/*!
 * enquire.min.js
 */
/*!
 * enquire.js v2.1.2 - Awesome Media Queries in JavaScript
 * Copyright (c) 2014 Nick Williams - http://wicky.nillia.ms/enquire.js
 * License: MIT (http://www.opensource.org/licenses/mit-license.php)
 */
!(function (e, t, n) {
  var i = window.matchMedia;
  "undefined" != typeof module && module.exports
    ? (module.exports = n(i))
    : "function" == typeof define && define.amd
    ? define(function () {
        return (t[e] = n(i));
      })
    : (t[e] = n(i));
})("enquire", this, function (e) {
  "use strict";
  function t(e, t) {
    var n,
      i = 0,
      o = e.length;
    for (i; o > i && ((n = t(e[i], i)), n !== !1); i++);
  }
  function n(e) {
    return "[object Array]" === Object.prototype.toString.apply(e);
  }
  function i(e) {
    return "function" == typeof e;
  }
  function o(e) {
    (this.options = e), !e.deferSetup && this.setup();
  }
  function r(t, n) {
    (this.query = t),
      (this.isUnconditional = n),
      (this.handlers = []),
      (this.mql = e(t));
    var i = this;
    (this.listener = function (e) {
      (i.mql = e), i.assess();
    }),
      this.mql.addListener(this.listener);
  }
  function s() {
    if (!e)
      throw new Error(
        "matchMedia not present, legacy browsers require a polyfill"
      );
    (this.queries = {}), (this.browserIsIncapable = !e("only all").matches);
  }
  return (
    (o.prototype = {
      setup: function () {
        this.options.setup && this.options.setup(), (this.initialised = !0);
      },
      on: function () {
        !this.initialised && this.setup(),
          this.options.match && this.options.match();
      },
      off: function () {
        this.options.unmatch && this.options.unmatch();
      },
      destroy: function () {
        this.options.destroy ? this.options.destroy() : this.off();
      },
      equals: function (e) {
        return this.options === e || this.options.match === e;
      },
    }),
    (r.prototype = {
      addHandler: function (e) {
        var t = new o(e);
        this.handlers.push(t), this.matches() && t.on();
      },
      removeHandler: function (e) {
        var n = this.handlers;
        t(n, function (t, i) {
          return t.equals(e) ? (t.destroy(), !n.splice(i, 1)) : void 0;
        });
      },
      matches: function () {
        return this.mql.matches || this.isUnconditional;
      },
      clear: function () {
        t(this.handlers, function (e) {
          e.destroy();
        }),
          this.mql.removeListener(this.listener),
          (this.handlers.length = 0);
      },
      assess: function () {
        var e = this.matches() ? "on" : "off";
        t(this.handlers, function (t) {
          t[e]();
        });
      },
    }),
    (s.prototype = {
      register: function (e, o, s) {
        var a = this.queries,
          l = s && this.browserIsIncapable;
        return (
          a[e] || (a[e] = new r(e, l)),
          i(o) && (o = { match: o }),
          n(o) || (o = [o]),
          t(o, function (t) {
            i(t) && (t = { match: t }), a[e].addHandler(t);
          }),
          this
        );
      },
      unregister: function (e, t) {
        var n = this.queries[e];
        return (
          n && (t ? n.removeHandler(t) : (n.clear(), delete this.queries[e])),
          this
        );
      },
    }),
    new s()
  );
})
/*!
 * jquery.min.js
 */,
  /*! jQuery v2.2.3 | (c) jQuery Foundation | jquery.org/license */
  !(function (e, t) {
    "object" == typeof module && "object" == typeof module.exports
      ? (module.exports = e.document
          ? t(e, !0)
          : function (e) {
              if (!e.document)
                throw new Error("jQuery requires a window with a document");
              return t(e);
            })
      : t(e);
  })("undefined" != typeof window ? window : this, function (e, t) {
    function n(e) {
      var t = !!e && "length" in e && e.length,
        n = re.type(e);
      return (
        "function" !== n &&
        !re.isWindow(e) &&
        ("array" === n ||
          0 === t ||
          ("number" == typeof t && t > 0 && t - 1 in e))
      );
    }
    function i(e, t, n) {
      if (re.isFunction(t))
        return re.grep(e, function (e, i) {
          return !!t.call(e, i, e) !== n;
        });
      if (t.nodeType)
        return re.grep(e, function (e) {
          return (e === t) !== n;
        });
      if ("string" == typeof t) {
        if (ve.test(t)) return re.filter(t, e, n);
        t = re.filter(t, e);
      }
      return re.grep(e, function (e) {
        return K.call(t, e) > -1 !== n;
      });
    }
    function o(e, t) {
      for (; (e = e[t]) && 1 !== e.nodeType; );
      return e;
    }
    function r(e) {
      var t = {};
      return (
        re.each(e.match(xe) || [], function (e, n) {
          t[n] = !0;
        }),
        t
      );
    }
    function s() {
      G.removeEventListener("DOMContentLoaded", s),
        e.removeEventListener("load", s),
        re.ready();
    }
    function a() {
      this.expando = re.expando + a.uid++;
    }
    function l(e, t, n) {
      var i;
      if (void 0 === n && 1 === e.nodeType)
        if (
          ((i = "data-" + t.replace(Ae, "-$&").toLowerCase()),
          (n = e.getAttribute(i)),
          "string" == typeof n)
        ) {
          try {
            n =
              "true" === n ||
              ("false" !== n &&
                ("null" === n
                  ? null
                  : +n + "" === n
                  ? +n
                  : Ee.test(n)
                  ? re.parseJSON(n)
                  : n));
          } catch (e) {}
          $e.set(e, t, n);
        } else n = void 0;
      return n;
    }
    function u(e, t, n, i) {
      var o,
        r = 1,
        s = 20,
        a = i
          ? function () {
              return i.cur();
            }
          : function () {
              return re.css(e, t, "");
            },
        l = a(),
        u = (n && n[3]) || (re.cssNumber[t] ? "" : "px"),
        c = (re.cssNumber[t] || ("px" !== u && +l)) && Ne.exec(re.css(e, t));
      if (c && c[3] !== u) {
        (u = u || c[3]), (n = n || []), (c = +l || 1);
        do (r = r || ".5"), (c /= r), re.style(e, t, c + u);
        while (r !== (r = a() / l) && 1 !== r && --s);
      }
      return (
        n &&
          ((c = +c || +l || 0),
          (o = n[1] ? c + (n[1] + 1) * n[2] : +n[2]),
          i && ((i.unit = u), (i.start = c), (i.end = o))),
        o
      );
    }
    function c(e, t) {
      var n =
        "undefined" != typeof e.getElementsByTagName
          ? e.getElementsByTagName(t || "*")
          : "undefined" != typeof e.querySelectorAll
          ? e.querySelectorAll(t || "*")
          : [];
      return void 0 === t || (t && re.nodeName(e, t)) ? re.merge([e], n) : n;
    }
    function d(e, t) {
      for (var n = 0, i = e.length; i > n; n++)
        Ce.set(e[n], "globalEval", !t || Ce.get(t[n], "globalEval"));
    }
    function p(e, t, n, i, o) {
      for (
        var r,
          s,
          a,
          l,
          u,
          p,
          f = t.createDocumentFragment(),
          h = [],
          v = 0,
          g = e.length;
        g > v;
        v++
      )
        if (((r = e[v]), r || 0 === r))
          if ("object" === re.type(r)) re.merge(h, r.nodeType ? [r] : r);
          else if (_e.test(r)) {
            for (
              s = s || f.appendChild(t.createElement("div")),
                a = (qe.exec(r) || ["", ""])[1].toLowerCase(),
                l = Le[a] || Le._default,
                s.innerHTML = l[1] + re.htmlPrefilter(r) + l[2],
                p = l[0];
              p--;

            )
              s = s.lastChild;
            re.merge(h, s.childNodes), (s = f.firstChild), (s.textContent = "");
          } else h.push(t.createTextNode(r));
      for (f.textContent = "", v = 0; (r = h[v++]); )
        if (i && re.inArray(r, i) > -1) o && o.push(r);
        else if (
          ((u = re.contains(r.ownerDocument, r)),
          (s = c(f.appendChild(r), "script")),
          u && d(s),
          n)
        )
          for (p = 0; (r = s[p++]); ) Pe.test(r.type || "") && n.push(r);
      return f;
    }
    function f() {
      return !0;
    }
    function h() {
      return !1;
    }
    function v() {
      try {
        return G.activeElement;
      } catch (e) {}
    }
    function g(e, t, n, i, o, r) {
      var s, a;
      if ("object" == typeof t) {
        "string" != typeof n && ((i = i || n), (n = void 0));
        for (a in t) g(e, a, n, i, t[a], r);
        return e;
      }
      if (
        (null == i && null == o
          ? ((o = n), (i = n = void 0))
          : null == o &&
            ("string" == typeof n
              ? ((o = i), (i = void 0))
              : ((o = i), (i = n), (n = void 0))),
        o === !1)
      )
        o = h;
      else if (!o) return e;
      return (
        1 === r &&
          ((s = o),
          (o = function (e) {
            return re().off(e), s.apply(this, arguments);
          }),
          (o.guid = s.guid || (s.guid = re.guid++))),
        e.each(function () {
          re.event.add(this, t, o, i, n);
        })
      );
    }
    function m(e, t) {
      return re.nodeName(e, "table") &&
        re.nodeName(11 !== t.nodeType ? t : t.firstChild, "tr")
        ? e.getElementsByTagName("tbody")[0] ||
            e.appendChild(e.ownerDocument.createElement("tbody"))
        : e;
    }
    function y(e) {
      return (e.type = (null !== e.getAttribute("type")) + "/" + e.type), e;
    }
    function b(e) {
      var t = Be.exec(e.type);
      return t ? (e.type = t[1]) : e.removeAttribute("type"), e;
    }
    function w(e, t) {
      var n, i, o, r, s, a, l, u;
      if (1 === t.nodeType) {
        if (
          Ce.hasData(e) &&
          ((r = Ce.access(e)), (s = Ce.set(t, r)), (u = r.events))
        ) {
          delete s.handle, (s.events = {});
          for (o in u)
            for (n = 0, i = u[o].length; i > n; n++)
              re.event.add(t, o, u[o][n]);
        }
        $e.hasData(e) &&
          ((a = $e.access(e)), (l = re.extend({}, a)), $e.set(t, l));
      }
    }
    function x(e, t) {
      var n = t.nodeName.toLowerCase();
      "input" === n && He.test(e.type)
        ? (t.checked = e.checked)
        : ("input" !== n && "textarea" !== n) ||
          (t.defaultValue = e.defaultValue);
    }
    function k(e, t, n, i) {
      t = J.apply([], t);
      var o,
        r,
        s,
        a,
        l,
        u,
        d = 0,
        f = e.length,
        h = f - 1,
        v = t[0],
        g = re.isFunction(v);
      if (g || (f > 1 && "string" == typeof v && !ie.checkClone && We.test(v)))
        return e.each(function (o) {
          var r = e.eq(o);
          g && (t[0] = v.call(this, o, r.html())), k(r, t, n, i);
        });
      if (
        f &&
        ((o = p(t, e[0].ownerDocument, !1, e, i)),
        (r = o.firstChild),
        1 === o.childNodes.length && (o = r),
        r || i)
      ) {
        for (s = re.map(c(o, "script"), y), a = s.length; f > d; d++)
          (l = o),
            d !== h &&
              ((l = re.clone(l, !0, !0)), a && re.merge(s, c(l, "script"))),
            n.call(e[d], l, d);
        if (a)
          for (
            u = s[s.length - 1].ownerDocument, re.map(s, b), d = 0;
            a > d;
            d++
          )
            (l = s[d]),
              Pe.test(l.type || "") &&
                !Ce.access(l, "globalEval") &&
                re.contains(u, l) &&
                (l.src
                  ? re._evalUrl && re._evalUrl(l.src)
                  : re.globalEval(l.textContent.replace(Ue, "")));
      }
      return e;
    }
    function T(e, t, n) {
      for (var i, o = t ? re.filter(t, e) : e, r = 0; null != (i = o[r]); r++)
        n || 1 !== i.nodeType || re.cleanData(c(i)),
          i.parentNode &&
            (n && re.contains(i.ownerDocument, i) && d(c(i, "script")),
            i.parentNode.removeChild(i));
      return e;
    }
    function S(e, t) {
      var n = re(t.createElement(e)).appendTo(t.body),
        i = re.css(n[0], "display");
      return n.detach(), i;
    }
    function C(e) {
      var t = G,
        n = Ye[e];
      return (
        n ||
          ((n = S(e, t)),
          ("none" !== n && n) ||
            ((Xe = (
              Xe || re("<iframe frameborder='0' width='0' height='0'/>")
            ).appendTo(t.documentElement)),
            (t = Xe[0].contentDocument),
            t.write(),
            t.close(),
            (n = S(e, t)),
            Xe.detach()),
          (Ye[e] = n)),
        n
      );
    }
    function $(e, t, n) {
      var i,
        o,
        r,
        s,
        a = e.style;
      return (
        (n = n || Qe(e)),
        (s = n ? n.getPropertyValue(t) || n[t] : void 0),
        ("" !== s && void 0 !== s) ||
          re.contains(e.ownerDocument, e) ||
          (s = re.style(e, t)),
        n &&
          !ie.pixelMarginRight() &&
          Ge.test(s) &&
          Ve.test(t) &&
          ((i = a.width),
          (o = a.minWidth),
          (r = a.maxWidth),
          (a.minWidth = a.maxWidth = a.width = s),
          (s = n.width),
          (a.width = i),
          (a.minWidth = o),
          (a.maxWidth = r)),
        void 0 !== s ? s + "" : s
      );
    }
    function E(e, t) {
      return {
        get: function () {
          return e()
            ? void delete this.get
            : (this.get = t).apply(this, arguments);
        },
      };
    }
    function A(e) {
      if (e in it) return e;
      for (var t = e[0].toUpperCase() + e.slice(1), n = nt.length; n--; )
        if (((e = nt[n] + t), e in it)) return e;
    }
    function j(e, t, n) {
      var i = Ne.exec(t);
      return i ? Math.max(0, i[2] - (n || 0)) + (i[3] || "px") : t;
    }
    function N(e, t, n, i, o) {
      for (
        var r = n === (i ? "border" : "content") ? 4 : "width" === t ? 1 : 0,
          s = 0;
        4 > r;
        r += 2
      )
        "margin" === n && (s += re.css(e, n + De[r], !0, o)),
          i
            ? ("content" === n && (s -= re.css(e, "padding" + De[r], !0, o)),
              "margin" !== n &&
                (s -= re.css(e, "border" + De[r] + "Width", !0, o)))
            : ((s += re.css(e, "padding" + De[r], !0, o)),
              "padding" !== n &&
                (s += re.css(e, "border" + De[r] + "Width", !0, o)));
      return s;
    }
    function D(t, n, i) {
      var o = !0,
        r = "width" === n ? t.offsetWidth : t.offsetHeight,
        s = Qe(t),
        a = "border-box" === re.css(t, "boxSizing", !1, s);
      if (
        (G.msFullscreenElement &&
          e.top !== e &&
          t.getClientRects().length &&
          (r = Math.round(100 * t.getBoundingClientRect()[n])),
        0 >= r || null == r)
      ) {
        if (
          ((r = $(t, n, s)),
          (0 > r || null == r) && (r = t.style[n]),
          Ge.test(r))
        )
          return r;
        (o = a && (ie.boxSizingReliable() || r === t.style[n])),
          (r = parseFloat(r) || 0);
      }
      return r + N(t, n, i || (a ? "border" : "content"), o, s) + "px";
    }
    function O(e, t) {
      for (var n, i, o, r = [], s = 0, a = e.length; a > s; s++)
        (i = e[s]),
          i.style &&
            ((r[s] = Ce.get(i, "olddisplay")),
            (n = i.style.display),
            t
              ? (r[s] || "none" !== n || (i.style.display = ""),
                "" === i.style.display &&
                  Oe(i) &&
                  (r[s] = Ce.access(i, "olddisplay", C(i.nodeName))))
              : ((o = Oe(i)),
                ("none" === n && o) ||
                  Ce.set(i, "olddisplay", o ? n : re.css(i, "display"))));
      for (s = 0; a > s; s++)
        (i = e[s]),
          i.style &&
            ((t && "none" !== i.style.display && "" !== i.style.display) ||
              (i.style.display = t ? r[s] || "" : "none"));
      return e;
    }
    function H(e, t, n, i, o) {
      return new H.prototype.init(e, t, n, i, o);
    }
    function q() {
      return (
        e.setTimeout(function () {
          ot = void 0;
        }),
        (ot = re.now())
      );
    }
    function P(e, t) {
      var n,
        i = 0,
        o = { height: e };
      for (t = t ? 1 : 0; 4 > i; i += 2 - t)
        (n = De[i]), (o["margin" + n] = o["padding" + n] = e);
      return t && (o.opacity = o.width = e), o;
    }
    function L(e, t, n) {
      for (
        var i,
          o = (I.tweeners[t] || []).concat(I.tweeners["*"]),
          r = 0,
          s = o.length;
        s > r;
        r++
      )
        if ((i = o[r].call(n, t, e))) return i;
    }
    function _(e, t, n) {
      var i,
        o,
        r,
        s,
        a,
        l,
        u,
        c,
        d = this,
        p = {},
        f = e.style,
        h = e.nodeType && Oe(e),
        v = Ce.get(e, "fxshow");
      n.queue ||
        ((a = re._queueHooks(e, "fx")),
        null == a.unqueued &&
          ((a.unqueued = 0),
          (l = a.empty.fire),
          (a.empty.fire = function () {
            a.unqueued || l();
          })),
        a.unqueued++,
        d.always(function () {
          d.always(function () {
            a.unqueued--, re.queue(e, "fx").length || a.empty.fire();
          });
        })),
        1 === e.nodeType &&
          ("height" in t || "width" in t) &&
          ((n.overflow = [f.overflow, f.overflowX, f.overflowY]),
          (u = re.css(e, "display")),
          (c = "none" === u ? Ce.get(e, "olddisplay") || C(e.nodeName) : u),
          "inline" === c &&
            "none" === re.css(e, "float") &&
            (f.display = "inline-block")),
        n.overflow &&
          ((f.overflow = "hidden"),
          d.always(function () {
            (f.overflow = n.overflow[0]),
              (f.overflowX = n.overflow[1]),
              (f.overflowY = n.overflow[2]);
          }));
      for (i in t)
        if (((o = t[i]), st.exec(o))) {
          if (
            (delete t[i],
            (r = r || "toggle" === o),
            o === (h ? "hide" : "show"))
          ) {
            if ("show" !== o || !v || void 0 === v[i]) continue;
            h = !0;
          }
          p[i] = (v && v[i]) || re.style(e, i);
        } else u = void 0;
      if (re.isEmptyObject(p))
        "inline" === ("none" === u ? C(e.nodeName) : u) && (f.display = u);
      else {
        v ? "hidden" in v && (h = v.hidden) : (v = Ce.access(e, "fxshow", {})),
          r && (v.hidden = !h),
          h
            ? re(e).show()
            : d.done(function () {
                re(e).hide();
              }),
          d.done(function () {
            var t;
            Ce.remove(e, "fxshow");
            for (t in p) re.style(e, t, p[t]);
          });
        for (i in p)
          (s = L(h ? v[i] : 0, i, d)),
            i in v ||
              ((v[i] = s.start),
              h &&
                ((s.end = s.start),
                (s.start = "width" === i || "height" === i ? 1 : 0)));
      }
    }
    function z(e, t) {
      var n, i, o, r, s;
      for (n in e)
        if (
          ((i = re.camelCase(n)),
          (o = t[i]),
          (r = e[n]),
          re.isArray(r) && ((o = r[1]), (r = e[n] = r[0])),
          n !== i && ((e[i] = r), delete e[n]),
          (s = re.cssHooks[i]),
          s && "expand" in s)
        ) {
          (r = s.expand(r)), delete e[i];
          for (n in r) n in e || ((e[n] = r[n]), (t[n] = o));
        } else t[i] = o;
    }
    function I(e, t, n) {
      var i,
        o,
        r = 0,
        s = I.prefilters.length,
        a = re.Deferred().always(function () {
          delete l.elem;
        }),
        l = function () {
          if (o) return !1;
          for (
            var t = ot || q(),
              n = Math.max(0, u.startTime + u.duration - t),
              i = n / u.duration || 0,
              r = 1 - i,
              s = 0,
              l = u.tweens.length;
            l > s;
            s++
          )
            u.tweens[s].run(r);
          return (
            a.notifyWith(e, [u, r, n]),
            1 > r && l ? n : (a.resolveWith(e, [u]), !1)
          );
        },
        u = a.promise({
          elem: e,
          props: re.extend({}, t),
          opts: re.extend(
            !0,
            { specialEasing: {}, easing: re.easing._default },
            n
          ),
          originalProperties: t,
          originalOptions: n,
          startTime: ot || q(),
          duration: n.duration,
          tweens: [],
          createTween: function (t, n) {
            var i = re.Tween(
              e,
              u.opts,
              t,
              n,
              u.opts.specialEasing[t] || u.opts.easing
            );
            return u.tweens.push(i), i;
          },
          stop: function (t) {
            var n = 0,
              i = t ? u.tweens.length : 0;
            if (o) return this;
            for (o = !0; i > n; n++) u.tweens[n].run(1);
            return (
              t
                ? (a.notifyWith(e, [u, 1, 0]), a.resolveWith(e, [u, t]))
                : a.rejectWith(e, [u, t]),
              this
            );
          },
        }),
        c = u.props;
      for (z(c, u.opts.specialEasing); s > r; r++)
        if ((i = I.prefilters[r].call(u, e, c, u.opts)))
          return (
            re.isFunction(i.stop) &&
              (re._queueHooks(u.elem, u.opts.queue).stop = re.proxy(i.stop, i)),
            i
          );
      return (
        re.map(c, L, u),
        re.isFunction(u.opts.start) && u.opts.start.call(e, u),
        re.fx.timer(re.extend(l, { elem: e, anim: u, queue: u.opts.queue })),
        u
          .progress(u.opts.progress)
          .done(u.opts.done, u.opts.complete)
          .fail(u.opts.fail)
          .always(u.opts.always)
      );
    }
    function F(e) {
      return (e.getAttribute && e.getAttribute("class")) || "";
    }
    function M(e) {
      return function (t, n) {
        "string" != typeof t && ((n = t), (t = "*"));
        var i,
          o = 0,
          r = t.toLowerCase().match(xe) || [];
        if (re.isFunction(n))
          for (; (i = r[o++]); )
            "+" === i[0]
              ? ((i = i.slice(1) || "*"), (e[i] = e[i] || []).unshift(n))
              : (e[i] = e[i] || []).push(n);
      };
    }
    function R(e, t, n, i) {
      function o(a) {
        var l;
        return (
          (r[a] = !0),
          re.each(e[a] || [], function (e, a) {
            var u = a(t, n, i);
            return "string" != typeof u || s || r[u]
              ? s
                ? !(l = u)
                : void 0
              : (t.dataTypes.unshift(u), o(u), !1);
          }),
          l
        );
      }
      var r = {},
        s = e === $t;
      return o(t.dataTypes[0]) || (!r["*"] && o("*"));
    }
    function W(e, t) {
      var n,
        i,
        o = re.ajaxSettings.flatOptions || {};
      for (n in t) void 0 !== t[n] && ((o[n] ? e : i || (i = {}))[n] = t[n]);
      return i && re.extend(!0, e, i), e;
    }
    function B(e, t, n) {
      for (var i, o, r, s, a = e.contents, l = e.dataTypes; "*" === l[0]; )
        l.shift(),
          void 0 === i &&
            (i = e.mimeType || t.getResponseHeader("Content-Type"));
      if (i)
        for (o in a)
          if (a[o] && a[o].test(i)) {
            l.unshift(o);
            break;
          }
      if (l[0] in n) r = l[0];
      else {
        for (o in n) {
          if (!l[0] || e.converters[o + " " + l[0]]) {
            r = o;
            break;
          }
          s || (s = o);
        }
        r = r || s;
      }
      return r ? (r !== l[0] && l.unshift(r), n[r]) : void 0;
    }
    function U(e, t, n, i) {
      var o,
        r,
        s,
        a,
        l,
        u = {},
        c = e.dataTypes.slice();
      if (c[1]) for (s in e.converters) u[s.toLowerCase()] = e.converters[s];
      for (r = c.shift(); r; )
        if (
          (e.responseFields[r] && (n[e.responseFields[r]] = t),
          !l && i && e.dataFilter && (t = e.dataFilter(t, e.dataType)),
          (l = r),
          (r = c.shift()))
        )
          if ("*" === r) r = l;
          else if ("*" !== l && l !== r) {
            if (((s = u[l + " " + r] || u["* " + r]), !s))
              for (o in u)
                if (
                  ((a = o.split(" ")),
                  a[1] === r && (s = u[l + " " + a[0]] || u["* " + a[0]]))
                ) {
                  s === !0
                    ? (s = u[o])
                    : u[o] !== !0 && ((r = a[0]), c.unshift(a[1]));
                  break;
                }
            if (s !== !0)
              if (s && e.throws) t = s(t);
              else
                try {
                  t = s(t);
                } catch (e) {
                  return {
                    state: "parsererror",
                    error: s ? e : "No conversion from " + l + " to " + r,
                  };
                }
          }
      return { state: "success", data: t };
    }
    function X(e, t, n, i) {
      var o;
      if (re.isArray(t))
        re.each(t, function (t, o) {
          n || Nt.test(e)
            ? i(e, o)
            : X(
                e + "[" + ("object" == typeof o && null != o ? t : "") + "]",
                o,
                n,
                i
              );
        });
      else if (n || "object" !== re.type(t)) i(e, t);
      else for (o in t) X(e + "[" + o + "]", t[o], n, i);
    }
    function Y(e) {
      return re.isWindow(e) ? e : 9 === e.nodeType && e.defaultView;
    }
    var V = [],
      G = e.document,
      Q = V.slice,
      J = V.concat,
      Z = V.push,
      K = V.indexOf,
      ee = {},
      te = ee.toString,
      ne = ee.hasOwnProperty,
      ie = {},
      oe = "2.2.3",
      re = function (e, t) {
        return new re.fn.init(e, t);
      },
      se = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
      ae = /^-ms-/,
      le = /-([\da-z])/gi,
      ue = function (e, t) {
        return t.toUpperCase();
      };
    (re.fn = re.prototype = {
      jquery: oe,
      constructor: re,
      selector: "",
      length: 0,
      toArray: function () {
        return Q.call(this);
      },
      get: function (e) {
        return null != e
          ? 0 > e
            ? this[e + this.length]
            : this[e]
          : Q.call(this);
      },
      pushStack: function (e) {
        var t = re.merge(this.constructor(), e);
        return (t.prevObject = this), (t.context = this.context), t;
      },
      each: function (e) {
        return re.each(this, e);
      },
      map: function (e) {
        return this.pushStack(
          re.map(this, function (t, n) {
            return e.call(t, n, t);
          })
        );
      },
      slice: function () {
        return this.pushStack(Q.apply(this, arguments));
      },
      first: function () {
        return this.eq(0);
      },
      last: function () {
        return this.eq(-1);
      },
      eq: function (e) {
        var t = this.length,
          n = +e + (0 > e ? t : 0);
        return this.pushStack(n >= 0 && t > n ? [this[n]] : []);
      },
      end: function () {
        return this.prevObject || this.constructor();
      },
      push: Z,
      sort: V.sort,
      splice: V.splice,
    }),
      (re.extend = re.fn.extend = function () {
        var e,
          t,
          n,
          i,
          o,
          r,
          s = arguments[0] || {},
          a = 1,
          l = arguments.length,
          u = !1;
        for (
          "boolean" == typeof s && ((u = s), (s = arguments[a] || {}), a++),
            "object" == typeof s || re.isFunction(s) || (s = {}),
            a === l && ((s = this), a--);
          l > a;
          a++
        )
          if (null != (e = arguments[a]))
            for (t in e)
              (n = s[t]),
                (i = e[t]),
                s !== i &&
                  (u && i && (re.isPlainObject(i) || (o = re.isArray(i)))
                    ? (o
                        ? ((o = !1), (r = n && re.isArray(n) ? n : []))
                        : (r = n && re.isPlainObject(n) ? n : {}),
                      (s[t] = re.extend(u, r, i)))
                    : void 0 !== i && (s[t] = i));
        return s;
      }),
      re.extend({
        expando: "jQuery" + (oe + Math.random()).replace(/\D/g, ""),
        isReady: !0,
        error: function (e) {
          throw new Error(e);
        },
        noop: function () {},
        isFunction: function (e) {
          return "function" === re.type(e);
        },
        isArray: Array.isArray,
        isWindow: function (e) {
          return null != e && e === e.window;
        },
        isNumeric: function (e) {
          var t = e && e.toString();
          return !re.isArray(e) && t - parseFloat(t) + 1 >= 0;
        },
        isPlainObject: function (e) {
          var t;
          if ("object" !== re.type(e) || e.nodeType || re.isWindow(e))
            return !1;
          if (
            e.constructor &&
            !ne.call(e, "constructor") &&
            !ne.call(e.constructor.prototype || {}, "isPrototypeOf")
          )
            return !1;
          for (t in e);
          return void 0 === t || ne.call(e, t);
        },
        isEmptyObject: function (e) {
          var t;
          for (t in e) return !1;
          return !0;
        },
        type: function (e) {
          return null == e
            ? e + ""
            : "object" == typeof e || "function" == typeof e
            ? ee[te.call(e)] || "object"
            : typeof e;
        },
        globalEval: function (e) {
          var t,
            n = eval;
          (e = re.trim(e)),
            e &&
              (1 === e.indexOf("use strict")
                ? ((t = G.createElement("script")),
                  (t.text = e),
                  G.head.appendChild(t).parentNode.removeChild(t))
                : n(e));
        },
        camelCase: function (e) {
          return e.replace(ae, "ms-").replace(le, ue);
        },
        nodeName: function (e, t) {
          return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
        },
        each: function (e, t) {
          var i,
            o = 0;
          if (n(e))
            for (i = e.length; i > o && t.call(e[o], o, e[o]) !== !1; o++);
          else for (o in e) if (t.call(e[o], o, e[o]) === !1) break;
          return e;
        },
        trim: function (e) {
          return null == e ? "" : (e + "").replace(se, "");
        },
        makeArray: function (e, t) {
          var i = t || [];
          return (
            null != e &&
              (n(Object(e))
                ? re.merge(i, "string" == typeof e ? [e] : e)
                : Z.call(i, e)),
            i
          );
        },
        inArray: function (e, t, n) {
          return null == t ? -1 : K.call(t, e, n);
        },
        merge: function (e, t) {
          for (var n = +t.length, i = 0, o = e.length; n > i; i++)
            e[o++] = t[i];
          return (e.length = o), e;
        },
        grep: function (e, t, n) {
          for (var i, o = [], r = 0, s = e.length, a = !n; s > r; r++)
            (i = !t(e[r], r)), i !== a && o.push(e[r]);
          return o;
        },
        map: function (e, t, i) {
          var o,
            r,
            s = 0,
            a = [];
          if (n(e))
            for (o = e.length; o > s; s++)
              (r = t(e[s], s, i)), null != r && a.push(r);
          else for (s in e) (r = t(e[s], s, i)), null != r && a.push(r);
          return J.apply([], a);
        },
        guid: 1,
        proxy: function (e, t) {
          var n, i, o;
          return (
            "string" == typeof t && ((n = e[t]), (t = e), (e = n)),
            re.isFunction(e)
              ? ((i = Q.call(arguments, 2)),
                (o = function () {
                  return e.apply(t || this, i.concat(Q.call(arguments)));
                }),
                (o.guid = e.guid = e.guid || re.guid++),
                o)
              : void 0
          );
        },
        now: Date.now,
        support: ie,
      }),
      "function" == typeof Symbol &&
        (re.fn[Symbol.iterator] = V[Symbol.iterator]),
      re.each(
        "Boolean Number String Function Array Date RegExp Object Error Symbol".split(
          " "
        ),
        function (e, t) {
          ee["[object " + t + "]"] = t.toLowerCase();
        }
      );
    var ce = (function (e) {
      function t(e, t, n, i) {
        var o,
          r,
          s,
          a,
          l,
          u,
          d,
          f,
          h = t && t.ownerDocument,
          v = t ? t.nodeType : 9;
        if (
          ((n = n || []),
          "string" != typeof e || !e || (1 !== v && 9 !== v && 11 !== v))
        )
          return n;
        if (
          !i &&
          ((t ? t.ownerDocument || t : F) !== O && D(t), (t = t || O), q)
        ) {
          if (11 !== v && (u = me.exec(e)))
            if ((o = u[1])) {
              if (9 === v) {
                if (!(s = t.getElementById(o))) return n;
                if (s.id === o) return n.push(s), n;
              } else if (
                h &&
                (s = h.getElementById(o)) &&
                z(t, s) &&
                s.id === o
              )
                return n.push(s), n;
            } else {
              if (u[2]) return Z.apply(n, t.getElementsByTagName(e)), n;
              if (
                (o = u[3]) &&
                x.getElementsByClassName &&
                t.getElementsByClassName
              )
                return Z.apply(n, t.getElementsByClassName(o)), n;
            }
          if (x.qsa && !U[e + " "] && (!P || !P.test(e))) {
            if (1 !== v) (h = t), (f = e);
            else if ("object" !== t.nodeName.toLowerCase()) {
              for (
                (a = t.getAttribute("id"))
                  ? (a = a.replace(be, "\\$&"))
                  : t.setAttribute("id", (a = I)),
                  d = C(e),
                  r = d.length,
                  l = pe.test(a) ? "#" + a : "[id='" + a + "']";
                r--;

              )
                d[r] = l + " " + p(d[r]);
              (f = d.join(",")), (h = (ye.test(e) && c(t.parentNode)) || t);
            }
            if (f)
              try {
                return Z.apply(n, h.querySelectorAll(f)), n;
              } catch (e) {
              } finally {
                a === I && t.removeAttribute("id");
              }
          }
        }
        return E(e.replace(ae, "$1"), t, n, i);
      }
      function n() {
        function e(n, i) {
          return (
            t.push(n + " ") > k.cacheLength && delete e[t.shift()],
            (e[n + " "] = i)
          );
        }
        var t = [];
        return e;
      }
      function i(e) {
        return (e[I] = !0), e;
      }
      function o(e) {
        var t = O.createElement("div");
        try {
          return !!e(t);
        } catch (e) {
          return !1;
        } finally {
          t.parentNode && t.parentNode.removeChild(t), (t = null);
        }
      }
      function r(e, t) {
        for (var n = e.split("|"), i = n.length; i--; ) k.attrHandle[n[i]] = t;
      }
      function s(e, t) {
        var n = t && e,
          i =
            n &&
            1 === e.nodeType &&
            1 === t.nodeType &&
            (~t.sourceIndex || Y) - (~e.sourceIndex || Y);
        if (i) return i;
        if (n) for (; (n = n.nextSibling); ) if (n === t) return -1;
        return e ? 1 : -1;
      }
      function a(e) {
        return function (t) {
          var n = t.nodeName.toLowerCase();
          return "input" === n && t.type === e;
        };
      }
      function l(e) {
        return function (t) {
          var n = t.nodeName.toLowerCase();
          return ("input" === n || "button" === n) && t.type === e;
        };
      }
      function u(e) {
        return i(function (t) {
          return (
            (t = +t),
            i(function (n, i) {
              for (var o, r = e([], n.length, t), s = r.length; s--; )
                n[(o = r[s])] && (n[o] = !(i[o] = n[o]));
            })
          );
        });
      }
      function c(e) {
        return e && "undefined" != typeof e.getElementsByTagName && e;
      }
      function d() {}
      function p(e) {
        for (var t = 0, n = e.length, i = ""; n > t; t++) i += e[t].value;
        return i;
      }
      function f(e, t, n) {
        var i = t.dir,
          o = n && "parentNode" === i,
          r = R++;
        return t.first
          ? function (t, n, r) {
              for (; (t = t[i]); ) if (1 === t.nodeType || o) return e(t, n, r);
            }
          : function (t, n, s) {
              var a,
                l,
                u,
                c = [M, r];
              if (s) {
                for (; (t = t[i]); )
                  if ((1 === t.nodeType || o) && e(t, n, s)) return !0;
              } else
                for (; (t = t[i]); )
                  if (1 === t.nodeType || o) {
                    if (
                      ((u = t[I] || (t[I] = {})),
                      (l = u[t.uniqueID] || (u[t.uniqueID] = {})),
                      (a = l[i]) && a[0] === M && a[1] === r)
                    )
                      return (c[2] = a[2]);
                    if (((l[i] = c), (c[2] = e(t, n, s)))) return !0;
                  }
            };
      }
      function h(e) {
        return e.length > 1
          ? function (t, n, i) {
              for (var o = e.length; o--; ) if (!e[o](t, n, i)) return !1;
              return !0;
            }
          : e[0];
      }
      function v(e, n, i) {
        for (var o = 0, r = n.length; r > o; o++) t(e, n[o], i);
        return i;
      }
      function g(e, t, n, i, o) {
        for (var r, s = [], a = 0, l = e.length, u = null != t; l > a; a++)
          (r = e[a]) && ((n && !n(r, i, o)) || (s.push(r), u && t.push(a)));
        return s;
      }
      function m(e, t, n, o, r, s) {
        return (
          o && !o[I] && (o = m(o)),
          r && !r[I] && (r = m(r, s)),
          i(function (i, s, a, l) {
            var u,
              c,
              d,
              p = [],
              f = [],
              h = s.length,
              m = i || v(t || "*", a.nodeType ? [a] : a, []),
              y = !e || (!i && t) ? m : g(m, p, e, a, l),
              b = n ? (r || (i ? e : h || o) ? [] : s) : y;
            if ((n && n(y, b, a, l), o))
              for (u = g(b, f), o(u, [], a, l), c = u.length; c--; )
                (d = u[c]) && (b[f[c]] = !(y[f[c]] = d));
            if (i) {
              if (r || e) {
                if (r) {
                  for (u = [], c = b.length; c--; )
                    (d = b[c]) && u.push((y[c] = d));
                  r(null, (b = []), u, l);
                }
                for (c = b.length; c--; )
                  (d = b[c]) &&
                    (u = r ? ee(i, d) : p[c]) > -1 &&
                    (i[u] = !(s[u] = d));
              }
            } else (b = g(b === s ? b.splice(h, b.length) : b)), r ? r(null, s, b, l) : Z.apply(s, b);
          })
        );
      }
      function y(e) {
        for (
          var t,
            n,
            i,
            o = e.length,
            r = k.relative[e[0].type],
            s = r || k.relative[" "],
            a = r ? 1 : 0,
            l = f(
              function (e) {
                return e === t;
              },
              s,
              !0
            ),
            u = f(
              function (e) {
                return ee(t, e) > -1;
              },
              s,
              !0
            ),
            c = [
              function (e, n, i) {
                var o =
                  (!r && (i || n !== A)) ||
                  ((t = n).nodeType ? l(e, n, i) : u(e, n, i));
                return (t = null), o;
              },
            ];
          o > a;
          a++
        )
          if ((n = k.relative[e[a].type])) c = [f(h(c), n)];
          else {
            if (((n = k.filter[e[a].type].apply(null, e[a].matches)), n[I])) {
              for (i = ++a; o > i && !k.relative[e[i].type]; i++);
              return m(
                a > 1 && h(c),
                a > 1 &&
                  p(
                    e
                      .slice(0, a - 1)
                      .concat({ value: " " === e[a - 2].type ? "*" : "" })
                  ).replace(ae, "$1"),
                n,
                i > a && y(e.slice(a, i)),
                o > i && y((e = e.slice(i))),
                o > i && p(e)
              );
            }
            c.push(n);
          }
        return h(c);
      }
      function b(e, n) {
        var o = n.length > 0,
          r = e.length > 0,
          s = function (i, s, a, l, u) {
            var c,
              d,
              p,
              f = 0,
              h = "0",
              v = i && [],
              m = [],
              y = A,
              b = i || (r && k.find.TAG("*", u)),
              w = (M += null == y ? 1 : Math.random() || 0.1),
              x = b.length;
            for (
              u && (A = s === O || s || u);
              h !== x && null != (c = b[h]);
              h++
            ) {
              if (r && c) {
                for (
                  d = 0, s || c.ownerDocument === O || (D(c), (a = !q));
                  (p = e[d++]);

                )
                  if (p(c, s || O, a)) {
                    l.push(c);
                    break;
                  }
                u && (M = w);
              }
              o && ((c = !p && c) && f--, i && v.push(c));
            }
            if (((f += h), o && h !== f)) {
              for (d = 0; (p = n[d++]); ) p(v, m, s, a);
              if (i) {
                if (f > 0) for (; h--; ) v[h] || m[h] || (m[h] = Q.call(l));
                m = g(m);
              }
              Z.apply(l, m),
                u && !i && m.length > 0 && f + n.length > 1 && t.uniqueSort(l);
            }
            return u && ((M = w), (A = y)), v;
          };
        return o ? i(s) : s;
      }
      var w,
        x,
        k,
        T,
        S,
        C,
        $,
        E,
        A,
        j,
        N,
        D,
        O,
        H,
        q,
        P,
        L,
        _,
        z,
        I = "sizzle" + 1 * new Date(),
        F = e.document,
        M = 0,
        R = 0,
        W = n(),
        B = n(),
        U = n(),
        X = function (e, t) {
          return e === t && (N = !0), 0;
        },
        Y = 1 << 31,
        V = {}.hasOwnProperty,
        G = [],
        Q = G.pop,
        J = G.push,
        Z = G.push,
        K = G.slice,
        ee = function (e, t) {
          for (var n = 0, i = e.length; i > n; n++) if (e[n] === t) return n;
          return -1;
        },
        te =
          "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
        ne = "[\\x20\\t\\r\\n\\f]",
        ie = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
        oe =
          "\\[" +
          ne +
          "*(" +
          ie +
          ")(?:" +
          ne +
          "*([*^$|!~]?=)" +
          ne +
          "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" +
          ie +
          "))|)" +
          ne +
          "*\\]",
        re =
          ":(" +
          ie +
          ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" +
          oe +
          ")*)|.*)\\)|)",
        se = new RegExp(ne + "+", "g"),
        ae = new RegExp(
          "^" + ne + "+|((?:^|[^\\\\])(?:\\\\.)*)" + ne + "+$",
          "g"
        ),
        le = new RegExp("^" + ne + "*," + ne + "*"),
        ue = new RegExp("^" + ne + "*([>+~]|" + ne + ")" + ne + "*"),
        ce = new RegExp("=" + ne + "*([^\\]'\"]*?)" + ne + "*\\]", "g"),
        de = new RegExp(re),
        pe = new RegExp("^" + ie + "$"),
        fe = {
          ID: new RegExp("^#(" + ie + ")"),
          CLASS: new RegExp("^\\.(" + ie + ")"),
          TAG: new RegExp("^(" + ie + "|[*])"),
          ATTR: new RegExp("^" + oe),
          PSEUDO: new RegExp("^" + re),
          CHILD: new RegExp(
            "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
              ne +
              "*(even|odd|(([+-]|)(\\d*)n|)" +
              ne +
              "*(?:([+-]|)" +
              ne +
              "*(\\d+)|))" +
              ne +
              "*\\)|)",
            "i"
          ),
          bool: new RegExp("^(?:" + te + ")$", "i"),
          needsContext: new RegExp(
            "^" +
              ne +
              "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
              ne +
              "*((?:-\\d)?\\d*)" +
              ne +
              "*\\)|)(?=[^-]|$)",
            "i"
          ),
        },
        he = /^(?:input|select|textarea|button)$/i,
        ve = /^h\d$/i,
        ge = /^[^{]+\{\s*\[native \w/,
        me = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
        ye = /[+~]/,
        be = /'|\\/g,
        we = new RegExp("\\\\([\\da-f]{1,6}" + ne + "?|(" + ne + ")|.)", "ig"),
        xe = function (e, t, n) {
          var i = "0x" + t - 65536;
          return i !== i || n
            ? t
            : 0 > i
            ? String.fromCharCode(i + 65536)
            : String.fromCharCode((i >> 10) | 55296, (1023 & i) | 56320);
        },
        ke = function () {
          D();
        };
      try {
        Z.apply((G = K.call(F.childNodes)), F.childNodes),
          G[F.childNodes.length].nodeType;
      } catch (e) {
        Z = {
          apply: G.length
            ? function (e, t) {
                J.apply(e, K.call(t));
              }
            : function (e, t) {
                for (var n = e.length, i = 0; (e[n++] = t[i++]); );
                e.length = n - 1;
              },
        };
      }
      (x = t.support = {}),
        (S = t.isXML = function (e) {
          var t = e && (e.ownerDocument || e).documentElement;
          return !!t && "HTML" !== t.nodeName;
        }),
        (D = t.setDocument = function (e) {
          var t,
            n,
            i = e ? e.ownerDocument || e : F;
          return i !== O && 9 === i.nodeType && i.documentElement
            ? ((O = i),
              (H = O.documentElement),
              (q = !S(O)),
              (n = O.defaultView) &&
                n.top !== n &&
                (n.addEventListener
                  ? n.addEventListener("unload", ke, !1)
                  : n.attachEvent && n.attachEvent("onunload", ke)),
              (x.attributes = o(function (e) {
                return (e.className = "i"), !e.getAttribute("className");
              })),
              (x.getElementsByTagName = o(function (e) {
                return (
                  e.appendChild(O.createComment("")),
                  !e.getElementsByTagName("*").length
                );
              })),
              (x.getElementsByClassName = ge.test(O.getElementsByClassName)),
              (x.getById = o(function (e) {
                return (
                  (H.appendChild(e).id = I),
                  !O.getElementsByName || !O.getElementsByName(I).length
                );
              })),
              x.getById
                ? ((k.find.ID = function (e, t) {
                    if ("undefined" != typeof t.getElementById && q) {
                      var n = t.getElementById(e);
                      return n ? [n] : [];
                    }
                  }),
                  (k.filter.ID = function (e) {
                    var t = e.replace(we, xe);
                    return function (e) {
                      return e.getAttribute("id") === t;
                    };
                  }))
                : (delete k.find.ID,
                  (k.filter.ID = function (e) {
                    var t = e.replace(we, xe);
                    return function (e) {
                      var n =
                        "undefined" != typeof e.getAttributeNode &&
                        e.getAttributeNode("id");
                      return n && n.value === t;
                    };
                  })),
              (k.find.TAG = x.getElementsByTagName
                ? function (e, t) {
                    return "undefined" != typeof t.getElementsByTagName
                      ? t.getElementsByTagName(e)
                      : x.qsa
                      ? t.querySelectorAll(e)
                      : void 0;
                  }
                : function (e, t) {
                    var n,
                      i = [],
                      o = 0,
                      r = t.getElementsByTagName(e);
                    if ("*" === e) {
                      for (; (n = r[o++]); ) 1 === n.nodeType && i.push(n);
                      return i;
                    }
                    return r;
                  }),
              (k.find.CLASS =
                x.getElementsByClassName &&
                function (e, t) {
                  return "undefined" != typeof t.getElementsByClassName && q
                    ? t.getElementsByClassName(e)
                    : void 0;
                }),
              (L = []),
              (P = []),
              (x.qsa = ge.test(O.querySelectorAll)) &&
                (o(function (e) {
                  (H.appendChild(e).innerHTML =
                    "<a id='" +
                    I +
                    "'></a><select id='" +
                    I +
                    "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                    e.querySelectorAll("[msallowcapture^='']").length &&
                      P.push("[*^$]=" + ne + "*(?:''|\"\")"),
                    e.querySelectorAll("[selected]").length ||
                      P.push("\\[" + ne + "*(?:value|" + te + ")"),
                    e.querySelectorAll("[id~=" + I + "-]").length ||
                      P.push("~="),
                    e.querySelectorAll(":checked").length || P.push(":checked"),
                    e.querySelectorAll("a#" + I + "+*").length ||
                      P.push(".#.+[+~]");
                }),
                o(function (e) {
                  var t = O.createElement("input");
                  t.setAttribute("type", "hidden"),
                    e.appendChild(t).setAttribute("name", "D"),
                    e.querySelectorAll("[name=d]").length &&
                      P.push("name" + ne + "*[*^$|!~]?="),
                    e.querySelectorAll(":enabled").length ||
                      P.push(":enabled", ":disabled"),
                    e.querySelectorAll("*,:x"),
                    P.push(",.*:");
                })),
              (x.matchesSelector = ge.test(
                (_ =
                  H.matches ||
                  H.webkitMatchesSelector ||
                  H.mozMatchesSelector ||
                  H.oMatchesSelector ||
                  H.msMatchesSelector)
              )) &&
                o(function (e) {
                  (x.disconnectedMatch = _.call(e, "div")),
                    _.call(e, "[s!='']:x"),
                    L.push("!=", re);
                }),
              (P = P.length && new RegExp(P.join("|"))),
              (L = L.length && new RegExp(L.join("|"))),
              (t = ge.test(H.compareDocumentPosition)),
              (z =
                t || ge.test(H.contains)
                  ? function (e, t) {
                      var n = 9 === e.nodeType ? e.documentElement : e,
                        i = t && t.parentNode;
                      return (
                        e === i ||
                        !(
                          !i ||
                          1 !== i.nodeType ||
                          !(n.contains
                            ? n.contains(i)
                            : e.compareDocumentPosition &&
                              16 & e.compareDocumentPosition(i))
                        )
                      );
                    }
                  : function (e, t) {
                      if (t)
                        for (; (t = t.parentNode); ) if (t === e) return !0;
                      return !1;
                    }),
              (X = t
                ? function (e, t) {
                    if (e === t) return (N = !0), 0;
                    var n =
                      !e.compareDocumentPosition - !t.compareDocumentPosition;
                    return n
                      ? n
                      : ((n =
                          (e.ownerDocument || e) === (t.ownerDocument || t)
                            ? e.compareDocumentPosition(t)
                            : 1),
                        1 & n ||
                        (!x.sortDetached && t.compareDocumentPosition(e) === n)
                          ? e === O || (e.ownerDocument === F && z(F, e))
                            ? -1
                            : t === O || (t.ownerDocument === F && z(F, t))
                            ? 1
                            : j
                            ? ee(j, e) - ee(j, t)
                            : 0
                          : 4 & n
                          ? -1
                          : 1);
                  }
                : function (e, t) {
                    if (e === t) return (N = !0), 0;
                    var n,
                      i = 0,
                      o = e.parentNode,
                      r = t.parentNode,
                      a = [e],
                      l = [t];
                    if (!o || !r)
                      return e === O
                        ? -1
                        : t === O
                        ? 1
                        : o
                        ? -1
                        : r
                        ? 1
                        : j
                        ? ee(j, e) - ee(j, t)
                        : 0;
                    if (o === r) return s(e, t);
                    for (n = e; (n = n.parentNode); ) a.unshift(n);
                    for (n = t; (n = n.parentNode); ) l.unshift(n);
                    for (; a[i] === l[i]; ) i++;
                    return i
                      ? s(a[i], l[i])
                      : a[i] === F
                      ? -1
                      : l[i] === F
                      ? 1
                      : 0;
                  }),
              O)
            : O;
        }),
        (t.matches = function (e, n) {
          return t(e, null, null, n);
        }),
        (t.matchesSelector = function (e, n) {
          if (
            ((e.ownerDocument || e) !== O && D(e),
            (n = n.replace(ce, "='$1']")),
            x.matchesSelector &&
              q &&
              !U[n + " "] &&
              (!L || !L.test(n)) &&
              (!P || !P.test(n)))
          )
            try {
              var i = _.call(e, n);
              if (
                i ||
                x.disconnectedMatch ||
                (e.document && 11 !== e.document.nodeType)
              )
                return i;
            } catch (e) {}
          return t(n, O, null, [e]).length > 0;
        }),
        (t.contains = function (e, t) {
          return (e.ownerDocument || e) !== O && D(e), z(e, t);
        }),
        (t.attr = function (e, t) {
          (e.ownerDocument || e) !== O && D(e);
          var n = k.attrHandle[t.toLowerCase()],
            i =
              n && V.call(k.attrHandle, t.toLowerCase()) ? n(e, t, !q) : void 0;
          return void 0 !== i
            ? i
            : x.attributes || !q
            ? e.getAttribute(t)
            : (i = e.getAttributeNode(t)) && i.specified
            ? i.value
            : null;
        }),
        (t.error = function (e) {
          throw new Error("Syntax error, unrecognized expression: " + e);
        }),
        (t.uniqueSort = function (e) {
          var t,
            n = [],
            i = 0,
            o = 0;
          if (
            ((N = !x.detectDuplicates),
            (j = !x.sortStable && e.slice(0)),
            e.sort(X),
            N)
          ) {
            for (; (t = e[o++]); ) t === e[o] && (i = n.push(o));
            for (; i--; ) e.splice(n[i], 1);
          }
          return (j = null), e;
        }),
        (T = t.getText = function (e) {
          var t,
            n = "",
            i = 0,
            o = e.nodeType;
          if (o) {
            if (1 === o || 9 === o || 11 === o) {
              if ("string" == typeof e.textContent) return e.textContent;
              for (e = e.firstChild; e; e = e.nextSibling) n += T(e);
            } else if (3 === o || 4 === o) return e.nodeValue;
          } else for (; (t = e[i++]); ) n += T(t);
          return n;
        }),
        (k = t.selectors = {
          cacheLength: 50,
          createPseudo: i,
          match: fe,
          attrHandle: {},
          find: {},
          relative: {
            ">": { dir: "parentNode", first: !0 },
            " ": { dir: "parentNode" },
            "+": { dir: "previousSibling", first: !0 },
            "~": { dir: "previousSibling" },
          },
          preFilter: {
            ATTR: function (e) {
              return (
                (e[1] = e[1].replace(we, xe)),
                (e[3] = (e[3] || e[4] || e[5] || "").replace(we, xe)),
                "~=" === e[2] && (e[3] = " " + e[3] + " "),
                e.slice(0, 4)
              );
            },
            CHILD: function (e) {
              return (
                (e[1] = e[1].toLowerCase()),
                "nth" === e[1].slice(0, 3)
                  ? (e[3] || t.error(e[0]),
                    (e[4] = +(e[4]
                      ? e[5] + (e[6] || 1)
                      : 2 * ("even" === e[3] || "odd" === e[3]))),
                    (e[5] = +(e[7] + e[8] || "odd" === e[3])))
                  : e[3] && t.error(e[0]),
                e
              );
            },
            PSEUDO: function (e) {
              var t,
                n = !e[6] && e[2];
              return fe.CHILD.test(e[0])
                ? null
                : (e[3]
                    ? (e[2] = e[4] || e[5] || "")
                    : n &&
                      de.test(n) &&
                      (t = C(n, !0)) &&
                      (t = n.indexOf(")", n.length - t) - n.length) &&
                      ((e[0] = e[0].slice(0, t)), (e[2] = n.slice(0, t))),
                  e.slice(0, 3));
            },
          },
          filter: {
            TAG: function (e) {
              var t = e.replace(we, xe).toLowerCase();
              return "*" === e
                ? function () {
                    return !0;
                  }
                : function (e) {
                    return e.nodeName && e.nodeName.toLowerCase() === t;
                  };
            },
            CLASS: function (e) {
              var t = W[e + " "];
              return (
                t ||
                ((t = new RegExp("(^|" + ne + ")" + e + "(" + ne + "|$)")) &&
                  W(e, function (e) {
                    return t.test(
                      ("string" == typeof e.className && e.className) ||
                        ("undefined" != typeof e.getAttribute &&
                          e.getAttribute("class")) ||
                        ""
                    );
                  }))
              );
            },
            ATTR: function (e, n, i) {
              return function (o) {
                var r = t.attr(o, e);
                return null == r
                  ? "!=" === n
                  : !n ||
                      ((r += ""),
                      "=" === n
                        ? r === i
                        : "!=" === n
                        ? r !== i
                        : "^=" === n
                        ? i && 0 === r.indexOf(i)
                        : "*=" === n
                        ? i && r.indexOf(i) > -1
                        : "$=" === n
                        ? i && r.slice(-i.length) === i
                        : "~=" === n
                        ? (" " + r.replace(se, " ") + " ").indexOf(i) > -1
                        : "|=" === n &&
                          (r === i || r.slice(0, i.length + 1) === i + "-"));
              };
            },
            CHILD: function (e, t, n, i, o) {
              var r = "nth" !== e.slice(0, 3),
                s = "last" !== e.slice(-4),
                a = "of-type" === t;
              return 1 === i && 0 === o
                ? function (e) {
                    return !!e.parentNode;
                  }
                : function (t, n, l) {
                    var u,
                      c,
                      d,
                      p,
                      f,
                      h,
                      v = r !== s ? "nextSibling" : "previousSibling",
                      g = t.parentNode,
                      m = a && t.nodeName.toLowerCase(),
                      y = !l && !a,
                      b = !1;
                    if (g) {
                      if (r) {
                        for (; v; ) {
                          for (p = t; (p = p[v]); )
                            if (
                              a
                                ? p.nodeName.toLowerCase() === m
                                : 1 === p.nodeType
                            )
                              return !1;
                          h = v = "only" === e && !h && "nextSibling";
                        }
                        return !0;
                      }
                      if (((h = [s ? g.firstChild : g.lastChild]), s && y)) {
                        for (
                          p = g,
                            d = p[I] || (p[I] = {}),
                            c = d[p.uniqueID] || (d[p.uniqueID] = {}),
                            u = c[e] || [],
                            f = u[0] === M && u[1],
                            b = f && u[2],
                            p = f && g.childNodes[f];
                          (p = (++f && p && p[v]) || (b = f = 0) || h.pop());

                        )
                          if (1 === p.nodeType && ++b && p === t) {
                            c[e] = [M, f, b];
                            break;
                          }
                      } else if (
                        (y &&
                          ((p = t),
                          (d = p[I] || (p[I] = {})),
                          (c = d[p.uniqueID] || (d[p.uniqueID] = {})),
                          (u = c[e] || []),
                          (f = u[0] === M && u[1]),
                          (b = f)),
                        b === !1)
                      )
                        for (
                          ;
                          (p = (++f && p && p[v]) || (b = f = 0) || h.pop()) &&
                          ((a
                            ? p.nodeName.toLowerCase() !== m
                            : 1 !== p.nodeType) ||
                            !++b ||
                            (y &&
                              ((d = p[I] || (p[I] = {})),
                              (c = d[p.uniqueID] || (d[p.uniqueID] = {})),
                              (c[e] = [M, b])),
                            p !== t));

                        );
                      return (b -= o), b === i || (b % i === 0 && b / i >= 0);
                    }
                  };
            },
            PSEUDO: function (e, n) {
              var o,
                r =
                  k.pseudos[e] ||
                  k.setFilters[e.toLowerCase()] ||
                  t.error("unsupported pseudo: " + e);
              return r[I]
                ? r(n)
                : r.length > 1
                ? ((o = [e, e, "", n]),
                  k.setFilters.hasOwnProperty(e.toLowerCase())
                    ? i(function (e, t) {
                        for (var i, o = r(e, n), s = o.length; s--; )
                          (i = ee(e, o[s])), (e[i] = !(t[i] = o[s]));
                      })
                    : function (e) {
                        return r(e, 0, o);
                      })
                : r;
            },
          },
          pseudos: {
            not: i(function (e) {
              var t = [],
                n = [],
                o = $(e.replace(ae, "$1"));
              return o[I]
                ? i(function (e, t, n, i) {
                    for (var r, s = o(e, null, i, []), a = e.length; a--; )
                      (r = s[a]) && (e[a] = !(t[a] = r));
                  })
                : function (e, i, r) {
                    return (
                      (t[0] = e), o(t, null, r, n), (t[0] = null), !n.pop()
                    );
                  };
            }),
            has: i(function (e) {
              return function (n) {
                return t(e, n).length > 0;
              };
            }),
            contains: i(function (e) {
              return (
                (e = e.replace(we, xe)),
                function (t) {
                  return (t.textContent || t.innerText || T(t)).indexOf(e) > -1;
                }
              );
            }),
            lang: i(function (e) {
              return (
                pe.test(e || "") || t.error("unsupported lang: " + e),
                (e = e.replace(we, xe).toLowerCase()),
                function (t) {
                  var n;
                  do
                    if (
                      (n = q
                        ? t.lang
                        : t.getAttribute("xml:lang") || t.getAttribute("lang"))
                    )
                      return (
                        (n = n.toLowerCase()),
                        n === e || 0 === n.indexOf(e + "-")
                      );
                  while ((t = t.parentNode) && 1 === t.nodeType);
                  return !1;
                }
              );
            }),
            target: function (t) {
              var n = e.location && e.location.hash;
              return n && n.slice(1) === t.id;
            },
            root: function (e) {
              return e === H;
            },
            focus: function (e) {
              return (
                e === O.activeElement &&
                (!O.hasFocus || O.hasFocus()) &&
                !!(e.type || e.href || ~e.tabIndex)
              );
            },
            enabled: function (e) {
              return e.disabled === !1;
            },
            disabled: function (e) {
              return e.disabled === !0;
            },
            checked: function (e) {
              var t = e.nodeName.toLowerCase();
              return (
                ("input" === t && !!e.checked) ||
                ("option" === t && !!e.selected)
              );
            },
            selected: function (e) {
              return (
                e.parentNode && e.parentNode.selectedIndex, e.selected === !0
              );
            },
            empty: function (e) {
              for (e = e.firstChild; e; e = e.nextSibling)
                if (e.nodeType < 6) return !1;
              return !0;
            },
            parent: function (e) {
              return !k.pseudos.empty(e);
            },
            header: function (e) {
              return ve.test(e.nodeName);
            },
            input: function (e) {
              return he.test(e.nodeName);
            },
            button: function (e) {
              var t = e.nodeName.toLowerCase();
              return ("input" === t && "button" === e.type) || "button" === t;
            },
            text: function (e) {
              var t;
              return (
                "input" === e.nodeName.toLowerCase() &&
                "text" === e.type &&
                (null == (t = e.getAttribute("type")) ||
                  "text" === t.toLowerCase())
              );
            },
            first: u(function () {
              return [0];
            }),
            last: u(function (e, t) {
              return [t - 1];
            }),
            eq: u(function (e, t, n) {
              return [0 > n ? n + t : n];
            }),
            even: u(function (e, t) {
              for (var n = 0; t > n; n += 2) e.push(n);
              return e;
            }),
            odd: u(function (e, t) {
              for (var n = 1; t > n; n += 2) e.push(n);
              return e;
            }),
            lt: u(function (e, t, n) {
              for (var i = 0 > n ? n + t : n; --i >= 0; ) e.push(i);
              return e;
            }),
            gt: u(function (e, t, n) {
              for (var i = 0 > n ? n + t : n; ++i < t; ) e.push(i);
              return e;
            }),
          },
        }),
        (k.pseudos.nth = k.pseudos.eq);
      for (w in { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 })
        k.pseudos[w] = a(w);
      for (w in { submit: !0, reset: !0 }) k.pseudos[w] = l(w);
      return (
        (d.prototype = k.filters = k.pseudos),
        (k.setFilters = new d()),
        (C = t.tokenize = function (e, n) {
          var i,
            o,
            r,
            s,
            a,
            l,
            u,
            c = B[e + " "];
          if (c) return n ? 0 : c.slice(0);
          for (a = e, l = [], u = k.preFilter; a; ) {
            (i && !(o = le.exec(a))) ||
              (o && (a = a.slice(o[0].length) || a), l.push((r = []))),
              (i = !1),
              (o = ue.exec(a)) &&
                ((i = o.shift()),
                r.push({ value: i, type: o[0].replace(ae, " ") }),
                (a = a.slice(i.length)));
            for (s in k.filter)
              !(o = fe[s].exec(a)) ||
                (u[s] && !(o = u[s](o))) ||
                ((i = o.shift()),
                r.push({ value: i, type: s, matches: o }),
                (a = a.slice(i.length)));
            if (!i) break;
          }
          return n ? a.length : a ? t.error(e) : B(e, l).slice(0);
        }),
        ($ = t.compile = function (e, t) {
          var n,
            i = [],
            o = [],
            r = U[e + " "];
          if (!r) {
            for (t || (t = C(e)), n = t.length; n--; )
              (r = y(t[n])), r[I] ? i.push(r) : o.push(r);
            (r = U(e, b(o, i))), (r.selector = e);
          }
          return r;
        }),
        (E = t.select = function (e, t, n, i) {
          var o,
            r,
            s,
            a,
            l,
            u = "function" == typeof e && e,
            d = !i && C((e = u.selector || e));
          if (((n = n || []), 1 === d.length)) {
            if (
              ((r = d[0] = d[0].slice(0)),
              r.length > 2 &&
                "ID" === (s = r[0]).type &&
                x.getById &&
                9 === t.nodeType &&
                q &&
                k.relative[r[1].type])
            ) {
              if (
                ((t = (k.find.ID(s.matches[0].replace(we, xe), t) || [])[0]),
                !t)
              )
                return n;
              u && (t = t.parentNode), (e = e.slice(r.shift().value.length));
            }
            for (
              o = fe.needsContext.test(e) ? 0 : r.length;
              o-- && ((s = r[o]), !k.relative[(a = s.type)]);

            )
              if (
                (l = k.find[a]) &&
                (i = l(
                  s.matches[0].replace(we, xe),
                  (ye.test(r[0].type) && c(t.parentNode)) || t
                ))
              ) {
                if ((r.splice(o, 1), (e = i.length && p(r)), !e))
                  return Z.apply(n, i), n;
                break;
              }
          }
          return (
            (u || $(e, d))(
              i,
              t,
              !q,
              n,
              !t || (ye.test(e) && c(t.parentNode)) || t
            ),
            n
          );
        }),
        (x.sortStable = I.split("").sort(X).join("") === I),
        (x.detectDuplicates = !!N),
        D(),
        (x.sortDetached = o(function (e) {
          return 1 & e.compareDocumentPosition(O.createElement("div"));
        })),
        o(function (e) {
          return (
            (e.innerHTML = "<a href='#'></a>"),
            "#" === e.firstChild.getAttribute("href")
          );
        }) ||
          r("type|href|height|width", function (e, t, n) {
            return n
              ? void 0
              : e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2);
          }),
        (x.attributes &&
          o(function (e) {
            return (
              (e.innerHTML = "<input/>"),
              e.firstChild.setAttribute("value", ""),
              "" === e.firstChild.getAttribute("value")
            );
          })) ||
          r("value", function (e, t, n) {
            return n || "input" !== e.nodeName.toLowerCase()
              ? void 0
              : e.defaultValue;
          }),
        o(function (e) {
          return null == e.getAttribute("disabled");
        }) ||
          r(te, function (e, t, n) {
            var i;
            return n
              ? void 0
              : e[t] === !0
              ? t.toLowerCase()
              : (i = e.getAttributeNode(t)) && i.specified
              ? i.value
              : null;
          }),
        t
      );
    })(e);
    (re.find = ce),
      (re.expr = ce.selectors),
      (re.expr[":"] = re.expr.pseudos),
      (re.uniqueSort = re.unique = ce.uniqueSort),
      (re.text = ce.getText),
      (re.isXMLDoc = ce.isXML),
      (re.contains = ce.contains);
    var de = function (e, t, n) {
        for (var i = [], o = void 0 !== n; (e = e[t]) && 9 !== e.nodeType; )
          if (1 === e.nodeType) {
            if (o && re(e).is(n)) break;
            i.push(e);
          }
        return i;
      },
      pe = function (e, t) {
        for (var n = []; e; e = e.nextSibling)
          1 === e.nodeType && e !== t && n.push(e);
        return n;
      },
      fe = re.expr.match.needsContext,
      he = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/,
      ve = /^.[^:#\[\.,]*$/;
    (re.filter = function (e, t, n) {
      var i = t[0];
      return (
        n && (e = ":not(" + e + ")"),
        1 === t.length && 1 === i.nodeType
          ? re.find.matchesSelector(i, e)
            ? [i]
            : []
          : re.find.matches(
              e,
              re.grep(t, function (e) {
                return 1 === e.nodeType;
              })
            )
      );
    }),
      re.fn.extend({
        find: function (e) {
          var t,
            n = this.length,
            i = [],
            o = this;
          if ("string" != typeof e)
            return this.pushStack(
              re(e).filter(function () {
                for (t = 0; n > t; t++) if (re.contains(o[t], this)) return !0;
              })
            );
          for (t = 0; n > t; t++) re.find(e, o[t], i);
          return (
            (i = this.pushStack(n > 1 ? re.unique(i) : i)),
            (i.selector = this.selector ? this.selector + " " + e : e),
            i
          );
        },
        filter: function (e) {
          return this.pushStack(i(this, e || [], !1));
        },
        not: function (e) {
          return this.pushStack(i(this, e || [], !0));
        },
        is: function (e) {
          return !!i(
            this,
            "string" == typeof e && fe.test(e) ? re(e) : e || [],
            !1
          ).length;
        },
      });
    var ge,
      me = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,
      ye = (re.fn.init = function (e, t, n) {
        var i, o;
        if (!e) return this;
        if (((n = n || ge), "string" == typeof e)) {
          if (
            ((i =
              "<" === e[0] && ">" === e[e.length - 1] && e.length >= 3
                ? [null, e, null]
                : me.exec(e)),
            !i || (!i[1] && t))
          )
            return !t || t.jquery
              ? (t || n).find(e)
              : this.constructor(t).find(e);
          if (i[1]) {
            if (
              ((t = t instanceof re ? t[0] : t),
              re.merge(
                this,
                re.parseHTML(
                  i[1],
                  t && t.nodeType ? t.ownerDocument || t : G,
                  !0
                )
              ),
              he.test(i[1]) && re.isPlainObject(t))
            )
              for (i in t)
                re.isFunction(this[i]) ? this[i](t[i]) : this.attr(i, t[i]);
            return this;
          }
          return (
            (o = G.getElementById(i[2])),
            o && o.parentNode && ((this.length = 1), (this[0] = o)),
            (this.context = G),
            (this.selector = e),
            this
          );
        }
        return e.nodeType
          ? ((this.context = this[0] = e), (this.length = 1), this)
          : re.isFunction(e)
          ? void 0 !== n.ready
            ? n.ready(e)
            : e(re)
          : (void 0 !== e.selector &&
              ((this.selector = e.selector), (this.context = e.context)),
            re.makeArray(e, this));
      });
    (ye.prototype = re.fn), (ge = re(G));
    var be = /^(?:parents|prev(?:Until|All))/,
      we = { children: !0, contents: !0, next: !0, prev: !0 };
    re.fn.extend({
      has: function (e) {
        var t = re(e, this),
          n = t.length;
        return this.filter(function () {
          for (var e = 0; n > e; e++) if (re.contains(this, t[e])) return !0;
        });
      },
      closest: function (e, t) {
        for (
          var n,
            i = 0,
            o = this.length,
            r = [],
            s =
              fe.test(e) || "string" != typeof e ? re(e, t || this.context) : 0;
          o > i;
          i++
        )
          for (n = this[i]; n && n !== t; n = n.parentNode)
            if (
              n.nodeType < 11 &&
              (s
                ? s.index(n) > -1
                : 1 === n.nodeType && re.find.matchesSelector(n, e))
            ) {
              r.push(n);
              break;
            }
        return this.pushStack(r.length > 1 ? re.uniqueSort(r) : r);
      },
      index: function (e) {
        return e
          ? "string" == typeof e
            ? K.call(re(e), this[0])
            : K.call(this, e.jquery ? e[0] : e)
          : this[0] && this[0].parentNode
          ? this.first().prevAll().length
          : -1;
      },
      add: function (e, t) {
        return this.pushStack(re.uniqueSort(re.merge(this.get(), re(e, t))));
      },
      addBack: function (e) {
        return this.add(
          null == e ? this.prevObject : this.prevObject.filter(e)
        );
      },
    }),
      re.each(
        {
          parent: function (e) {
            var t = e.parentNode;
            return t && 11 !== t.nodeType ? t : null;
          },
          parents: function (e) {
            return de(e, "parentNode");
          },
          parentsUntil: function (e, t, n) {
            return de(e, "parentNode", n);
          },
          next: function (e) {
            return o(e, "nextSibling");
          },
          prev: function (e) {
            return o(e, "previousSibling");
          },
          nextAll: function (e) {
            return de(e, "nextSibling");
          },
          prevAll: function (e) {
            return de(e, "previousSibling");
          },
          nextUntil: function (e, t, n) {
            return de(e, "nextSibling", n);
          },
          prevUntil: function (e, t, n) {
            return de(e, "previousSibling", n);
          },
          siblings: function (e) {
            return pe((e.parentNode || {}).firstChild, e);
          },
          children: function (e) {
            return pe(e.firstChild);
          },
          contents: function (e) {
            return e.contentDocument || re.merge([], e.childNodes);
          },
        },
        function (e, t) {
          re.fn[e] = function (n, i) {
            var o = re.map(this, t, n);
            return (
              "Until" !== e.slice(-5) && (i = n),
              i && "string" == typeof i && (o = re.filter(i, o)),
              this.length > 1 &&
                (we[e] || re.uniqueSort(o), be.test(e) && o.reverse()),
              this.pushStack(o)
            );
          };
        }
      );
    var xe = /\S+/g;
    (re.Callbacks = function (e) {
      e = "string" == typeof e ? r(e) : re.extend({}, e);
      var t,
        n,
        i,
        o,
        s = [],
        a = [],
        l = -1,
        u = function () {
          for (o = e.once, i = t = !0; a.length; l = -1)
            for (n = a.shift(); ++l < s.length; )
              s[l].apply(n[0], n[1]) === !1 &&
                e.stopOnFalse &&
                ((l = s.length), (n = !1));
          e.memory || (n = !1), (t = !1), o && (s = n ? [] : "");
        },
        c = {
          add: function () {
            return (
              s &&
                (n && !t && ((l = s.length - 1), a.push(n)),
                (function t(n) {
                  re.each(n, function (n, i) {
                    re.isFunction(i)
                      ? (e.unique && c.has(i)) || s.push(i)
                      : i && i.length && "string" !== re.type(i) && t(i);
                  });
                })(arguments),
                n && !t && u()),
              this
            );
          },
          remove: function () {
            return (
              re.each(arguments, function (e, t) {
                for (var n; (n = re.inArray(t, s, n)) > -1; )
                  s.splice(n, 1), l >= n && l--;
              }),
              this
            );
          },
          has: function (e) {
            return e ? re.inArray(e, s) > -1 : s.length > 0;
          },
          empty: function () {
            return s && (s = []), this;
          },
          disable: function () {
            return (o = a = []), (s = n = ""), this;
          },
          disabled: function () {
            return !s;
          },
          lock: function () {
            return (o = a = []), n || (s = n = ""), this;
          },
          locked: function () {
            return !!o;
          },
          fireWith: function (e, n) {
            return (
              o ||
                ((n = n || []),
                (n = [e, n.slice ? n.slice() : n]),
                a.push(n),
                t || u()),
              this
            );
          },
          fire: function () {
            return c.fireWith(this, arguments), this;
          },
          fired: function () {
            return !!i;
          },
        };
      return c;
    }),
      re.extend({
        Deferred: function (e) {
          var t = [
              ["resolve", "done", re.Callbacks("once memory"), "resolved"],
              ["reject", "fail", re.Callbacks("once memory"), "rejected"],
              ["notify", "progress", re.Callbacks("memory")],
            ],
            n = "pending",
            i = {
              state: function () {
                return n;
              },
              always: function () {
                return o.done(arguments).fail(arguments), this;
              },
              then: function () {
                var e = arguments;
                return re
                  .Deferred(function (n) {
                    re.each(t, function (t, r) {
                      var s = re.isFunction(e[t]) && e[t];
                      o[r[1]](function () {
                        var e = s && s.apply(this, arguments);
                        e && re.isFunction(e.promise)
                          ? e
                              .promise()
                              .progress(n.notify)
                              .done(n.resolve)
                              .fail(n.reject)
                          : n[r[0] + "With"](
                              this === i ? n.promise() : this,
                              s ? [e] : arguments
                            );
                      });
                    }),
                      (e = null);
                  })
                  .promise();
              },
              promise: function (e) {
                return null != e ? re.extend(e, i) : i;
              },
            },
            o = {};
          return (
            (i.pipe = i.then),
            re.each(t, function (e, r) {
              var s = r[2],
                a = r[3];
              (i[r[1]] = s.add),
                a &&
                  s.add(
                    function () {
                      n = a;
                    },
                    t[1 ^ e][2].disable,
                    t[2][2].lock
                  ),
                (o[r[0]] = function () {
                  return (
                    o[r[0] + "With"](this === o ? i : this, arguments), this
                  );
                }),
                (o[r[0] + "With"] = s.fireWith);
            }),
            i.promise(o),
            e && e.call(o, o),
            o
          );
        },
        when: function (e) {
          var t,
            n,
            i,
            o = 0,
            r = Q.call(arguments),
            s = r.length,
            a = 1 !== s || (e && re.isFunction(e.promise)) ? s : 0,
            l = 1 === a ? e : re.Deferred(),
            u = function (e, n, i) {
              return function (o) {
                (n[e] = this),
                  (i[e] = arguments.length > 1 ? Q.call(arguments) : o),
                  i === t ? l.notifyWith(n, i) : --a || l.resolveWith(n, i);
              };
            };
          if (s > 1)
            for (
              t = new Array(s), n = new Array(s), i = new Array(s);
              s > o;
              o++
            )
              r[o] && re.isFunction(r[o].promise)
                ? r[o]
                    .promise()
                    .progress(u(o, n, t))
                    .done(u(o, i, r))
                    .fail(l.reject)
                : --a;
          return a || l.resolveWith(i, r), l.promise();
        },
      });
    var ke;
    (re.fn.ready = function (e) {
      return re.ready.promise().done(e), this;
    }),
      re.extend({
        isReady: !1,
        readyWait: 1,
        holdReady: function (e) {
          e ? re.readyWait++ : re.ready(!0);
        },
        ready: function (e) {
          (e === !0 ? --re.readyWait : re.isReady) ||
            ((re.isReady = !0),
            (e !== !0 && --re.readyWait > 0) ||
              (ke.resolveWith(G, [re]),
              re.fn.triggerHandler &&
                (re(G).triggerHandler("ready"), re(G).off("ready"))));
        },
      }),
      (re.ready.promise = function (t) {
        return (
          ke ||
            ((ke = re.Deferred()),
            "complete" === G.readyState ||
            ("loading" !== G.readyState && !G.documentElement.doScroll)
              ? e.setTimeout(re.ready)
              : (G.addEventListener("DOMContentLoaded", s),
                e.addEventListener("load", s))),
          ke.promise(t)
        );
      }),
      re.ready.promise();
    var Te = function (e, t, n, i, o, r, s) {
        var a = 0,
          l = e.length,
          u = null == n;
        if ("object" === re.type(n)) {
          o = !0;
          for (a in n) Te(e, t, a, n[a], !0, r, s);
        } else if (
          void 0 !== i &&
          ((o = !0),
          re.isFunction(i) || (s = !0),
          u &&
            (s
              ? (t.call(e, i), (t = null))
              : ((u = t),
                (t = function (e, t, n) {
                  return u.call(re(e), n);
                }))),
          t)
        )
          for (; l > a; a++) t(e[a], n, s ? i : i.call(e[a], a, t(e[a], n)));
        return o ? e : u ? t.call(e) : l ? t(e[0], n) : r;
      },
      Se = function (e) {
        return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
      };
    (a.uid = 1),
      (a.prototype = {
        register: function (e, t) {
          var n = t || {};
          return (
            e.nodeType
              ? (e[this.expando] = n)
              : Object.defineProperty(e, this.expando, {
                  value: n,
                  writable: !0,
                  configurable: !0,
                }),
            e[this.expando]
          );
        },
        cache: function (e) {
          if (!Se(e)) return {};
          var t = e[this.expando];
          return (
            t ||
              ((t = {}),
              Se(e) &&
                (e.nodeType
                  ? (e[this.expando] = t)
                  : Object.defineProperty(e, this.expando, {
                      value: t,
                      configurable: !0,
                    }))),
            t
          );
        },
        set: function (e, t, n) {
          var i,
            o = this.cache(e);
          if ("string" == typeof t) o[t] = n;
          else for (i in t) o[i] = t[i];
          return o;
        },
        get: function (e, t) {
          return void 0 === t
            ? this.cache(e)
            : e[this.expando] && e[this.expando][t];
        },
        access: function (e, t, n) {
          var i;
          return void 0 === t || (t && "string" == typeof t && void 0 === n)
            ? ((i = this.get(e, t)),
              void 0 !== i ? i : this.get(e, re.camelCase(t)))
            : (this.set(e, t, n), void 0 !== n ? n : t);
        },
        remove: function (e, t) {
          var n,
            i,
            o,
            r = e[this.expando];
          if (void 0 !== r) {
            if (void 0 === t) this.register(e);
            else {
              re.isArray(t)
                ? (i = t.concat(t.map(re.camelCase)))
                : ((o = re.camelCase(t)),
                  t in r
                    ? (i = [t, o])
                    : ((i = o), (i = i in r ? [i] : i.match(xe) || []))),
                (n = i.length);
              for (; n--; ) delete r[i[n]];
            }
            (void 0 === t || re.isEmptyObject(r)) &&
              (e.nodeType
                ? (e[this.expando] = void 0)
                : delete e[this.expando]);
          }
        },
        hasData: function (e) {
          var t = e[this.expando];
          return void 0 !== t && !re.isEmptyObject(t);
        },
      });
    var Ce = new a(),
      $e = new a(),
      Ee = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
      Ae = /[A-Z]/g;
    re.extend({
      hasData: function (e) {
        return $e.hasData(e) || Ce.hasData(e);
      },
      data: function (e, t, n) {
        return $e.access(e, t, n);
      },
      removeData: function (e, t) {
        $e.remove(e, t);
      },
      _data: function (e, t, n) {
        return Ce.access(e, t, n);
      },
      _removeData: function (e, t) {
        Ce.remove(e, t);
      },
    }),
      re.fn.extend({
        data: function (e, t) {
          var n,
            i,
            o,
            r = this[0],
            s = r && r.attributes;
          if (void 0 === e) {
            if (
              this.length &&
              ((o = $e.get(r)), 1 === r.nodeType && !Ce.get(r, "hasDataAttrs"))
            ) {
              for (n = s.length; n--; )
                s[n] &&
                  ((i = s[n].name),
                  0 === i.indexOf("data-") &&
                    ((i = re.camelCase(i.slice(5))), l(r, i, o[i])));
              Ce.set(r, "hasDataAttrs", !0);
            }
            return o;
          }
          return "object" == typeof e
            ? this.each(function () {
                $e.set(this, e);
              })
            : Te(
                this,
                function (t) {
                  var n, i;
                  if (r && void 0 === t) {
                    if (
                      ((n =
                        $e.get(r, e) ||
                        $e.get(r, e.replace(Ae, "-$&").toLowerCase())),
                      void 0 !== n)
                    )
                      return n;
                    if (
                      ((i = re.camelCase(e)), (n = $e.get(r, i)), void 0 !== n)
                    )
                      return n;
                    if (((n = l(r, i, void 0)), void 0 !== n)) return n;
                  } else
                    (i = re.camelCase(e)),
                      this.each(function () {
                        var n = $e.get(this, i);
                        $e.set(this, i, t),
                          e.indexOf("-") > -1 &&
                            void 0 !== n &&
                            $e.set(this, e, t);
                      });
                },
                null,
                t,
                arguments.length > 1,
                null,
                !0
              );
        },
        removeData: function (e) {
          return this.each(function () {
            $e.remove(this, e);
          });
        },
      }),
      re.extend({
        queue: function (e, t, n) {
          var i;
          return e
            ? ((t = (t || "fx") + "queue"),
              (i = Ce.get(e, t)),
              n &&
                (!i || re.isArray(n)
                  ? (i = Ce.access(e, t, re.makeArray(n)))
                  : i.push(n)),
              i || [])
            : void 0;
        },
        dequeue: function (e, t) {
          t = t || "fx";
          var n = re.queue(e, t),
            i = n.length,
            o = n.shift(),
            r = re._queueHooks(e, t),
            s = function () {
              re.dequeue(e, t);
            };
          "inprogress" === o && ((o = n.shift()), i--),
            o &&
              ("fx" === t && n.unshift("inprogress"),
              delete r.stop,
              o.call(e, s, r)),
            !i && r && r.empty.fire();
        },
        _queueHooks: function (e, t) {
          var n = t + "queueHooks";
          return (
            Ce.get(e, n) ||
            Ce.access(e, n, {
              empty: re.Callbacks("once memory").add(function () {
                Ce.remove(e, [t + "queue", n]);
              }),
            })
          );
        },
      }),
      re.fn.extend({
        queue: function (e, t) {
          var n = 2;
          return (
            "string" != typeof e && ((t = e), (e = "fx"), n--),
            arguments.length < n
              ? re.queue(this[0], e)
              : void 0 === t
              ? this
              : this.each(function () {
                  var n = re.queue(this, e, t);
                  re._queueHooks(this, e),
                    "fx" === e && "inprogress" !== n[0] && re.dequeue(this, e);
                })
          );
        },
        dequeue: function (e) {
          return this.each(function () {
            re.dequeue(this, e);
          });
        },
        clearQueue: function (e) {
          return this.queue(e || "fx", []);
        },
        promise: function (e, t) {
          var n,
            i = 1,
            o = re.Deferred(),
            r = this,
            s = this.length,
            a = function () {
              --i || o.resolveWith(r, [r]);
            };
          for (
            "string" != typeof e && ((t = e), (e = void 0)), e = e || "fx";
            s--;

          )
            (n = Ce.get(r[s], e + "queueHooks")),
              n && n.empty && (i++, n.empty.add(a));
          return a(), o.promise(t);
        },
      });
    var je = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
      Ne = new RegExp("^(?:([+-])=|)(" + je + ")([a-z%]*)$", "i"),
      De = ["Top", "Right", "Bottom", "Left"],
      Oe = function (e, t) {
        return (
          (e = t || e),
          "none" === re.css(e, "display") || !re.contains(e.ownerDocument, e)
        );
      },
      He = /^(?:checkbox|radio)$/i,
      qe = /<([\w:-]+)/,
      Pe = /^$|\/(?:java|ecma)script/i,
      Le = {
        option: [1, "<select multiple='multiple'>", "</select>"],
        thead: [1, "<table>", "</table>"],
        col: [2, "<table><colgroup>", "</colgroup></table>"],
        tr: [2, "<table><tbody>", "</tbody></table>"],
        td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
        _default: [0, "", ""],
      };
    (Le.optgroup = Le.option),
      (Le.tbody = Le.tfoot = Le.colgroup = Le.caption = Le.thead),
      (Le.th = Le.td);
    var _e = /<|&#?\w+;/;
    !(function () {
      var e = G.createDocumentFragment(),
        t = e.appendChild(G.createElement("div")),
        n = G.createElement("input");
      n.setAttribute("type", "radio"),
        n.setAttribute("checked", "checked"),
        n.setAttribute("name", "t"),
        t.appendChild(n),
        (ie.checkClone = t.cloneNode(!0).cloneNode(!0).lastChild.checked),
        (t.innerHTML = "<textarea>x</textarea>"),
        (ie.noCloneChecked = !!t.cloneNode(!0).lastChild.defaultValue);
    })();
    var ze = /^key/,
      Ie = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
      Fe = /^([^.]*)(?:\.(.+)|)/;
    (re.event = {
      global: {},
      add: function (e, t, n, i, o) {
        var r,
          s,
          a,
          l,
          u,
          c,
          d,
          p,
          f,
          h,
          v,
          g = Ce.get(e);
        if (g)
          for (
            n.handler && ((r = n), (n = r.handler), (o = r.selector)),
              n.guid || (n.guid = re.guid++),
              (l = g.events) || (l = g.events = {}),
              (s = g.handle) ||
                (s = g.handle = function (t) {
                  return "undefined" != typeof re &&
                    re.event.triggered !== t.type
                    ? re.event.dispatch.apply(e, arguments)
                    : void 0;
                }),
              t = (t || "").match(xe) || [""],
              u = t.length;
            u--;

          )
            (a = Fe.exec(t[u]) || []),
              (f = v = a[1]),
              (h = (a[2] || "").split(".").sort()),
              f &&
                ((d = re.event.special[f] || {}),
                (f = (o ? d.delegateType : d.bindType) || f),
                (d = re.event.special[f] || {}),
                (c = re.extend(
                  {
                    type: f,
                    origType: v,
                    data: i,
                    handler: n,
                    guid: n.guid,
                    selector: o,
                    needsContext: o && re.expr.match.needsContext.test(o),
                    namespace: h.join("."),
                  },
                  r
                )),
                (p = l[f]) ||
                  ((p = l[f] = []),
                  (p.delegateCount = 0),
                  (d.setup && d.setup.call(e, i, h, s) !== !1) ||
                    (e.addEventListener && e.addEventListener(f, s))),
                d.add &&
                  (d.add.call(e, c),
                  c.handler.guid || (c.handler.guid = n.guid)),
                o ? p.splice(p.delegateCount++, 0, c) : p.push(c),
                (re.event.global[f] = !0));
      },
      remove: function (e, t, n, i, o) {
        var r,
          s,
          a,
          l,
          u,
          c,
          d,
          p,
          f,
          h,
          v,
          g = Ce.hasData(e) && Ce.get(e);
        if (g && (l = g.events)) {
          for (t = (t || "").match(xe) || [""], u = t.length; u--; )
            if (
              ((a = Fe.exec(t[u]) || []),
              (f = v = a[1]),
              (h = (a[2] || "").split(".").sort()),
              f)
            ) {
              for (
                d = re.event.special[f] || {},
                  f = (i ? d.delegateType : d.bindType) || f,
                  p = l[f] || [],
                  a =
                    a[2] &&
                    new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)"),
                  s = r = p.length;
                r--;

              )
                (c = p[r]),
                  (!o && v !== c.origType) ||
                    (n && n.guid !== c.guid) ||
                    (a && !a.test(c.namespace)) ||
                    (i && i !== c.selector && ("**" !== i || !c.selector)) ||
                    (p.splice(r, 1),
                    c.selector && p.delegateCount--,
                    d.remove && d.remove.call(e, c));
              s &&
                !p.length &&
                ((d.teardown && d.teardown.call(e, h, g.handle) !== !1) ||
                  re.removeEvent(e, f, g.handle),
                delete l[f]);
            } else for (f in l) re.event.remove(e, f + t[u], n, i, !0);
          re.isEmptyObject(l) && Ce.remove(e, "handle events");
        }
      },
      dispatch: function (e) {
        e = re.event.fix(e);
        var t,
          n,
          i,
          o,
          r,
          s = [],
          a = Q.call(arguments),
          l = (Ce.get(this, "events") || {})[e.type] || [],
          u = re.event.special[e.type] || {};
        if (
          ((a[0] = e),
          (e.delegateTarget = this),
          !u.preDispatch || u.preDispatch.call(this, e) !== !1)
        ) {
          for (
            s = re.event.handlers.call(this, e, l), t = 0;
            (o = s[t++]) && !e.isPropagationStopped();

          )
            for (
              e.currentTarget = o.elem, n = 0;
              (r = o.handlers[n++]) && !e.isImmediatePropagationStopped();

            )
              (e.rnamespace && !e.rnamespace.test(r.namespace)) ||
                ((e.handleObj = r),
                (e.data = r.data),
                (i = (
                  (re.event.special[r.origType] || {}).handle || r.handler
                ).apply(o.elem, a)),
                void 0 !== i &&
                  (e.result = i) === !1 &&
                  (e.preventDefault(), e.stopPropagation()));
          return u.postDispatch && u.postDispatch.call(this, e), e.result;
        }
      },
      handlers: function (e, t) {
        var n,
          i,
          o,
          r,
          s = [],
          a = t.delegateCount,
          l = e.target;
        if (
          a &&
          l.nodeType &&
          ("click" !== e.type || isNaN(e.button) || e.button < 1)
        )
          for (; l !== this; l = l.parentNode || this)
            if (1 === l.nodeType && (l.disabled !== !0 || "click" !== e.type)) {
              for (i = [], n = 0; a > n; n++)
                (r = t[n]),
                  (o = r.selector + " "),
                  void 0 === i[o] &&
                    (i[o] = r.needsContext
                      ? re(o, this).index(l) > -1
                      : re.find(o, this, null, [l]).length),
                  i[o] && i.push(r);
              i.length && s.push({ elem: l, handlers: i });
            }
        return a < t.length && s.push({ elem: this, handlers: t.slice(a) }), s;
      },
      props: "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(
        " "
      ),
      fixHooks: {},
      keyHooks: {
        props: "char charCode key keyCode".split(" "),
        filter: function (e, t) {
          return (
            null == e.which &&
              (e.which = null != t.charCode ? t.charCode : t.keyCode),
            e
          );
        },
      },
      mouseHooks: {
        props: "button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(
          " "
        ),
        filter: function (e, t) {
          var n,
            i,
            o,
            r = t.button;
          return (
            null == e.pageX &&
              null != t.clientX &&
              ((n = e.target.ownerDocument || G),
              (i = n.documentElement),
              (o = n.body),
              (e.pageX =
                t.clientX +
                ((i && i.scrollLeft) || (o && o.scrollLeft) || 0) -
                ((i && i.clientLeft) || (o && o.clientLeft) || 0)),
              (e.pageY =
                t.clientY +
                ((i && i.scrollTop) || (o && o.scrollTop) || 0) -
                ((i && i.clientTop) || (o && o.clientTop) || 0))),
            e.which ||
              void 0 === r ||
              (e.which = 1 & r ? 1 : 2 & r ? 3 : 4 & r ? 2 : 0),
            e
          );
        },
      },
      fix: function (e) {
        if (e[re.expando]) return e;
        var t,
          n,
          i,
          o = e.type,
          r = e,
          s = this.fixHooks[o];
        for (
          s ||
            (this.fixHooks[o] = s = Ie.test(o)
              ? this.mouseHooks
              : ze.test(o)
              ? this.keyHooks
              : {}),
            i = s.props ? this.props.concat(s.props) : this.props,
            e = new re.Event(r),
            t = i.length;
          t--;

        )
          (n = i[t]), (e[n] = r[n]);
        return (
          e.target || (e.target = G),
          3 === e.target.nodeType && (e.target = e.target.parentNode),
          s.filter ? s.filter(e, r) : e
        );
      },
      special: {
        load: { noBubble: !0 },
        focus: {
          trigger: function () {
            return this !== v() && this.focus ? (this.focus(), !1) : void 0;
          },
          delegateType: "focusin",
        },
        blur: {
          trigger: function () {
            return this === v() && this.blur ? (this.blur(), !1) : void 0;
          },
          delegateType: "focusout",
        },
        click: {
          trigger: function () {
            return "checkbox" === this.type &&
              this.click &&
              re.nodeName(this, "input")
              ? (this.click(), !1)
              : void 0;
          },
          _default: function (e) {
            return re.nodeName(e.target, "a");
          },
        },
        beforeunload: {
          postDispatch: function (e) {
            void 0 !== e.result &&
              e.originalEvent &&
              (e.originalEvent.returnValue = e.result);
          },
        },
      },
    }),
      (re.removeEvent = function (e, t, n) {
        e.removeEventListener && e.removeEventListener(t, n);
      }),
      (re.Event = function (e, t) {
        return this instanceof re.Event
          ? (e && e.type
              ? ((this.originalEvent = e),
                (this.type = e.type),
                (this.isDefaultPrevented =
                  e.defaultPrevented ||
                  (void 0 === e.defaultPrevented && e.returnValue === !1)
                    ? f
                    : h))
              : (this.type = e),
            t && re.extend(this, t),
            (this.timeStamp = (e && e.timeStamp) || re.now()),
            void (this[re.expando] = !0))
          : new re.Event(e, t);
      }),
      (re.Event.prototype = {
        constructor: re.Event,
        isDefaultPrevented: h,
        isPropagationStopped: h,
        isImmediatePropagationStopped: h,
        preventDefault: function () {
          var e = this.originalEvent;
          (this.isDefaultPrevented = f), e && e.preventDefault();
        },
        stopPropagation: function () {
          var e = this.originalEvent;
          (this.isPropagationStopped = f), e && e.stopPropagation();
        },
        stopImmediatePropagation: function () {
          var e = this.originalEvent;
          (this.isImmediatePropagationStopped = f),
            e && e.stopImmediatePropagation(),
            this.stopPropagation();
        },
      }),
      re.each(
        {
          mouseenter: "mouseover",
          mouseleave: "mouseout",
          pointerenter: "pointerover",
          pointerleave: "pointerout",
        },
        function (e, t) {
          re.event.special[e] = {
            delegateType: t,
            bindType: t,
            handle: function (e) {
              var n,
                i = this,
                o = e.relatedTarget,
                r = e.handleObj;
              return (
                (o && (o === i || re.contains(i, o))) ||
                  ((e.type = r.origType),
                  (n = r.handler.apply(this, arguments)),
                  (e.type = t)),
                n
              );
            },
          };
        }
      ),
      re.fn.extend({
        on: function (e, t, n, i) {
          return g(this, e, t, n, i);
        },
        one: function (e, t, n, i) {
          return g(this, e, t, n, i, 1);
        },
        off: function (e, t, n) {
          var i, o;
          if (e && e.preventDefault && e.handleObj)
            return (
              (i = e.handleObj),
              re(e.delegateTarget).off(
                i.namespace ? i.origType + "." + i.namespace : i.origType,
                i.selector,
                i.handler
              ),
              this
            );
          if ("object" == typeof e) {
            for (o in e) this.off(o, t, e[o]);
            return this;
          }
          return (
            (t !== !1 && "function" != typeof t) || ((n = t), (t = void 0)),
            n === !1 && (n = h),
            this.each(function () {
              re.event.remove(this, e, n, t);
            })
          );
        },
      });
    var Me = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,
      Re = /<script|<style|<link/i,
      We = /checked\s*(?:[^=]|=\s*.checked.)/i,
      Be = /^true\/(.*)/,
      Ue = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
    re.extend({
      htmlPrefilter: function (e) {
        return e.replace(Me, "<$1></$2>");
      },
      clone: function (e, t, n) {
        var i,
          o,
          r,
          s,
          a = e.cloneNode(!0),
          l = re.contains(e.ownerDocument, e);
        if (
          !(
            ie.noCloneChecked ||
            (1 !== e.nodeType && 11 !== e.nodeType) ||
            re.isXMLDoc(e)
          )
        )
          for (s = c(a), r = c(e), i = 0, o = r.length; o > i; i++)
            x(r[i], s[i]);
        if (t)
          if (n)
            for (r = r || c(e), s = s || c(a), i = 0, o = r.length; o > i; i++)
              w(r[i], s[i]);
          else w(e, a);
        return (
          (s = c(a, "script")), s.length > 0 && d(s, !l && c(e, "script")), a
        );
      },
      cleanData: function (e) {
        for (
          var t, n, i, o = re.event.special, r = 0;
          void 0 !== (n = e[r]);
          r++
        )
          if (Se(n)) {
            if ((t = n[Ce.expando])) {
              if (t.events)
                for (i in t.events)
                  o[i] ? re.event.remove(n, i) : re.removeEvent(n, i, t.handle);
              n[Ce.expando] = void 0;
            }
            n[$e.expando] && (n[$e.expando] = void 0);
          }
      },
    }),
      re.fn.extend({
        domManip: k,
        detach: function (e) {
          return T(this, e, !0);
        },
        remove: function (e) {
          return T(this, e);
        },
        text: function (e) {
          return Te(
            this,
            function (e) {
              return void 0 === e
                ? re.text(this)
                : this.empty().each(function () {
                    (1 !== this.nodeType &&
                      11 !== this.nodeType &&
                      9 !== this.nodeType) ||
                      (this.textContent = e);
                  });
            },
            null,
            e,
            arguments.length
          );
        },
        append: function () {
          return k(this, arguments, function (e) {
            if (
              1 === this.nodeType ||
              11 === this.nodeType ||
              9 === this.nodeType
            ) {
              var t = m(this, e);
              t.appendChild(e);
            }
          });
        },
        prepend: function () {
          return k(this, arguments, function (e) {
            if (
              1 === this.nodeType ||
              11 === this.nodeType ||
              9 === this.nodeType
            ) {
              var t = m(this, e);
              t.insertBefore(e, t.firstChild);
            }
          });
        },
        before: function () {
          return k(this, arguments, function (e) {
            this.parentNode && this.parentNode.insertBefore(e, this);
          });
        },
        after: function () {
          return k(this, arguments, function (e) {
            this.parentNode &&
              this.parentNode.insertBefore(e, this.nextSibling);
          });
        },
        empty: function () {
          for (var e, t = 0; null != (e = this[t]); t++)
            1 === e.nodeType && (re.cleanData(c(e, !1)), (e.textContent = ""));
          return this;
        },
        clone: function (e, t) {
          return (
            (e = null != e && e),
            (t = null == t ? e : t),
            this.map(function () {
              return re.clone(this, e, t);
            })
          );
        },
        html: function (e) {
          return Te(
            this,
            function (e) {
              var t = this[0] || {},
                n = 0,
                i = this.length;
              if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
              if (
                "string" == typeof e &&
                !Re.test(e) &&
                !Le[(qe.exec(e) || ["", ""])[1].toLowerCase()]
              ) {
                e = re.htmlPrefilter(e);
                try {
                  for (; i > n; n++)
                    (t = this[n] || {}),
                      1 === t.nodeType &&
                        (re.cleanData(c(t, !1)), (t.innerHTML = e));
                  t = 0;
                } catch (e) {}
              }
              t && this.empty().append(e);
            },
            null,
            e,
            arguments.length
          );
        },
        replaceWith: function () {
          var e = [];
          return k(
            this,
            arguments,
            function (t) {
              var n = this.parentNode;
              re.inArray(this, e) < 0 &&
                (re.cleanData(c(this)), n && n.replaceChild(t, this));
            },
            e
          );
        },
      }),
      re.each(
        {
          appendTo: "append",
          prependTo: "prepend",
          insertBefore: "before",
          insertAfter: "after",
          replaceAll: "replaceWith",
        },
        function (e, t) {
          re.fn[e] = function (e) {
            for (var n, i = [], o = re(e), r = o.length - 1, s = 0; r >= s; s++)
              (n = s === r ? this : this.clone(!0)),
                re(o[s])[t](n),
                Z.apply(i, n.get());
            return this.pushStack(i);
          };
        }
      );
    var Xe,
      Ye = { HTML: "block", BODY: "block" },
      Ve = /^margin/,
      Ge = new RegExp("^(" + je + ")(?!px)[a-z%]+$", "i"),
      Qe = function (t) {
        var n = t.ownerDocument.defaultView;
        return (n && n.opener) || (n = e), n.getComputedStyle(t);
      },
      Je = function (e, t, n, i) {
        var o,
          r,
          s = {};
        for (r in t) (s[r] = e.style[r]), (e.style[r] = t[r]);
        o = n.apply(e, i || []);
        for (r in t) e.style[r] = s[r];
        return o;
      },
      Ze = G.documentElement;
    !(function () {
      function t() {
        (a.style.cssText =
          "-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:relative;display:block;margin:auto;border:1px;padding:1px;top:1%;width:50%"),
          (a.innerHTML = ""),
          Ze.appendChild(s);
        var t = e.getComputedStyle(a);
        (n = "1%" !== t.top),
          (r = "2px" === t.marginLeft),
          (i = "4px" === t.width),
          (a.style.marginRight = "50%"),
          (o = "4px" === t.marginRight),
          Ze.removeChild(s);
      }
      var n,
        i,
        o,
        r,
        s = G.createElement("div"),
        a = G.createElement("div");
      a.style &&
        ((a.style.backgroundClip = "content-box"),
        (a.cloneNode(!0).style.backgroundClip = ""),
        (ie.clearCloneStyle = "content-box" === a.style.backgroundClip),
        (s.style.cssText =
          "border:0;width:8px;height:0;top:0;left:-9999px;padding:0;margin-top:1px;position:absolute"),
        s.appendChild(a),
        re.extend(ie, {
          pixelPosition: function () {
            return t(), n;
          },
          boxSizingReliable: function () {
            return null == i && t(), i;
          },
          pixelMarginRight: function () {
            return null == i && t(), o;
          },
          reliableMarginLeft: function () {
            return null == i && t(), r;
          },
          reliableMarginRight: function () {
            var t,
              n = a.appendChild(G.createElement("div"));
            return (
              (n.style.cssText = a.style.cssText =
                "-webkit-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0"),
              (n.style.marginRight = n.style.width = "0"),
              (a.style.width = "1px"),
              Ze.appendChild(s),
              (t = !parseFloat(e.getComputedStyle(n).marginRight)),
              Ze.removeChild(s),
              a.removeChild(n),
              t
            );
          },
        }));
    })();
    var Ke = /^(none|table(?!-c[ea]).+)/,
      et = { position: "absolute", visibility: "hidden", display: "block" },
      tt = { letterSpacing: "0", fontWeight: "400" },
      nt = ["Webkit", "O", "Moz", "ms"],
      it = G.createElement("div").style;
    re.extend({
      cssHooks: {
        opacity: {
          get: function (e, t) {
            if (t) {
              var n = $(e, "opacity");
              return "" === n ? "1" : n;
            }
          },
        },
      },
      cssNumber: {
        animationIterationCount: !0,
        columnCount: !0,
        fillOpacity: !0,
        flexGrow: !0,
        flexShrink: !0,
        fontWeight: !0,
        lineHeight: !0,
        opacity: !0,
        order: !0,
        orphans: !0,
        widows: !0,
        zIndex: !0,
        zoom: !0,
      },
      cssProps: { float: "cssFloat" },
      style: function (e, t, n, i) {
        if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
          var o,
            r,
            s,
            a = re.camelCase(t),
            l = e.style;
          return (
            (t = re.cssProps[a] || (re.cssProps[a] = A(a) || a)),
            (s = re.cssHooks[t] || re.cssHooks[a]),
            void 0 === n
              ? s && "get" in s && void 0 !== (o = s.get(e, !1, i))
                ? o
                : l[t]
              : ((r = typeof n),
                "string" === r &&
                  (o = Ne.exec(n)) &&
                  o[1] &&
                  ((n = u(e, t, o)), (r = "number")),
                void (
                  null != n &&
                  n === n &&
                  ("number" === r &&
                    (n += (o && o[3]) || (re.cssNumber[a] ? "" : "px")),
                  ie.clearCloneStyle ||
                    "" !== n ||
                    0 !== t.indexOf("background") ||
                    (l[t] = "inherit"),
                  (s && "set" in s && void 0 === (n = s.set(e, n, i))) ||
                    (l[t] = n))
                ))
          );
        }
      },
      css: function (e, t, n, i) {
        var o,
          r,
          s,
          a = re.camelCase(t);
        return (
          (t = re.cssProps[a] || (re.cssProps[a] = A(a) || a)),
          (s = re.cssHooks[t] || re.cssHooks[a]),
          s && "get" in s && (o = s.get(e, !0, n)),
          void 0 === o && (o = $(e, t, i)),
          "normal" === o && t in tt && (o = tt[t]),
          "" === n || n
            ? ((r = parseFloat(o)), n === !0 || isFinite(r) ? r || 0 : o)
            : o
        );
      },
    }),
      re.each(["height", "width"], function (e, t) {
        re.cssHooks[t] = {
          get: function (e, n, i) {
            return n
              ? Ke.test(re.css(e, "display")) && 0 === e.offsetWidth
                ? Je(e, et, function () {
                    return D(e, t, i);
                  })
                : D(e, t, i)
              : void 0;
          },
          set: function (e, n, i) {
            var o,
              r = i && Qe(e),
              s =
                i &&
                N(e, t, i, "border-box" === re.css(e, "boxSizing", !1, r), r);
            return (
              s &&
                (o = Ne.exec(n)) &&
                "px" !== (o[3] || "px") &&
                ((e.style[t] = n), (n = re.css(e, t))),
              j(e, n, s)
            );
          },
        };
      }),
      (re.cssHooks.marginLeft = E(ie.reliableMarginLeft, function (e, t) {
        return t
          ? (parseFloat($(e, "marginLeft")) ||
              e.getBoundingClientRect().left -
                Je(e, { marginLeft: 0 }, function () {
                  return e.getBoundingClientRect().left;
                })) + "px"
          : void 0;
      })),
      (re.cssHooks.marginRight = E(ie.reliableMarginRight, function (e, t) {
        return t
          ? Je(e, { display: "inline-block" }, $, [e, "marginRight"])
          : void 0;
      })),
      re.each({ margin: "", padding: "", border: "Width" }, function (e, t) {
        (re.cssHooks[e + t] = {
          expand: function (n) {
            for (
              var i = 0, o = {}, r = "string" == typeof n ? n.split(" ") : [n];
              4 > i;
              i++
            )
              o[e + De[i] + t] = r[i] || r[i - 2] || r[0];
            return o;
          },
        }),
          Ve.test(e) || (re.cssHooks[e + t].set = j);
      }),
      re.fn.extend({
        css: function (e, t) {
          return Te(
            this,
            function (e, t, n) {
              var i,
                o,
                r = {},
                s = 0;
              if (re.isArray(t)) {
                for (i = Qe(e), o = t.length; o > s; s++)
                  r[t[s]] = re.css(e, t[s], !1, i);
                return r;
              }
              return void 0 !== n ? re.style(e, t, n) : re.css(e, t);
            },
            e,
            t,
            arguments.length > 1
          );
        },
        show: function () {
          return O(this, !0);
        },
        hide: function () {
          return O(this);
        },
        toggle: function (e) {
          return "boolean" == typeof e
            ? e
              ? this.show()
              : this.hide()
            : this.each(function () {
                Oe(this) ? re(this).show() : re(this).hide();
              });
        },
      }),
      (re.Tween = H),
      (H.prototype = {
        constructor: H,
        init: function (e, t, n, i, o, r) {
          (this.elem = e),
            (this.prop = n),
            (this.easing = o || re.easing._default),
            (this.options = t),
            (this.start = this.now = this.cur()),
            (this.end = i),
            (this.unit = r || (re.cssNumber[n] ? "" : "px"));
        },
        cur: function () {
          var e = H.propHooks[this.prop];
          return e && e.get ? e.get(this) : H.propHooks._default.get(this);
        },
        run: function (e) {
          var t,
            n = H.propHooks[this.prop];
          return (
            this.options.duration
              ? (this.pos = t = re.easing[this.easing](
                  e,
                  this.options.duration * e,
                  0,
                  1,
                  this.options.duration
                ))
              : (this.pos = t = e),
            (this.now = (this.end - this.start) * t + this.start),
            this.options.step &&
              this.options.step.call(this.elem, this.now, this),
            n && n.set ? n.set(this) : H.propHooks._default.set(this),
            this
          );
        },
      }),
      (H.prototype.init.prototype = H.prototype),
      (H.propHooks = {
        _default: {
          get: function (e) {
            var t;
            return 1 !== e.elem.nodeType ||
              (null != e.elem[e.prop] && null == e.elem.style[e.prop])
              ? e.elem[e.prop]
              : ((t = re.css(e.elem, e.prop, "")), t && "auto" !== t ? t : 0);
          },
          set: function (e) {
            re.fx.step[e.prop]
              ? re.fx.step[e.prop](e)
              : 1 !== e.elem.nodeType ||
                (null == e.elem.style[re.cssProps[e.prop]] &&
                  !re.cssHooks[e.prop])
              ? (e.elem[e.prop] = e.now)
              : re.style(e.elem, e.prop, e.now + e.unit);
          },
        },
      }),
      (H.propHooks.scrollTop = H.propHooks.scrollLeft = {
        set: function (e) {
          e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
        },
      }),
      (re.easing = {
        linear: function (e) {
          return e;
        },
        swing: function (e) {
          return 0.5 - Math.cos(e * Math.PI) / 2;
        },
        _default: "swing",
      }),
      (re.fx = H.prototype.init),
      (re.fx.step = {});
    var ot,
      rt,
      st = /^(?:toggle|show|hide)$/,
      at = /queueHooks$/;
    (re.Animation = re.extend(I, {
      tweeners: {
        "*": [
          function (e, t) {
            var n = this.createTween(e, t);
            return u(n.elem, e, Ne.exec(t), n), n;
          },
        ],
      },
      tweener: function (e, t) {
        re.isFunction(e) ? ((t = e), (e = ["*"])) : (e = e.match(xe));
        for (var n, i = 0, o = e.length; o > i; i++)
          (n = e[i]),
            (I.tweeners[n] = I.tweeners[n] || []),
            I.tweeners[n].unshift(t);
      },
      prefilters: [_],
      prefilter: function (e, t) {
        t ? I.prefilters.unshift(e) : I.prefilters.push(e);
      },
    })),
      (re.speed = function (e, t, n) {
        var i =
          e && "object" == typeof e
            ? re.extend({}, e)
            : {
                complete: n || (!n && t) || (re.isFunction(e) && e),
                duration: e,
                easing: (n && t) || (t && !re.isFunction(t) && t),
              };
        return (
          (i.duration = re.fx.off
            ? 0
            : "number" == typeof i.duration
            ? i.duration
            : i.duration in re.fx.speeds
            ? re.fx.speeds[i.duration]
            : re.fx.speeds._default),
          (null != i.queue && i.queue !== !0) || (i.queue = "fx"),
          (i.old = i.complete),
          (i.complete = function () {
            re.isFunction(i.old) && i.old.call(this),
              i.queue && re.dequeue(this, i.queue);
          }),
          i
        );
      }),
      re.fn.extend({
        fadeTo: function (e, t, n, i) {
          return this.filter(Oe)
            .css("opacity", 0)
            .show()
            .end()
            .animate({ opacity: t }, e, n, i);
        },
        animate: function (e, t, n, i) {
          var o = re.isEmptyObject(e),
            r = re.speed(t, n, i),
            s = function () {
              var t = I(this, re.extend({}, e), r);
              (o || Ce.get(this, "finish")) && t.stop(!0);
            };
          return (
            (s.finish = s),
            o || r.queue === !1 ? this.each(s) : this.queue(r.queue, s)
          );
        },
        stop: function (e, t, n) {
          var i = function (e) {
            var t = e.stop;
            delete e.stop, t(n);
          };
          return (
            "string" != typeof e && ((n = t), (t = e), (e = void 0)),
            t && e !== !1 && this.queue(e || "fx", []),
            this.each(function () {
              var t = !0,
                o = null != e && e + "queueHooks",
                r = re.timers,
                s = Ce.get(this);
              if (o) s[o] && s[o].stop && i(s[o]);
              else for (o in s) s[o] && s[o].stop && at.test(o) && i(s[o]);
              for (o = r.length; o--; )
                r[o].elem !== this ||
                  (null != e && r[o].queue !== e) ||
                  (r[o].anim.stop(n), (t = !1), r.splice(o, 1));
              (!t && n) || re.dequeue(this, e);
            })
          );
        },
        finish: function (e) {
          return (
            e !== !1 && (e = e || "fx"),
            this.each(function () {
              var t,
                n = Ce.get(this),
                i = n[e + "queue"],
                o = n[e + "queueHooks"],
                r = re.timers,
                s = i ? i.length : 0;
              for (
                n.finish = !0,
                  re.queue(this, e, []),
                  o && o.stop && o.stop.call(this, !0),
                  t = r.length;
                t--;

              )
                r[t].elem === this &&
                  r[t].queue === e &&
                  (r[t].anim.stop(!0), r.splice(t, 1));
              for (t = 0; s > t; t++)
                i[t] && i[t].finish && i[t].finish.call(this);
              delete n.finish;
            })
          );
        },
      }),
      re.each(["toggle", "show", "hide"], function (e, t) {
        var n = re.fn[t];
        re.fn[t] = function (e, i, o) {
          return null == e || "boolean" == typeof e
            ? n.apply(this, arguments)
            : this.animate(P(t, !0), e, i, o);
        };
      }),
      re.each(
        {
          slideDown: P("show"),
          slideUp: P("hide"),
          slideToggle: P("toggle"),
          fadeIn: { opacity: "show" },
          fadeOut: { opacity: "hide" },
          fadeToggle: { opacity: "toggle" },
        },
        function (e, t) {
          re.fn[e] = function (e, n, i) {
            return this.animate(t, e, n, i);
          };
        }
      ),
      (re.timers = []),
      (re.fx.tick = function () {
        var e,
          t = 0,
          n = re.timers;
        for (ot = re.now(); t < n.length; t++)
          (e = n[t]), e() || n[t] !== e || n.splice(t--, 1);
        n.length || re.fx.stop(), (ot = void 0);
      }),
      (re.fx.timer = function (e) {
        re.timers.push(e), e() ? re.fx.start() : re.timers.pop();
      }),
      (re.fx.interval = 13),
      (re.fx.start = function () {
        rt || (rt = e.setInterval(re.fx.tick, re.fx.interval));
      }),
      (re.fx.stop = function () {
        e.clearInterval(rt), (rt = null);
      }),
      (re.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
      (re.fn.delay = function (t, n) {
        return (
          (t = re.fx ? re.fx.speeds[t] || t : t),
          (n = n || "fx"),
          this.queue(n, function (n, i) {
            var o = e.setTimeout(n, t);
            i.stop = function () {
              e.clearTimeout(o);
            };
          })
        );
      }),
      (function () {
        var e = G.createElement("input"),
          t = G.createElement("select"),
          n = t.appendChild(G.createElement("option"));
        (e.type = "checkbox"),
          (ie.checkOn = "" !== e.value),
          (ie.optSelected = n.selected),
          (t.disabled = !0),
          (ie.optDisabled = !n.disabled),
          (e = G.createElement("input")),
          (e.value = "t"),
          (e.type = "radio"),
          (ie.radioValue = "t" === e.value);
      })();
    var lt,
      ut = re.expr.attrHandle;
    re.fn.extend({
      attr: function (e, t) {
        return Te(this, re.attr, e, t, arguments.length > 1);
      },
      removeAttr: function (e) {
        return this.each(function () {
          re.removeAttr(this, e);
        });
      },
    }),
      re.extend({
        attr: function (e, t, n) {
          var i,
            o,
            r = e.nodeType;
          if (3 !== r && 8 !== r && 2 !== r)
            return "undefined" == typeof e.getAttribute
              ? re.prop(e, t, n)
              : ((1 === r && re.isXMLDoc(e)) ||
                  ((t = t.toLowerCase()),
                  (o =
                    re.attrHooks[t] ||
                    (re.expr.match.bool.test(t) ? lt : void 0))),
                void 0 !== n
                  ? null === n
                    ? void re.removeAttr(e, t)
                    : o && "set" in o && void 0 !== (i = o.set(e, n, t))
                    ? i
                    : (e.setAttribute(t, n + ""), n)
                  : o && "get" in o && null !== (i = o.get(e, t))
                  ? i
                  : ((i = re.find.attr(e, t)), null == i ? void 0 : i));
        },
        attrHooks: {
          type: {
            set: function (e, t) {
              if (!ie.radioValue && "radio" === t && re.nodeName(e, "input")) {
                var n = e.value;
                return e.setAttribute("type", t), n && (e.value = n), t;
              }
            },
          },
        },
        removeAttr: function (e, t) {
          var n,
            i,
            o = 0,
            r = t && t.match(xe);
          if (r && 1 === e.nodeType)
            for (; (n = r[o++]); )
              (i = re.propFix[n] || n),
                re.expr.match.bool.test(n) && (e[i] = !1),
                e.removeAttribute(n);
        },
      }),
      (lt = {
        set: function (e, t, n) {
          return t === !1 ? re.removeAttr(e, n) : e.setAttribute(n, n), n;
        },
      }),
      re.each(re.expr.match.bool.source.match(/\w+/g), function (e, t) {
        var n = ut[t] || re.find.attr;
        ut[t] = function (e, t, i) {
          var o, r;
          return (
            i ||
              ((r = ut[t]),
              (ut[t] = o),
              (o = null != n(e, t, i) ? t.toLowerCase() : null),
              (ut[t] = r)),
            o
          );
        };
      });
    var ct = /^(?:input|select|textarea|button)$/i,
      dt = /^(?:a|area)$/i;
    re.fn.extend({
      prop: function (e, t) {
        return Te(this, re.prop, e, t, arguments.length > 1);
      },
      removeProp: function (e) {
        return this.each(function () {
          delete this[re.propFix[e] || e];
        });
      },
    }),
      re.extend({
        prop: function (e, t, n) {
          var i,
            o,
            r = e.nodeType;
          if (3 !== r && 8 !== r && 2 !== r)
            return (
              (1 === r && re.isXMLDoc(e)) ||
                ((t = re.propFix[t] || t), (o = re.propHooks[t])),
              void 0 !== n
                ? o && "set" in o && void 0 !== (i = o.set(e, n, t))
                  ? i
                  : (e[t] = n)
                : o && "get" in o && null !== (i = o.get(e, t))
                ? i
                : e[t]
            );
        },
        propHooks: {
          tabIndex: {
            get: function (e) {
              var t = re.find.attr(e, "tabindex");
              return t
                ? parseInt(t, 10)
                : ct.test(e.nodeName) || (dt.test(e.nodeName) && e.href)
                ? 0
                : -1;
            },
          },
        },
        propFix: { for: "htmlFor", class: "className" },
      }),
      ie.optSelected ||
        (re.propHooks.selected = {
          get: function (e) {
            var t = e.parentNode;
            return t && t.parentNode && t.parentNode.selectedIndex, null;
          },
          set: function (e) {
            var t = e.parentNode;
            t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex);
          },
        }),
      re.each(
        [
          "tabIndex",
          "readOnly",
          "maxLength",
          "cellSpacing",
          "cellPadding",
          "rowSpan",
          "colSpan",
          "useMap",
          "frameBorder",
          "contentEditable",
        ],
        function () {
          re.propFix[this.toLowerCase()] = this;
        }
      );
    var pt = /[\t\r\n\f]/g;
    re.fn.extend({
      addClass: function (e) {
        var t,
          n,
          i,
          o,
          r,
          s,
          a,
          l = 0;
        if (re.isFunction(e))
          return this.each(function (t) {
            re(this).addClass(e.call(this, t, F(this)));
          });
        if ("string" == typeof e && e)
          for (t = e.match(xe) || []; (n = this[l++]); )
            if (
              ((o = F(n)),
              (i = 1 === n.nodeType && (" " + o + " ").replace(pt, " ")))
            ) {
              for (s = 0; (r = t[s++]); )
                i.indexOf(" " + r + " ") < 0 && (i += r + " ");
              (a = re.trim(i)), o !== a && n.setAttribute("class", a);
            }
        return this;
      },
      removeClass: function (e) {
        var t,
          n,
          i,
          o,
          r,
          s,
          a,
          l = 0;
        if (re.isFunction(e))
          return this.each(function (t) {
            re(this).removeClass(e.call(this, t, F(this)));
          });
        if (!arguments.length) return this.attr("class", "");
        if ("string" == typeof e && e)
          for (t = e.match(xe) || []; (n = this[l++]); )
            if (
              ((o = F(n)),
              (i = 1 === n.nodeType && (" " + o + " ").replace(pt, " ")))
            ) {
              for (s = 0; (r = t[s++]); )
                for (; i.indexOf(" " + r + " ") > -1; )
                  i = i.replace(" " + r + " ", " ");
              (a = re.trim(i)), o !== a && n.setAttribute("class", a);
            }
        return this;
      },
      toggleClass: function (e, t) {
        var n = typeof e;
        return "boolean" == typeof t && "string" === n
          ? t
            ? this.addClass(e)
            : this.removeClass(e)
          : re.isFunction(e)
          ? this.each(function (n) {
              re(this).toggleClass(e.call(this, n, F(this), t), t);
            })
          : this.each(function () {
              var t, i, o, r;
              if ("string" === n)
                for (i = 0, o = re(this), r = e.match(xe) || []; (t = r[i++]); )
                  o.hasClass(t) ? o.removeClass(t) : o.addClass(t);
              else
                (void 0 !== e && "boolean" !== n) ||
                  ((t = F(this)),
                  t && Ce.set(this, "__className__", t),
                  this.setAttribute &&
                    this.setAttribute(
                      "class",
                      t || e === !1 ? "" : Ce.get(this, "__className__") || ""
                    ));
            });
      },
      hasClass: function (e) {
        var t,
          n,
          i = 0;
        for (t = " " + e + " "; (n = this[i++]); )
          if (
            1 === n.nodeType &&
            (" " + F(n) + " ").replace(pt, " ").indexOf(t) > -1
          )
            return !0;
        return !1;
      },
    });
    var ft = /\r/g,
      ht = /[\x20\t\r\n\f]+/g;
    re.fn.extend({
      val: function (e) {
        var t,
          n,
          i,
          o = this[0];
        return arguments.length
          ? ((i = re.isFunction(e)),
            this.each(function (n) {
              var o;
              1 === this.nodeType &&
                ((o = i ? e.call(this, n, re(this).val()) : e),
                null == o
                  ? (o = "")
                  : "number" == typeof o
                  ? (o += "")
                  : re.isArray(o) &&
                    (o = re.map(o, function (e) {
                      return null == e ? "" : e + "";
                    })),
                (t =
                  re.valHooks[this.type] ||
                  re.valHooks[this.nodeName.toLowerCase()]),
                (t && "set" in t && void 0 !== t.set(this, o, "value")) ||
                  (this.value = o));
            }))
          : o
          ? ((t = re.valHooks[o.type] || re.valHooks[o.nodeName.toLowerCase()]),
            t && "get" in t && void 0 !== (n = t.get(o, "value"))
              ? n
              : ((n = o.value),
                "string" == typeof n ? n.replace(ft, "") : null == n ? "" : n))
          : void 0;
      },
    }),
      re.extend({
        valHooks: {
          option: {
            get: function (e) {
              var t = re.find.attr(e, "value");
              return null != t ? t : re.trim(re.text(e)).replace(ht, " ");
            },
          },
          select: {
            get: function (e) {
              for (
                var t,
                  n,
                  i = e.options,
                  o = e.selectedIndex,
                  r = "select-one" === e.type || 0 > o,
                  s = r ? null : [],
                  a = r ? o + 1 : i.length,
                  l = 0 > o ? a : r ? o : 0;
                a > l;
                l++
              )
                if (
                  ((n = i[l]),
                  (n.selected || l === o) &&
                    (ie.optDisabled
                      ? !n.disabled
                      : null === n.getAttribute("disabled")) &&
                    (!n.parentNode.disabled ||
                      !re.nodeName(n.parentNode, "optgroup")))
                ) {
                  if (((t = re(n).val()), r)) return t;
                  s.push(t);
                }
              return s;
            },
            set: function (e, t) {
              for (
                var n, i, o = e.options, r = re.makeArray(t), s = o.length;
                s--;

              )
                (i = o[s]),
                  (i.selected =
                    re.inArray(re.valHooks.option.get(i), r) > -1) && (n = !0);
              return n || (e.selectedIndex = -1), r;
            },
          },
        },
      }),
      re.each(["radio", "checkbox"], function () {
        (re.valHooks[this] = {
          set: function (e, t) {
            return re.isArray(t)
              ? (e.checked = re.inArray(re(e).val(), t) > -1)
              : void 0;
          },
        }),
          ie.checkOn ||
            (re.valHooks[this].get = function (e) {
              return null === e.getAttribute("value") ? "on" : e.value;
            });
      });
    var vt = /^(?:focusinfocus|focusoutblur)$/;
    re.extend(re.event, {
      trigger: function (t, n, i, o) {
        var r,
          s,
          a,
          l,
          u,
          c,
          d,
          p = [i || G],
          f = ne.call(t, "type") ? t.type : t,
          h = ne.call(t, "namespace") ? t.namespace.split(".") : [];
        if (
          ((s = a = i = i || G),
          3 !== i.nodeType &&
            8 !== i.nodeType &&
            !vt.test(f + re.event.triggered) &&
            (f.indexOf(".") > -1 &&
              ((h = f.split(".")), (f = h.shift()), h.sort()),
            (u = f.indexOf(":") < 0 && "on" + f),
            (t = t[re.expando]
              ? t
              : new re.Event(f, "object" == typeof t && t)),
            (t.isTrigger = o ? 2 : 3),
            (t.namespace = h.join(".")),
            (t.rnamespace = t.namespace
              ? new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)")
              : null),
            (t.result = void 0),
            t.target || (t.target = i),
            (n = null == n ? [t] : re.makeArray(n, [t])),
            (d = re.event.special[f] || {}),
            o || !d.trigger || d.trigger.apply(i, n) !== !1))
        ) {
          if (!o && !d.noBubble && !re.isWindow(i)) {
            for (
              l = d.delegateType || f, vt.test(l + f) || (s = s.parentNode);
              s;
              s = s.parentNode
            )
              p.push(s), (a = s);
            a === (i.ownerDocument || G) &&
              p.push(a.defaultView || a.parentWindow || e);
          }
          for (r = 0; (s = p[r++]) && !t.isPropagationStopped(); )
            (t.type = r > 1 ? l : d.bindType || f),
              (c = (Ce.get(s, "events") || {})[t.type] && Ce.get(s, "handle")),
              c && c.apply(s, n),
              (c = u && s[u]),
              c &&
                c.apply &&
                Se(s) &&
                ((t.result = c.apply(s, n)),
                t.result === !1 && t.preventDefault());
          return (
            (t.type = f),
            o ||
              t.isDefaultPrevented() ||
              (d._default && d._default.apply(p.pop(), n) !== !1) ||
              !Se(i) ||
              (u &&
                re.isFunction(i[f]) &&
                !re.isWindow(i) &&
                ((a = i[u]),
                a && (i[u] = null),
                (re.event.triggered = f),
                i[f](),
                (re.event.triggered = void 0),
                a && (i[u] = a))),
            t.result
          );
        }
      },
      simulate: function (e, t, n) {
        var i = re.extend(new re.Event(), n, { type: e, isSimulated: !0 });
        re.event.trigger(i, null, t),
          i.isDefaultPrevented() && n.preventDefault();
      },
    }),
      re.fn.extend({
        trigger: function (e, t) {
          return this.each(function () {
            re.event.trigger(e, t, this);
          });
        },
        triggerHandler: function (e, t) {
          var n = this[0];
          return n ? re.event.trigger(e, t, n, !0) : void 0;
        },
      }),
      re.each(
        "blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(
          " "
        ),
        function (e, t) {
          re.fn[t] = function (e, n) {
            return arguments.length > 0
              ? this.on(t, null, e, n)
              : this.trigger(t);
          };
        }
      ),
      re.fn.extend({
        hover: function (e, t) {
          return this.mouseenter(e).mouseleave(t || e);
        },
      }),
      (ie.focusin = "onfocusin" in e),
      ie.focusin ||
        re.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
          var n = function (e) {
            re.event.simulate(t, e.target, re.event.fix(e));
          };
          re.event.special[t] = {
            setup: function () {
              var i = this.ownerDocument || this,
                o = Ce.access(i, t);
              o || i.addEventListener(e, n, !0), Ce.access(i, t, (o || 0) + 1);
            },
            teardown: function () {
              var i = this.ownerDocument || this,
                o = Ce.access(i, t) - 1;
              o
                ? Ce.access(i, t, o)
                : (i.removeEventListener(e, n, !0), Ce.remove(i, t));
            },
          };
        });
    var gt = e.location,
      mt = re.now(),
      yt = /\?/;
    (re.parseJSON = function (e) {
      return JSON.parse(e + "");
    }),
      (re.parseXML = function (t) {
        var n;
        if (!t || "string" != typeof t) return null;
        try {
          n = new e.DOMParser().parseFromString(t, "text/xml");
        } catch (e) {
          n = void 0;
        }
        return (
          (n && !n.getElementsByTagName("parsererror").length) ||
            re.error("Invalid XML: " + t),
          n
        );
      });
    var bt = /#.*$/,
      wt = /([?&])_=[^&]*/,
      xt = /^(.*?):[ \t]*([^\r\n]*)$/gm,
      kt = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
      Tt = /^(?:GET|HEAD)$/,
      St = /^\/\//,
      Ct = {},
      $t = {},
      Et = "*/".concat("*"),
      At = G.createElement("a");
    (At.href = gt.href),
      re.extend({
        active: 0,
        lastModified: {},
        etag: {},
        ajaxSettings: {
          url: gt.href,
          type: "GET",
          isLocal: kt.test(gt.protocol),
          global: !0,
          processData: !0,
          async: !0,
          contentType: "application/x-www-form-urlencoded; charset=UTF-8",
          accepts: {
            "*": Et,
            text: "text/plain",
            html: "text/html",
            xml: "application/xml, text/xml",
            json: "application/json, text/javascript",
          },
          contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
          responseFields: {
            xml: "responseXML",
            text: "responseText",
            json: "responseJSON",
          },
          converters: {
            "* text": String,
            "text html": !0,
            "text json": re.parseJSON,
            "text xml": re.parseXML,
          },
          flatOptions: { url: !0, context: !0 },
        },
        ajaxSetup: function (e, t) {
          return t ? W(W(e, re.ajaxSettings), t) : W(re.ajaxSettings, e);
        },
        ajaxPrefilter: M(Ct),
        ajaxTransport: M($t),
        ajax: function (t, n) {
          function i(t, n, i, a) {
            var u,
              d,
              y,
              b,
              x,
              T = n;
            2 !== w &&
              ((w = 2),
              l && e.clearTimeout(l),
              (o = void 0),
              (s = a || ""),
              (k.readyState = t > 0 ? 4 : 0),
              (u = (t >= 200 && 300 > t) || 304 === t),
              i && (b = B(p, k, i)),
              (b = U(p, b, k, u)),
              u
                ? (p.ifModified &&
                    ((x = k.getResponseHeader("Last-Modified")),
                    x && (re.lastModified[r] = x),
                    (x = k.getResponseHeader("etag")),
                    x && (re.etag[r] = x)),
                  204 === t || "HEAD" === p.type
                    ? (T = "nocontent")
                    : 304 === t
                    ? (T = "notmodified")
                    : ((T = b.state), (d = b.data), (y = b.error), (u = !y)))
                : ((y = T), (!t && T) || ((T = "error"), 0 > t && (t = 0))),
              (k.status = t),
              (k.statusText = (n || T) + ""),
              u ? v.resolveWith(f, [d, T, k]) : v.rejectWith(f, [k, T, y]),
              k.statusCode(m),
              (m = void 0),
              c &&
                h.trigger(u ? "ajaxSuccess" : "ajaxError", [k, p, u ? d : y]),
              g.fireWith(f, [k, T]),
              c &&
                (h.trigger("ajaxComplete", [k, p]),
                --re.active || re.event.trigger("ajaxStop")));
          }
          "object" == typeof t && ((n = t), (t = void 0)), (n = n || {});
          var o,
            r,
            s,
            a,
            l,
            u,
            c,
            d,
            p = re.ajaxSetup({}, n),
            f = p.context || p,
            h = p.context && (f.nodeType || f.jquery) ? re(f) : re.event,
            v = re.Deferred(),
            g = re.Callbacks("once memory"),
            m = p.statusCode || {},
            y = {},
            b = {},
            w = 0,
            x = "canceled",
            k = {
              readyState: 0,
              getResponseHeader: function (e) {
                var t;
                if (2 === w) {
                  if (!a)
                    for (a = {}; (t = xt.exec(s)); )
                      a[t[1].toLowerCase()] = t[2];
                  t = a[e.toLowerCase()];
                }
                return null == t ? null : t;
              },
              getAllResponseHeaders: function () {
                return 2 === w ? s : null;
              },
              setRequestHeader: function (e, t) {
                var n = e.toLowerCase();
                return w || ((e = b[n] = b[n] || e), (y[e] = t)), this;
              },
              overrideMimeType: function (e) {
                return w || (p.mimeType = e), this;
              },
              statusCode: function (e) {
                var t;
                if (e)
                  if (2 > w) for (t in e) m[t] = [m[t], e[t]];
                  else k.always(e[k.status]);
                return this;
              },
              abort: function (e) {
                var t = e || x;
                return o && o.abort(t), i(0, t), this;
              },
            };
          if (
            ((v.promise(k).complete = g.add),
            (k.success = k.done),
            (k.error = k.fail),
            (p.url = ((t || p.url || gt.href) + "")
              .replace(bt, "")
              .replace(St, gt.protocol + "//")),
            (p.type = n.method || n.type || p.method || p.type),
            (p.dataTypes = re
              .trim(p.dataType || "*")
              .toLowerCase()
              .match(xe) || [""]),
            null == p.crossDomain)
          ) {
            u = G.createElement("a");
            try {
              (u.href = p.url),
                (u.href = u.href),
                (p.crossDomain =
                  At.protocol + "//" + At.host != u.protocol + "//" + u.host);
            } catch (e) {
              p.crossDomain = !0;
            }
          }
          if (
            (p.data &&
              p.processData &&
              "string" != typeof p.data &&
              (p.data = re.param(p.data, p.traditional)),
            R(Ct, p, n, k),
            2 === w)
          )
            return k;
          (c = re.event && p.global),
            c && 0 === re.active++ && re.event.trigger("ajaxStart"),
            (p.type = p.type.toUpperCase()),
            (p.hasContent = !Tt.test(p.type)),
            (r = p.url),
            p.hasContent ||
              (p.data &&
                ((r = p.url += (yt.test(r) ? "&" : "?") + p.data),
                delete p.data),
              p.cache === !1 &&
                (p.url = wt.test(r)
                  ? r.replace(wt, "$1_=" + mt++)
                  : r + (yt.test(r) ? "&" : "?") + "_=" + mt++)),
            p.ifModified &&
              (re.lastModified[r] &&
                k.setRequestHeader("If-Modified-Since", re.lastModified[r]),
              re.etag[r] && k.setRequestHeader("If-None-Match", re.etag[r])),
            ((p.data && p.hasContent && p.contentType !== !1) ||
              n.contentType) &&
              k.setRequestHeader("Content-Type", p.contentType),
            k.setRequestHeader(
              "Accept",
              p.dataTypes[0] && p.accepts[p.dataTypes[0]]
                ? p.accepts[p.dataTypes[0]] +
                    ("*" !== p.dataTypes[0] ? ", " + Et + "; q=0.01" : "")
                : p.accepts["*"]
            );
          for (d in p.headers) k.setRequestHeader(d, p.headers[d]);
          if (p.beforeSend && (p.beforeSend.call(f, k, p) === !1 || 2 === w))
            return k.abort();
          x = "abort";
          for (d in { success: 1, error: 1, complete: 1 }) k[d](p[d]);
          if ((o = R($t, p, n, k))) {
            if (
              ((k.readyState = 1), c && h.trigger("ajaxSend", [k, p]), 2 === w)
            )
              return k;
            p.async &&
              p.timeout > 0 &&
              (l = e.setTimeout(function () {
                k.abort("timeout");
              }, p.timeout));
            try {
              (w = 1), o.send(y, i);
            } catch (e) {
              if (!(2 > w)) throw e;
              i(-1, e);
            }
          } else i(-1, "No Transport");
          return k;
        },
        getJSON: function (e, t, n) {
          return re.get(e, t, n, "json");
        },
        getScript: function (e, t) {
          return re.get(e, void 0, t, "script");
        },
      }),
      re.each(["get", "post"], function (e, t) {
        re[t] = function (e, n, i, o) {
          return (
            re.isFunction(n) && ((o = o || i), (i = n), (n = void 0)),
            re.ajax(
              re.extend(
                { url: e, type: t, dataType: o, data: n, success: i },
                re.isPlainObject(e) && e
              )
            )
          );
        };
      }),
      (re._evalUrl = function (e) {
        return re.ajax({
          url: e,
          type: "GET",
          dataType: "script",
          async: !1,
          global: !1,
          throws: !0,
        });
      }),
      re.fn.extend({
        wrapAll: function (e) {
          var t;
          return re.isFunction(e)
            ? this.each(function (t) {
                re(this).wrapAll(e.call(this, t));
              })
            : (this[0] &&
                ((t = re(e, this[0].ownerDocument).eq(0).clone(!0)),
                this[0].parentNode && t.insertBefore(this[0]),
                t
                  .map(function () {
                    for (var e = this; e.firstElementChild; )
                      e = e.firstElementChild;
                    return e;
                  })
                  .append(this)),
              this);
        },
        wrapInner: function (e) {
          return re.isFunction(e)
            ? this.each(function (t) {
                re(this).wrapInner(e.call(this, t));
              })
            : this.each(function () {
                var t = re(this),
                  n = t.contents();
                n.length ? n.wrapAll(e) : t.append(e);
              });
        },
        wrap: function (e) {
          var t = re.isFunction(e);
          return this.each(function (n) {
            re(this).wrapAll(t ? e.call(this, n) : e);
          });
        },
        unwrap: function () {
          return this.parent()
            .each(function () {
              re.nodeName(this, "body") ||
                re(this).replaceWith(this.childNodes);
            })
            .end();
        },
      }),
      (re.expr.filters.hidden = function (e) {
        return !re.expr.filters.visible(e);
      }),
      (re.expr.filters.visible = function (e) {
        return (
          e.offsetWidth > 0 ||
          e.offsetHeight > 0 ||
          e.getClientRects().length > 0
        );
      });
    var jt = /%20/g,
      Nt = /\[\]$/,
      Dt = /\r?\n/g,
      Ot = /^(?:submit|button|image|reset|file)$/i,
      Ht = /^(?:input|select|textarea|keygen)/i;
    (re.param = function (e, t) {
      var n,
        i = [],
        o = function (e, t) {
          (t = re.isFunction(t) ? t() : null == t ? "" : t),
            (i[i.length] = encodeURIComponent(e) + "=" + encodeURIComponent(t));
        };
      if (
        (void 0 === t && (t = re.ajaxSettings && re.ajaxSettings.traditional),
        re.isArray(e) || (e.jquery && !re.isPlainObject(e)))
      )
        re.each(e, function () {
          o(this.name, this.value);
        });
      else for (n in e) X(n, e[n], t, o);
      return i.join("&").replace(jt, "+");
    }),
      re.fn.extend({
        serialize: function () {
          return re.param(this.serializeArray());
        },
        serializeArray: function () {
          return this.map(function () {
            var e = re.prop(this, "elements");
            return e ? re.makeArray(e) : this;
          })
            .filter(function () {
              var e = this.type;
              return (
                this.name &&
                !re(this).is(":disabled") &&
                Ht.test(this.nodeName) &&
                !Ot.test(e) &&
                (this.checked || !He.test(e))
              );
            })
            .map(function (e, t) {
              var n = re(this).val();
              return null == n
                ? null
                : re.isArray(n)
                ? re.map(n, function (e) {
                    return { name: t.name, value: e.replace(Dt, "\r\n") };
                  })
                : { name: t.name, value: n.replace(Dt, "\r\n") };
            })
            .get();
        },
      }),
      (re.ajaxSettings.xhr = function () {
        try {
          return new e.XMLHttpRequest();
        } catch (e) {}
      });
    var qt = { 0: 200, 1223: 204 },
      Pt = re.ajaxSettings.xhr();
    (ie.cors = !!Pt && "withCredentials" in Pt),
      (ie.ajax = Pt = !!Pt),
      re.ajaxTransport(function (t) {
        var n, i;
        return ie.cors || (Pt && !t.crossDomain)
          ? {
              send: function (o, r) {
                var s,
                  a = t.xhr();
                if (
                  (a.open(t.type, t.url, t.async, t.username, t.password),
                  t.xhrFields)
                )
                  for (s in t.xhrFields) a[s] = t.xhrFields[s];
                t.mimeType &&
                  a.overrideMimeType &&
                  a.overrideMimeType(t.mimeType),
                  t.crossDomain ||
                    o["X-Requested-With"] ||
                    (o["X-Requested-With"] = "XMLHttpRequest");
                for (s in o) a.setRequestHeader(s, o[s]);
                (n = function (e) {
                  return function () {
                    n &&
                      ((n = i = a.onload = a.onerror = a.onabort = a.onreadystatechange = null),
                      "abort" === e
                        ? a.abort()
                        : "error" === e
                        ? "number" != typeof a.status
                          ? r(0, "error")
                          : r(a.status, a.statusText)
                        : r(
                            qt[a.status] || a.status,
                            a.statusText,
                            "text" !== (a.responseType || "text") ||
                              "string" != typeof a.responseText
                              ? { binary: a.response }
                              : { text: a.responseText },
                            a.getAllResponseHeaders()
                          ));
                  };
                }),
                  (a.onload = n()),
                  (i = a.onerror = n("error")),
                  void 0 !== a.onabort
                    ? (a.onabort = i)
                    : (a.onreadystatechange = function () {
                        4 === a.readyState &&
                          e.setTimeout(function () {
                            n && i();
                          });
                      }),
                  (n = n("abort"));
                try {
                  a.send((t.hasContent && t.data) || null);
                } catch (e) {
                  if (n) throw e;
                }
              },
              abort: function () {
                n && n();
              },
            }
          : void 0;
      }),
      re.ajaxSetup({
        accepts: {
          script:
            "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript",
        },
        contents: { script: /\b(?:java|ecma)script\b/ },
        converters: {
          "text script": function (e) {
            return re.globalEval(e), e;
          },
        },
      }),
      re.ajaxPrefilter("script", function (e) {
        void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET");
      }),
      re.ajaxTransport("script", function (e) {
        if (e.crossDomain) {
          var t, n;
          return {
            send: function (i, o) {
              (t = re("<script>")
                .prop({ charset: e.scriptCharset, src: e.url })
                .on(
                  "load error",
                  (n = function (e) {
                    t.remove(),
                      (n = null),
                      e && o("error" === e.type ? 404 : 200, e.type);
                  })
                )),
                G.head.appendChild(t[0]);
            },
            abort: function () {
              n && n();
            },
          };
        }
      });
    var Lt = [],
      _t = /(=)\?(?=&|$)|\?\?/;
    re.ajaxSetup({
      jsonp: "callback",
      jsonpCallback: function () {
        var e = Lt.pop() || re.expando + "_" + mt++;
        return (this[e] = !0), e;
      },
    }),
      re.ajaxPrefilter("json jsonp", function (t, n, i) {
        var o,
          r,
          s,
          a =
            t.jsonp !== !1 &&
            (_t.test(t.url)
              ? "url"
              : "string" == typeof t.data &&
                0 ===
                  (t.contentType || "").indexOf(
                    "application/x-www-form-urlencoded"
                  ) &&
                _t.test(t.data) &&
                "data");
        return a || "jsonp" === t.dataTypes[0]
          ? ((o = t.jsonpCallback = re.isFunction(t.jsonpCallback)
              ? t.jsonpCallback()
              : t.jsonpCallback),
            a
              ? (t[a] = t[a].replace(_t, "$1" + o))
              : t.jsonp !== !1 &&
                (t.url += (yt.test(t.url) ? "&" : "?") + t.jsonp + "=" + o),
            (t.converters["script json"] = function () {
              return s || re.error(o + " was not called"), s[0];
            }),
            (t.dataTypes[0] = "json"),
            (r = e[o]),
            (e[o] = function () {
              s = arguments;
            }),
            i.always(function () {
              void 0 === r ? re(e).removeProp(o) : (e[o] = r),
                t[o] && ((t.jsonpCallback = n.jsonpCallback), Lt.push(o)),
                s && re.isFunction(r) && r(s[0]),
                (s = r = void 0);
            }),
            "script")
          : void 0;
      }),
      (re.parseHTML = function (e, t, n) {
        if (!e || "string" != typeof e) return null;
        "boolean" == typeof t && ((n = t), (t = !1)), (t = t || G);
        var i = he.exec(e),
          o = !n && [];
        return i
          ? [t.createElement(i[1])]
          : ((i = p([e], t, o)),
            o && o.length && re(o).remove(),
            re.merge([], i.childNodes));
      });
    var zt = re.fn.load;
    (re.fn.load = function (e, t, n) {
      if ("string" != typeof e && zt) return zt.apply(this, arguments);
      var i,
        o,
        r,
        s = this,
        a = e.indexOf(" ");
      return (
        a > -1 && ((i = re.trim(e.slice(a))), (e = e.slice(0, a))),
        re.isFunction(t)
          ? ((n = t), (t = void 0))
          : t && "object" == typeof t && (o = "POST"),
        s.length > 0 &&
          re
            .ajax({ url: e, type: o || "GET", dataType: "html", data: t })
            .done(function (e) {
              (r = arguments),
                s.html(i ? re("<div>").append(re.parseHTML(e)).find(i) : e);
            })
            .always(
              n &&
                function (e, t) {
                  s.each(function () {
                    n.apply(this, r || [e.responseText, t, e]);
                  });
                }
            ),
        this
      );
    }),
      re.each(
        [
          "ajaxStart",
          "ajaxStop",
          "ajaxComplete",
          "ajaxError",
          "ajaxSuccess",
          "ajaxSend",
        ],
        function (e, t) {
          re.fn[t] = function (e) {
            return this.on(t, e);
          };
        }
      ),
      (re.expr.filters.animated = function (e) {
        return re.grep(re.timers, function (t) {
          return e === t.elem;
        }).length;
      }),
      (re.offset = {
        setOffset: function (e, t, n) {
          var i,
            o,
            r,
            s,
            a,
            l,
            u,
            c = re.css(e, "position"),
            d = re(e),
            p = {};
          "static" === c && (e.style.position = "relative"),
            (a = d.offset()),
            (r = re.css(e, "top")),
            (l = re.css(e, "left")),
            (u =
              ("absolute" === c || "fixed" === c) &&
              (r + l).indexOf("auto") > -1),
            u
              ? ((i = d.position()), (s = i.top), (o = i.left))
              : ((s = parseFloat(r) || 0), (o = parseFloat(l) || 0)),
            re.isFunction(t) && (t = t.call(e, n, re.extend({}, a))),
            null != t.top && (p.top = t.top - a.top + s),
            null != t.left && (p.left = t.left - a.left + o),
            "using" in t ? t.using.call(e, p) : d.css(p);
        },
      }),
      re.fn.extend({
        offset: function (e) {
          if (arguments.length)
            return void 0 === e
              ? this
              : this.each(function (t) {
                  re.offset.setOffset(this, e, t);
                });
          var t,
            n,
            i = this[0],
            o = { top: 0, left: 0 },
            r = i && i.ownerDocument;
          return r
            ? ((t = r.documentElement),
              re.contains(t, i)
                ? ((o = i.getBoundingClientRect()),
                  (n = Y(r)),
                  {
                    top: o.top + n.pageYOffset - t.clientTop,
                    left: o.left + n.pageXOffset - t.clientLeft,
                  })
                : o)
            : void 0;
        },
        position: function () {
          if (this[0]) {
            var e,
              t,
              n = this[0],
              i = { top: 0, left: 0 };
            return (
              "fixed" === re.css(n, "position")
                ? (t = n.getBoundingClientRect())
                : ((e = this.offsetParent()),
                  (t = this.offset()),
                  re.nodeName(e[0], "html") || (i = e.offset()),
                  (i.top += re.css(e[0], "borderTopWidth", !0)),
                  (i.left += re.css(e[0], "borderLeftWidth", !0))),
              {
                top: t.top - i.top - re.css(n, "marginTop", !0),
                left: t.left - i.left - re.css(n, "marginLeft", !0),
              }
            );
          }
        },
        offsetParent: function () {
          return this.map(function () {
            for (
              var e = this.offsetParent;
              e && "static" === re.css(e, "position");

            )
              e = e.offsetParent;
            return e || Ze;
          });
        },
      }),
      re.each(
        { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" },
        function (e, t) {
          var n = "pageYOffset" === t;
          re.fn[e] = function (i) {
            return Te(
              this,
              function (e, i, o) {
                var r = Y(e);
                return void 0 === o
                  ? r
                    ? r[t]
                    : e[i]
                  : void (r
                      ? r.scrollTo(n ? r.pageXOffset : o, n ? o : r.pageYOffset)
                      : (e[i] = o));
              },
              e,
              i,
              arguments.length
            );
          };
        }
      ),
      re.each(["top", "left"], function (e, t) {
        re.cssHooks[t] = E(ie.pixelPosition, function (e, n) {
          return n
            ? ((n = $(e, t)), Ge.test(n) ? re(e).position()[t] + "px" : n)
            : void 0;
        });
      }),
      re.each({ Height: "height", Width: "width" }, function (e, t) {
        re.each(
          { padding: "inner" + e, content: t, "": "outer" + e },
          function (n, i) {
            re.fn[i] = function (i, o) {
              var r = arguments.length && (n || "boolean" != typeof i),
                s = n || (i === !0 || o === !0 ? "margin" : "border");
              return Te(
                this,
                function (t, n, i) {
                  var o;
                  return re.isWindow(t)
                    ? t.document.documentElement["client" + e]
                    : 9 === t.nodeType
                    ? ((o = t.documentElement),
                      Math.max(
                        t.body["scroll" + e],
                        o["scroll" + e],
                        t.body["offset" + e],
                        o["offset" + e],
                        o["client" + e]
                      ))
                    : void 0 === i
                    ? re.css(t, n, s)
                    : re.style(t, n, i, s);
                },
                t,
                r ? i : void 0,
                r,
                null
              );
            };
          }
        );
      }),
      re.fn.extend({
        bind: function (e, t, n) {
          return this.on(e, null, t, n);
        },
        unbind: function (e, t) {
          return this.off(e, null, t);
        },
        delegate: function (e, t, n, i) {
          return this.on(t, e, n, i);
        },
        undelegate: function (e, t, n) {
          return 1 === arguments.length
            ? this.off(e, "**")
            : this.off(t, e || "**", n);
        },
        size: function () {
          return this.length;
        },
      }),
      (re.fn.andSelf = re.fn.addBack),
      "function" == typeof define &&
        define.amd &&
        define("jquery", [], function () {
          return re;
        });
    var It = e.jQuery,
      Ft = e.$;
    return (
      (re.noConflict = function (t) {
        return (
          e.$ === re && (e.$ = Ft), t && e.jQuery === re && (e.jQuery = It), re
        );
      }),
      t || (e.jQuery = e.$ = re),
      re
    );
  })
  /*!
   * jquery.zoom.min.js
   */,
  /*!
	Zoom 1.7.21
	license: MIT
	http://www.jacklmoore.com/zoom
*/
  (function (e) {
    var t = {
      url: !1,
      callback: !1,
      target: !1,
      duration: 120,
      on: "mouseover",
      touch: !0,
      onZoomIn: !1,
      onZoomOut: !1,
      magnify: 1,
    };
    (e.zoom = function (t, n, i, o) {
      var r,
        s,
        a,
        l,
        u,
        c,
        d,
        p = e(t),
        f = p.css("position"),
        h = e(n);
      return (
        (t.style.position = /(absolute|fixed)/.test(f) ? f : "relative"),
        (t.style.overflow = "hidden"),
        (i.style.width = i.style.height = ""),
        e(i)
          .addClass("zoomImg")
          .css({
            position: "absolute",
            top: 0,
            left: 0,
            opacity: 0,
            width: i.width * o,
            height: i.height * o,
            border: "none",
            maxWidth: "none",
            maxHeight: "none",
          })
          .appendTo(t),
        {
          init: function () {
            (s = p.outerWidth()),
              (r = p.outerHeight()),
              n === t
                ? ((l = s), (a = r))
                : ((l = h.outerWidth()), (a = h.outerHeight())),
              (u = (i.width - s) / l),
              (c = (i.height - r) / a),
              (d = h.offset());
          },
          move: function (e) {
            var t = e.pageX - d.left,
              n = e.pageY - d.top;
            (n = Math.max(Math.min(n, a), 0)),
              (t = Math.max(Math.min(t, l), 0)),
              (i.style.left = t * -u + "px"),
              (i.style.top = n * -c + "px");
          },
        }
      );
    }),
      (e.fn.zoom = function (n) {
        return this.each(function () {
          var i = e.extend({}, t, n || {}),
            o = (i.target && e(i.target)[0]) || this,
            r = this,
            s = e(r),
            a = document.createElement("img"),
            l = e(a),
            u = "mousemove.zoom",
            c = !1,
            d = !1;
          if (!i.url) {
            var p = r.querySelector("img");
            if (
              (p &&
                (i.url = p.getAttribute("data-src") || p.currentSrc || p.src),
              !i.url)
            )
              return;
          }
          s.one(
            "zoom.destroy",
            function (e, t) {
              s.off(".zoom"),
                (o.style.position = e),
                (o.style.overflow = t),
                (a.onload = null),
                l.remove();
            }.bind(this, o.style.position, o.style.overflow)
          ),
            (a.onload = function () {
              function t(t) {
                p.init(),
                  p.move(t),
                  l
                    .stop()
                    .fadeTo(
                      e.support.opacity ? i.duration : 0,
                      1,
                      !!e.isFunction(i.onZoomIn) && i.onZoomIn.call(a)
                    );
              }
              function n() {
                l.stop().fadeTo(
                  i.duration,
                  0,
                  !!e.isFunction(i.onZoomOut) && i.onZoomOut.call(a)
                );
              }
              var p = e.zoom(o, r, a, i.magnify);
              "grab" === i.on
                ? s.on("mousedown.zoom", function (i) {
                    1 === i.which &&
                      (e(document).one("mouseup.zoom", function () {
                        n(), e(document).off(u, p.move);
                      }),
                      t(i),
                      e(document).on(u, p.move),
                      i.preventDefault());
                  })
                : "click" === i.on
                ? s.on("click.zoom", function (i) {
                    return c
                      ? void 0
                      : ((c = !0),
                        t(i),
                        e(document).on(u, p.move),
                        e(document).one("click.zoom", function () {
                          n(), (c = !1), e(document).off(u, p.move);
                        }),
                        !1);
                  })
                : "toggle" === i.on
                ? s.on("click.zoom", function (e) {
                    c ? n() : t(e), (c = !c);
                  })
                : "mouseover" === i.on &&
                  (p.init(),
                  s
                    .on("mouseenter.zoom", t)
                    .on("mouseleave.zoom", n)
                    .on(u, p.move)),
                i.touch &&
                  s
                    .on("touchstart.zoom", function (e) {
                      e.preventDefault(),
                        d
                          ? ((d = !1), n())
                          : ((d = !0),
                            t(
                              e.originalEvent.touches[0] ||
                                e.originalEvent.changedTouches[0]
                            ));
                    })
                    .on("touchmove.zoom", function (e) {
                      e.preventDefault(),
                        p.move(
                          e.originalEvent.touches[0] ||
                            e.originalEvent.changedTouches[0]
                        );
                    })
                    .on("touchend.zoom", function (e) {
                      e.preventDefault(), d && ((d = !1), n());
                    }),
                e.isFunction(i.callback) && i.callback.call(a);
            }),
            a.setAttribute("role", "presentation"),
            (a.alt = ""),
            (a.src = i.url);
        });
      }),
      (e.fn.zoom.defaults = t);
  })(window.jQuery),
  function () {
    function e(e, t) {
      for (var n = -1, i = t.length, o = e.length; ++n < i; ) e[o + n] = t[n];
      return e;
    }
    function t(e, t, n) {
      for (var i = -1, o = e.length; ++i < o; ) {
        var r = e[i],
          s = t(r);
        if (null != s && (a === le ? s === s : n(s, a)))
          var a = s,
            l = r;
      }
      return l;
    }
    function n(e, t, n) {
      var i;
      return (
        n(e, function (e, n, o) {
          return t(e, n, o) ? ((i = e), !1) : void 0;
        }),
        i
      );
    }
    function i(e, t, n, i, o) {
      return (
        o(e, function (e, o, r) {
          n = i ? ((i = !1), e) : t(n, e, o, r);
        }),
        n
      );
    }
    function o(e, t) {
      return T(t, function (t) {
        return e[t];
      });
    }
    function r(e) {
      return e && e.Object === Object ? e : null;
    }
    function s(e) {
      return fe[e];
    }
    function a(e) {
      var t = !1;
      if (null != e && "function" != typeof e.toString)
        try {
          t = !!(e + "");
        } catch (e) {}
      return t;
    }
    function l(e, t) {
      return (
        (e = "number" == typeof e || pe.test(e) ? +e : -1),
        e > -1 && 0 == e % 1 && (null == t ? 9007199254740991 : t) > e
      );
    }
    function u(e) {
      if (Z(e) && !Re(e)) {
        if (e instanceof c) return e;
        if (Se.call(e, "__wrapped__")) {
          var t = new c(e.__wrapped__, e.__chain__);
          return (t.__actions__ = A(e.__actions__)), t;
        }
      }
      return new c(e);
    }
    function c(e, t) {
      (this.__wrapped__ = e), (this.__actions__ = []), (this.__chain__ = !!t);
    }
    function d(e, t, n, i) {
      var o;
      return (
        (o = e === le) ||
          ((o = Te[n]),
          (o = (e === o || (e !== e && o !== o)) && !Se.call(i, n))),
        o ? t : e
      );
    }
    function p(e) {
      return J(e) ? Ne(e) : {};
    }
    function f(e, t, n) {
      if ("function" != typeof e) throw new TypeError("Expected a function");
      return setTimeout(function () {
        e.apply(le, n);
      }, t);
    }
    function h(e, t) {
      var n = !0;
      return (
        Pe(e, function (e, i, o) {
          return (n = !!t(e, i, o));
        }),
        n
      );
    }
    function v(e, t) {
      var n = [];
      return (
        Pe(e, function (e, i, o) {
          t(e, i, o) && n.push(e);
        }),
        n
      );
    }
    function g(t, n, i, o) {
      o || (o = []);
      for (var r = -1, s = t.length; ++r < s; ) {
        var a = t[r];
        n > 0 && Z(a) && V(a) && (i || Re(a) || Y(a))
          ? n > 1
            ? g(a, n - 1, i, o)
            : e(o, a)
          : i || (o[o.length] = a);
      }
      return o;
    }
    function m(e, t) {
      return e && Le(e, t, ie);
    }
    function y(e, t) {
      return v(t, function (t) {
        return G(e[t]);
      });
    }
    function b(e, t, n, i, o) {
      return (
        e === t ||
        (null == e || null == t || (!J(e) && !Z(t))
          ? e !== e && t !== t
          : w(e, t, b, n, i, o))
      );
    }
    function w(e, t, n, i, o, r) {
      var s = Re(e),
        l = Re(t),
        u = "[object Array]",
        c = "[object Array]";
      s ||
        ((u = $e.call(e)),
        "[object Arguments]" == u && (u = "[object Object]")),
        l ||
          ((c = $e.call(t)),
          "[object Arguments]" == c && (c = "[object Object]"));
      var d = "[object Object]" == u && !a(e),
        l = "[object Object]" == c && !a(t);
      return !(c = u == c) || s || d
        ? 2 & o ||
          ((u = d && Se.call(e, "__wrapped__")),
          (l = l && Se.call(t, "__wrapped__")),
          !u && !l)
          ? !!c &&
            (r || (r = []),
            (u = M(r, function (t) {
              return t[0] === e;
            })) && u[1]
              ? u[1] == t
              : (r.push([e, t]),
                (t = (s ? P : _)(e, t, n, i, o, r)),
                r.pop(),
                t))
          : n(u ? e.value() : e, l ? t.value() : t, i, o, r)
        : L(e, t, u);
    }
    function x(e) {
      var t = typeof e;
      return "function" == t ? e : null == e ? se : ("object" == t ? S : $)(e);
    }
    function k(e) {
      e = null == e ? e : Object(e);
      var t,
        n = [];
      for (t in e) n.push(t);
      return n;
    }
    function T(e, t) {
      var n = -1,
        i = V(e) ? Array(e.length) : [];
      return (
        Pe(e, function (e, o, r) {
          i[++n] = t(e, o, r);
        }),
        i
      );
    }
    function S(e) {
      var t = ie(e);
      return function (n) {
        var i = t.length;
        if (null == n) return !i;
        for (n = Object(n); i--; ) {
          var o = t[i];
          if (!(o in n && b(e[o], n[o], le, 3))) return !1;
        }
        return !0;
      };
    }
    function C(e, t) {
      return (
        (e = Object(e)),
        W(
          t,
          function (t, n) {
            return n in e && (t[n] = e[n]), t;
          },
          {}
        )
      );
    }
    function $(e) {
      return function (t) {
        return null == t ? le : t[e];
      };
    }
    function E(e, t, n) {
      var i = -1,
        o = e.length;
      for (
        0 > t && (t = -t > o ? 0 : o + t),
          n = n > o ? o : n,
          0 > n && (n += o),
          o = t > n ? 0 : (n - t) >>> 0,
          t >>>= 0,
          n = Array(o);
        ++i < o;

      )
        n[i] = e[i + t];
      return n;
    }
    function A(e) {
      return E(e, 0, e.length);
    }
    function j(e, t) {
      var n;
      return (
        Pe(e, function (e, i, o) {
          return (n = t(e, i, o)), !n;
        }),
        !!n
      );
    }
    function N(t, n) {
      return W(
        n,
        function (t, n) {
          return n.func.apply(n.thisArg, e([t], n.args));
        },
        t
      );
    }
    function D(e, t, n, i) {
      n || (n = {});
      for (var o = -1, r = t.length; ++o < r; ) {
        var s = t[o],
          a = i ? i(n[s], e[s], s, n, e) : e[s],
          l = n,
          u = l[s];
        (Se.call(l, s) &&
          (u === a || (u !== u && a !== a)) &&
          (a !== le || s in l)) ||
          (l[s] = a);
      }
      return n;
    }
    function O(e) {
      return U(function (t, n) {
        var i = -1,
          o = n.length,
          r = o > 1 ? n[o - 1] : le,
          r = "function" == typeof r ? (o--, r) : le;
        for (t = Object(t); ++i < o; ) {
          var s = n[i];
          s && e(t, s, i, r);
        }
        return t;
      });
    }
    function H(e) {
      return function () {
        var t = arguments,
          n = p(e.prototype),
          t = e.apply(n, t);
        return J(t) ? t : n;
      };
    }
    function q(e, t, n) {
      function i() {
        for (
          var r = -1,
            s = arguments.length,
            a = -1,
            l = n.length,
            u = Array(l + s),
            c = this && this !== xe && this instanceof i ? o : e;
          ++a < l;

        )
          u[a] = n[a];
        for (; s--; ) u[a++] = arguments[++r];
        return c.apply(t, u);
      }
      if ("function" != typeof e) throw new TypeError("Expected a function");
      var o = H(e);
      return i;
    }
    function P(e, t, n, i, o, r) {
      var s = -1,
        a = 1 & o,
        l = e.length,
        u = t.length;
      if (l != u && !(2 & o && u > l)) return !1;
      for (u = !0; ++s < l; ) {
        var c = e[s],
          d = t[s];
        if (void 0 !== le) {
          u = !1;
          break;
        }
        if (a) {
          if (
            !j(t, function (e) {
              return c === e || n(c, e, i, o, r);
            })
          ) {
            u = !1;
            break;
          }
        } else if (c !== d && !n(c, d, i, o, r)) {
          u = !1;
          break;
        }
      }
      return u;
    }
    function L(e, t, n) {
      switch (n) {
        case "[object Boolean]":
        case "[object Date]":
          return +e == +t;
        case "[object Error]":
          return e.name == t.name && e.message == t.message;
        case "[object Number]":
          return e != +e ? t != +t : e == +t;
        case "[object RegExp]":
        case "[object String]":
          return e == t + "";
      }
      return !1;
    }
    function _(e, t, n, i, o, r) {
      var s = 2 & o,
        a = ie(e),
        l = a.length,
        u = ie(t).length;
      if (l != u && !s) return !1;
      for (var c = l; c--; ) {
        var d = a[c];
        if (!(s ? d in t : Se.call(t, d))) return !1;
      }
      for (u = !0; ++c < l; ) {
        var d = a[c],
          p = e[d],
          f = t[d];
        if (void 0 !== le || (p !== f && !n(p, f, i, o, r))) {
          u = !1;
          break;
        }
        s || (s = "constructor" == d);
      }
      return (
        u &&
          !s &&
          ((n = e.constructor),
          (i = t.constructor),
          n != i &&
            "constructor" in e &&
            "constructor" in t &&
            !(
              "function" == typeof n &&
              n instanceof n &&
              "function" == typeof i &&
              i instanceof i
            ) &&
            (u = !1)),
        u
      );
    }
    function z(e) {
      var t = e ? e.length : le;
      if (Q(t) && (Re(e) || ee(e) || Y(e))) {
        e = String;
        for (var n = -1, i = Array(t); ++n < t; ) i[n] = e(n);
        t = i;
      } else t = null;
      return t;
    }
    function I(e) {
      var t = e && e.constructor,
        t = (G(t) && t.prototype) || Te;
      return e === t;
    }
    function F(e) {
      return e ? e[0] : le;
    }
    function M(e, t) {
      return n(e, x(t), Pe);
    }
    function R(e, t) {
      return Pe(e, "function" == typeof t ? t : se);
    }
    function W(e, t, n) {
      return i(e, x(t), n, 3 > arguments.length, Pe);
    }
    function B(e, t) {
      var n;
      if ("function" != typeof t) throw new TypeError("Expected a function");
      return (
        (e = We(e)),
        function () {
          return (
            0 < --e && (n = t.apply(this, arguments)), 1 >= e && (t = le), n
          );
        }
      );
    }
    function U(e) {
      var t;
      if ("function" != typeof e) throw new TypeError("Expected a function");
      return (
        (t = qe(t === le ? e.length - 1 : We(t), 0)),
        function () {
          for (
            var n = arguments, i = -1, o = qe(n.length - t, 0), r = Array(o);
            ++i < o;

          )
            r[i] = n[t + i];
          for (o = Array(t + 1), i = -1; ++i < t; ) o[i] = n[i];
          return (o[t] = r), e.apply(this, o);
        }
      );
    }
    function X(e, t) {
      return e > t;
    }
    function Y(e) {
      return (
        Z(e) &&
        V(e) &&
        Se.call(e, "callee") &&
        (!De.call(e, "callee") || "[object Arguments]" == $e.call(e))
      );
    }
    function V(e) {
      return null != e && !("function" == typeof e && G(e)) && Q(_e(e));
    }
    function G(e) {
      return (
        (e = J(e) ? $e.call(e) : ""),
        "[object Function]" == e || "[object GeneratorFunction]" == e
      );
    }
    function Q(e) {
      return (
        "number" == typeof e && e > -1 && 0 == e % 1 && 9007199254740991 >= e
      );
    }
    function J(e) {
      var t = typeof e;
      return !!e && ("object" == t || "function" == t);
    }
    function Z(e) {
      return !!e && "object" == typeof e;
    }
    function K(e) {
      return "number" == typeof e || (Z(e) && "[object Number]" == $e.call(e));
    }
    function ee(e) {
      return (
        "string" == typeof e ||
        (!Re(e) && Z(e) && "[object String]" == $e.call(e))
      );
    }
    function te(e, t) {
      return t > e;
    }
    function ne(e) {
      return "string" == typeof e ? e : null == e ? "" : e + "";
    }
    function ie(e) {
      var t = I(e);
      if (!t && !V(e)) return He(Object(e));
      var n,
        i = z(e),
        o = !!i,
        i = i || [],
        r = i.length;
      for (n in e)
        !Se.call(e, n) ||
          (o && ("length" == n || l(n, r))) ||
          (t && "constructor" == n) ||
          i.push(n);
      return i;
    }
    function oe(e) {
      for (
        var t = -1,
          n = I(e),
          i = k(e),
          o = i.length,
          r = z(e),
          s = !!r,
          r = r || [],
          a = r.length;
        ++t < o;

      ) {
        var u = i[t];
        (s && ("length" == u || l(u, a))) ||
          ("constructor" == u && (n || !Se.call(e, u))) ||
          r.push(u);
      }
      return r;
    }
    function re(e) {
      return e ? o(e, ie(e)) : [];
    }
    function se(e) {
      return e;
    }
    function ae(t, n, i) {
      var o = ie(n),
        r = y(n, o);
      null != i ||
        (J(n) && (r.length || !o.length)) ||
        ((i = n), (n = t), (t = this), (r = y(n, ie(n))));
      var s = !(J(i) && "chain" in i) || i.chain,
        a = G(t);
      return (
        Pe(r, function (i) {
          var o = n[i];
          (t[i] = o),
            a &&
              (t.prototype[i] = function () {
                var n = this.__chain__;
                if (s || n) {
                  var i = t(this.__wrapped__);
                  return (
                    (i.__actions__ = A(this.__actions__)).push({
                      func: o,
                      args: arguments,
                      thisArg: t,
                    }),
                    (i.__chain__ = n),
                    i
                  );
                }
                return o.apply(t, e([this.value()], arguments));
              });
        }),
        t
      );
    }
    var le,
      ue = 1 / 0,
      ce = /[&<>"'`]/g,
      de = RegExp(ce.source),
      pe = /^(?:0|[1-9]\d*)$/,
      fe = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
        "`": "&#96;",
      },
      he = { function: !0, object: !0 },
      ve = he[typeof exports] && exports && !exports.nodeType ? exports : le,
      ge = he[typeof module] && module && !module.nodeType ? module : le,
      me = ge && ge.exports === ve ? ve : le,
      ye = r(he[typeof self] && self),
      be = r(he[typeof window] && window),
      we = r(he[typeof this] && this),
      xe =
        r(ve && ge && "object" == typeof global && global) ||
        (be !== (we && we.window) && be) ||
        ye ||
        we ||
        Function("return this")(),
      ke = Array.prototype,
      Te = Object.prototype,
      Se = Te.hasOwnProperty,
      Ce = 0,
      $e = Te.toString,
      Ee = xe._,
      Ae = xe.Reflect,
      je = Ae ? Ae.f : le,
      Ne = Object.create,
      De = Te.propertyIsEnumerable,
      Oe = xe.isFinite,
      He = Object.keys,
      qe = Math.max,
      Pe = (function (e, t) {
        return function (n, i) {
          if (null == n) return n;
          if (!V(n)) return e(n, i);
          for (
            var o = n.length, r = t ? o : -1, s = Object(n);
            (t ? r-- : ++r < o) && !1 !== i(s[r], r, s);

          );
          return n;
        };
      })(m),
      Le = (function (e) {
        return function (t, n, i) {
          var o = -1,
            r = Object(t);
          i = i(t);
          for (var s = i.length; s--; ) {
            var a = i[e ? s : ++o];
            if (!1 === n(r[a], a, r)) break;
          }
          return t;
        };
      })();
    je &&
      !De.call({ valueOf: 1 }, "valueOf") &&
      (k = function (e) {
        e = je(e);
        for (var t, n = []; !(t = e.next()).done; ) n.push(t.value);
        return n;
      });
    var _e = $("length"),
      ze = U(function (t, n) {
        return (
          Re(t) || (t = null == t ? [] : [Object(t)]), g(n, 1), e(A(t), re)
        );
      }),
      Ie = U(function (e, t, n) {
        return q(e, t, n);
      }),
      Fe = U(function (e, t) {
        return f(e, 1, t);
      }),
      Me = U(function (e, t, n) {
        return f(e, Be(t) || 0, n);
      }),
      Re = Array.isArray,
      We = Number,
      Be = Number,
      Ue = O(function (e, t) {
        D(t, ie(t), e);
      }),
      Xe = O(function (e, t) {
        D(t, oe(t), e);
      }),
      Ye = O(function (e, t, n, i) {
        D(t, oe(t), e, i);
      }),
      Ve = U(function (e) {
        return e.push(le, d), Ye.apply(le, e);
      }),
      Ge = U(function (e, t) {
        return null == e ? {} : C(e, g(t, 1));
      }),
      Qe = x;
    (c.prototype = p(u.prototype)),
      (c.prototype.constructor = c),
      (u.assignIn = Xe),
      (u.before = B),
      (u.bind = Ie),
      (u.chain = function (e) {
        return (e = u(e)), (e.__chain__ = !0), e;
      }),
      (u.compact = function (e) {
        return v(e, Boolean);
      }),
      (u.concat = ze),
      (u.create = function (e, t) {
        var n = p(e);
        return t ? Ue(n, t) : n;
      }),
      (u.defaults = Ve),
      (u.defer = Fe),
      (u.delay = Me),
      (u.filter = function (e, t) {
        return v(e, x(t));
      }),
      (u.flatten = function (e) {
        return e && e.length ? g(e, 1) : [];
      }),
      (u.flattenDeep = function (e) {
        return e && e.length ? g(e, ue) : [];
      }),
      (u.iteratee = Qe),
      (u.keys = ie),
      (u.map = function (e, t) {
        return T(e, x(t));
      }),
      (u.matches = function (e) {
        return S(Ue({}, e));
      }),
      (u.mixin = ae),
      (u.negate = function (e) {
        if ("function" != typeof e) throw new TypeError("Expected a function");
        return function () {
          return !e.apply(this, arguments);
        };
      }),
      (u.once = function (e) {
        return B(2, e);
      }),
      (u.pick = Ge),
      (u.slice = function (e, t, n) {
        var i = e ? e.length : 0;
        return (n = n === le ? i : +n), i ? E(e, null == t ? 0 : +t, n) : [];
      }),
      (u.sortBy = function (e, t) {
        var n = 0;
        return (
          (t = x(t)),
          T(
            T(e, function (e, i, o) {
              return { c: e, b: n++, a: t(e, i, o) };
            }).sort(function (e, t) {
              var n;
              e: {
                n = e.a;
                var i = t.a;
                if (n !== i) {
                  var o = null === n,
                    r = n === le,
                    s = n === n,
                    a = null === i,
                    l = i === le,
                    u = i === i;
                  if ((n > i && !a) || !s || (o && !l && u) || (r && u)) {
                    n = 1;
                    break e;
                  }
                  if ((i > n && !o) || !u || (a && !r && s) || (l && s)) {
                    n = -1;
                    break e;
                  }
                }
                n = 0;
              }
              return n || e.b - t.b;
            }),
            $("c")
          )
        );
      }),
      (u.tap = function (e, t) {
        return t(e), e;
      }),
      (u.thru = function (e, t) {
        return t(e);
      }),
      (u.toArray = function (e) {
        return V(e) ? (e.length ? A(e) : []) : re(e);
      }),
      (u.values = re),
      (u.extend = Xe),
      ae(u, u),
      (u.clone = function (e) {
        return J(e) ? (Re(e) ? A(e) : D(e, ie(e))) : e;
      }),
      (u.escape = function (e) {
        return (e = ne(e)) && de.test(e) ? e.replace(ce, s) : e;
      }),
      (u.every = function (e, t, n) {
        return (t = n ? le : t), h(e, x(t));
      }),
      (u.find = M),
      (u.forEach = R),
      (u.has = function (e, t) {
        return null != e && Se.call(e, t);
      }),
      (u.head = F),
      (u.identity = se),
      (u.indexOf = function (e, t, n) {
        var i = e ? e.length : 0;
        (n = "number" == typeof n ? (0 > n ? qe(i + n, 0) : n) : 0),
          (n = (n || 0) - 1);
        for (var o = t === t; ++n < i; ) {
          var r = e[n];
          if (o ? r === t : r !== r) return n;
        }
        return -1;
      }),
      (u.isArguments = Y),
      (u.isArray = Re),
      (u.isBoolean = function (e) {
        return (
          !0 === e || !1 === e || (Z(e) && "[object Boolean]" == $e.call(e))
        );
      }),
      (u.isDate = function (e) {
        return Z(e) && "[object Date]" == $e.call(e);
      }),
      (u.isEmpty = function (e) {
        if (V(e) && (Re(e) || ee(e) || G(e.splice) || Y(e))) return !e.length;
        for (var t in e) if (Se.call(e, t)) return !1;
        return !0;
      }),
      (u.isEqual = function (e, t) {
        return b(e, t);
      }),
      (u.isFinite = function (e) {
        return "number" == typeof e && Oe(e);
      }),
      (u.isFunction = G),
      (u.isNaN = function (e) {
        return K(e) && e != +e;
      }),
      (u.isNull = function (e) {
        return null === e;
      }),
      (u.isNumber = K),
      (u.isObject = J),
      (u.isRegExp = function (e) {
        return J(e) && "[object RegExp]" == $e.call(e);
      }),
      (u.isString = ee),
      (u.isUndefined = function (e) {
        return e === le;
      }),
      (u.last = function (e) {
        var t = e ? e.length : 0;
        return t ? e[t - 1] : le;
      }),
      (u.max = function (e) {
        return e && e.length ? t(e, se, X) : le;
      }),
      (u.min = function (e) {
        return e && e.length ? t(e, se, te) : le;
      }),
      (u.noConflict = function () {
        return xe._ === this && (xe._ = Ee), this;
      }),
      (u.noop = function () {}),
      (u.reduce = W),
      (u.result = function (e, t, n) {
        return (
          (t = null == e ? le : e[t]), t === le && (t = n), G(t) ? t.call(e) : t
        );
      }),
      (u.size = function (e) {
        return null == e ? 0 : ((e = V(e) ? e : ie(e)), e.length);
      }),
      (u.some = function (e, t, n) {
        return (t = n ? le : t), j(e, x(t));
      }),
      (u.uniqueId = function (e) {
        var t = ++Ce;
        return ne(e) + t;
      }),
      (u.each = R),
      (u.first = F),
      ae(
        u,
        (function () {
          var e = {};
          return (
            m(u, function (t, n) {
              Se.call(u.prototype, n) || (e[n] = t);
            }),
            e
          );
        })(),
        { chain: !1 }
      ),
      (u.VERSION = "4.5.1"),
      Pe(
        "pop join replace reverse split push shift sort splice unshift".split(
          " "
        ),
        function (e) {
          var t = (/^(?:replace|split)$/.test(e) ? String.prototype : ke)[e],
            n = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru",
            i = /^(?:pop|join|replace|shift)$/.test(e);
          u.prototype[e] = function () {
            var e = arguments;
            return i && !this.__chain__
              ? t.apply(this.value(), e)
              : this[n](function (n) {
                  return t.apply(n, e);
                });
          };
        }
      ),
      (u.prototype.toJSON = u.prototype.valueOf = u.prototype.value = function () {
        return N(this.__wrapped__, this.__actions__);
      }),
      ((be || ye || {})._ = u),
      "function" == typeof define && "object" == typeof define.amd && define.amd
        ? define(function () {
            return u;
          })
        : ve && ge
        ? (me && ((ge.exports = u)._ = u), (ve._ = u))
        : (xe._ = u);
  }.call(this)
  /*!
   * mobile-sniff.min.js
   */,
  !(function () {
    window.mobileCheck = function () {
      var e = !1;
      return (
        (function (t) {
          (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            t
          ) ||
            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
              t.substr(0, 4)
            )) &&
            (e = !0);
        })(navigator.userAgent || navigator.vendor || window.opera),
        e
      );
    };
  })()
  /*!
   * modernizr.min.js
   */,
  /*! modernizr 3.3.1 (Custom Build) | MIT *
   * https://modernizr.com/download/?-csstransforms-flexbox-svg-setclasses !*/
  !(function (e, t, n) {
    function i(e, t) {
      return typeof e === t;
    }
    function o() {
      var e, t, n, o, r, s, a;
      for (var l in b)
        if (b.hasOwnProperty(l)) {
          if (
            ((e = []),
            (t = b[l]),
            t.name &&
              (e.push(t.name.toLowerCase()),
              t.options && t.options.aliases && t.options.aliases.length))
          )
            for (n = 0; n < t.options.aliases.length; n++)
              e.push(t.options.aliases[n].toLowerCase());
          for (
            o = i(t.fn, "function") ? t.fn() : t.fn, r = 0;
            r < e.length;
            r++
          )
            (s = e[r]),
              (a = s.split(".")),
              1 === a.length
                ? (x[a[0]] = o)
                : (!x[a[0]] ||
                    x[a[0]] instanceof Boolean ||
                    (x[a[0]] = new Boolean(x[a[0]])),
                  (x[a[0]][a[1]] = o)),
              y.push((o ? "" : "no-") + a.join("-"));
        }
    }
    function r(e) {
      var t = k.className,
        n = x._config.classPrefix || "";
      if ((T && (t = t.baseVal), x._config.enableJSClass)) {
        var i = new RegExp("(^|\\s)" + n + "no-js(\\s|$)");
        t = t.replace(i, "$1" + n + "js$2");
      }
      x._config.enableClasses &&
        ((t += " " + n + e.join(" " + n)),
        T ? (k.className.baseVal = t) : (k.className = t));
    }
    function s(e, t) {
      return !!~("" + e).indexOf(t);
    }
    function a() {
      return "function" != typeof t.createElement
        ? t.createElement(arguments[0])
        : T
        ? t.createElementNS.call(t, "http://www.w3.org/2000/svg", arguments[0])
        : t.createElement.apply(t, arguments);
    }
    function l(e) {
      return e
        .replace(/([a-z])-([a-z])/g, function (e, t, n) {
          return t + n.toUpperCase();
        })
        .replace(/^-/, "");
    }
    function u(e, t) {
      return function () {
        return e.apply(t, arguments);
      };
    }
    function c(e, t, n) {
      var o;
      for (var r in e)
        if (e[r] in t)
          return n === !1
            ? e[r]
            : ((o = t[e[r]]), i(o, "function") ? u(o, n || t) : o);
      return !1;
    }
    function d(e) {
      return e
        .replace(/([A-Z])/g, function (e, t) {
          return "-" + t.toLowerCase();
        })
        .replace(/^ms-/, "-ms-");
    }
    function p() {
      var e = t.body;
      return e || ((e = a(T ? "svg" : "body")), (e.fake = !0)), e;
    }
    function f(e, n, i, o) {
      var r,
        s,
        l,
        u,
        c = "modernizr",
        d = a("div"),
        f = p();
      if (parseInt(i, 10))
        for (; i--; )
          (l = a("div")), (l.id = o ? o[i] : c + (i + 1)), d.appendChild(l);
      return (
        (r = a("style")),
        (r.type = "text/css"),
        (r.id = "s" + c),
        (f.fake ? f : d).appendChild(r),
        f.appendChild(d),
        r.styleSheet
          ? (r.styleSheet.cssText = e)
          : r.appendChild(t.createTextNode(e)),
        (d.id = c),
        f.fake &&
          ((f.style.background = ""),
          (f.style.overflow = "hidden"),
          (u = k.style.overflow),
          (k.style.overflow = "hidden"),
          k.appendChild(f)),
        (s = n(d, e)),
        f.fake
          ? (f.parentNode.removeChild(f),
            (k.style.overflow = u),
            k.offsetHeight)
          : d.parentNode.removeChild(d),
        !!s
      );
    }
    function h(t, i) {
      var o = t.length;
      if ("CSS" in e && "supports" in e.CSS) {
        for (; o--; ) if (e.CSS.supports(d(t[o]), i)) return !0;
        return !1;
      }
      if ("CSSSupportsRule" in e) {
        for (var r = []; o--; ) r.push("(" + d(t[o]) + ":" + i + ")");
        return (
          (r = r.join(" or ")),
          f(
            "@supports (" + r + ") { #modernizr { position: absolute; } }",
            function (e) {
              return "absolute" == getComputedStyle(e, null).position;
            }
          )
        );
      }
      return n;
    }
    function v(e, t, o, r) {
      function u() {
        d && (delete A.style, delete A.modElem);
      }
      if (((r = !i(r, "undefined") && r), !i(o, "undefined"))) {
        var c = h(e, o);
        if (!i(c, "undefined")) return c;
      }
      for (
        var d, p, f, v, g, m = ["modernizr", "tspan", "samp"];
        !A.style && m.length;

      )
        (d = !0), (A.modElem = a(m.shift())), (A.style = A.modElem.style);
      for (f = e.length, p = 0; f > p; p++)
        if (
          ((v = e[p]),
          (g = A.style[v]),
          s(v, "-") && (v = l(v)),
          A.style[v] !== n)
        ) {
          if (r || i(o, "undefined")) return u(), "pfx" != t || v;
          try {
            A.style[v] = o;
          } catch (e) {}
          if (A.style[v] != g) return u(), "pfx" != t || v;
        }
      return u(), !1;
    }
    function g(e, t, n, o, r) {
      var s = e.charAt(0).toUpperCase() + e.slice(1),
        a = (e + " " + C.join(s + " ") + s).split(" ");
      return i(t, "string") || i(t, "undefined")
        ? v(a, t, o, r)
        : ((a = (e + " " + $.join(s + " ") + s).split(" ")), c(a, t, n));
    }
    function m(e, t, i) {
      return g(e, n, n, t, i);
    }
    var y = [],
      b = [],
      w = {
        _version: "3.3.1",
        _config: {
          classPrefix: "",
          enableClasses: !0,
          enableJSClass: !0,
          usePrefixes: !0,
        },
        _q: [],
        on: function (e, t) {
          var n = this;
          setTimeout(function () {
            t(n[e]);
          }, 0);
        },
        addTest: function (e, t, n) {
          b.push({ name: e, fn: t, options: n });
        },
        addAsyncTest: function (e) {
          b.push({ name: null, fn: e });
        },
      },
      x = function () {};
    (x.prototype = w),
      (x = new x()),
      x.addTest(
        "svg",
        !!t.createElementNS &&
          !!t.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect
      );
    var k = t.documentElement,
      T = "svg" === k.nodeName.toLowerCase(),
      S = "Moz O ms Webkit",
      C = w._config.usePrefixes ? S.split(" ") : [];
    w._cssomPrefixes = C;
    var $ = w._config.usePrefixes ? S.toLowerCase().split(" ") : [];
    w._domPrefixes = $;
    var E = { elem: a("modernizr") };
    x._q.push(function () {
      delete E.elem;
    });
    var A = { style: E.elem.style };
    x._q.unshift(function () {
      delete A.style;
    }),
      (w.testAllProps = g),
      (w.testAllProps = m),
      x.addTest("flexbox", m("flexBasis", "1px", !0)),
      x.addTest("csstransforms", function () {
        return (
          -1 === navigator.userAgent.indexOf("Android 2.") &&
          m("transform", "scale(1)", !0)
        );
      }),
      o(),
      r(y),
      delete w.addTest,
      delete w.addAsyncTest;
    for (var j = 0; j < x._q.length; j++) x._q[j]();
    e.Modernizr = x;
  })(window, document)
  /*!
   * prepare-transition.min.js
   */,
  /* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
  !(function (e) {
    e.fn.prepareTransition = function () {
      return this.each(function () {
        var t = e(this);
        t.one(
          "TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",
          function () {
            t.removeClass("is-transitioning");
          }
        );
        var n = [
            "transition-duration",
            "-moz-transition-duration",
            "-webkit-transition-duration",
            "-o-transition-duration",
          ],
          i = 0;
        e.each(n, function (e, n) {
          i || (i = parseFloat(t.css(n)));
        }),
          0 != i && (t.addClass("is-transitioning"), t[0].offsetWidth);
      });
    };
  })(jQuery)
  /*!
   * slick-slim.min.js
   */,
  (function (factory) {
    "use strict";
    if (typeof define === "function" && define.amd) {
      define(["jquery"], factory);
    } else if (typeof exports !== "undefined") {
      module.exports = factory(require("jquery"));
    } else {
      factory(jQuery);
    }
  })(function ($) {
    "use strict";
    var Slick = window.Slick || {};
    Slick = (function () {
      var instanceUid = 0;
      function Slick(element, settings) {
        var _ = this,
          dataSettings;
        _.defaults = {
          accessibility: true,
          adaptiveHeight: false,
          appendArrows: $(element),
          appendDots: $(element),
          arrows: true,
          asNavFor: null,
          prevArrow:
            '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
          nextArrow:
            '<button class="slick-next" aria-label="Next" type="button">Next</button>',
          autoplay: false,
          autoplaySpeed: 3e3,
          centerMode: false,
          centerPadding: "50px",
          cssEase: "ease",
          customPaging: function (slider, i) {
            return $('<button type="button" />').text(i + 1);
          },
          dots: false,
          dotsClass: "slick-dots",
          draggable: true,
          easing: "linear",
          edgeFriction: 0.35,
          fade: false,
          focusOnSelect: false,
          focusOnChange: false,
          infinite: true,
          initialSlide: 0,
          lazyLoad: "ondemand",
          mobileFirst: false,
          pauseOnHover: true,
          pauseOnFocus: true,
          pauseOnDotsHover: false,
          respondTo: "window",
          responsive: null,
          rows: 1,
          rtl: false,
          slide: "",
          slidesPerRow: 1,
          slidesToShow: 1,
          slidesToScroll: 1,
          speed: 500,
          swipe: true,
          swipeToSlide: false,
          touchMove: true,
          touchThreshold: 5,
          useCSS: true,
          useTransform: true,
          variableWidth: false,
          vertical: false,
          verticalSwiping: false,
          waitForAnimate: true,
          zIndex: 1e3,
        };
        _.initials = {
          animating: false,
          dragging: false,
          autoPlayTimer: null,
          currentDirection: 0,
          currentLeft: null,
          currentSlide: 0,
          direction: 1,
          $dots: null,
          listWidth: null,
          listHeight: null,
          loadIndex: 0,
          $nextArrow: null,
          $prevArrow: null,
          scrolling: false,
          slideCount: null,
          slideWidth: null,
          $slideTrack: null,
          $slides: null,
          sliding: false,
          slideOffset: 0,
          swipeLeft: null,
          swiping: false,
          $list: null,
          touchObject: {},
          transformsEnabled: false,
          unslicked: false,
        };
        $.extend(_, _.initials);
        _.activeBreakpoint = null;
        _.animType = null;
        _.animProp = null;
        _.breakpoints = [];
        _.breakpointSettings = [];
        _.cssTransitions = false;
        _.focussed = false;
        _.interrupted = false;
        _.hidden = "hidden";
        _.paused = true;
        _.positionProp = null;
        _.respondTo = null;
        _.rowCount = 1;
        _.shouldClick = true;
        _.$slider = $(element);
        _.$slidesCache = null;
        _.transformType = null;
        _.transitionType = null;
        _.visibilityChange = "visibilitychange";
        _.windowWidth = 0;
        _.windowTimer = null;
        dataSettings = $(element).data("slick") || {};
        _.options = $.extend({}, _.defaults, settings, dataSettings);
        _.currentSlide = _.options.initialSlide;
        _.originalSettings = _.options;
        if (typeof document.mozHidden !== "undefined") {
          _.hidden = "mozHidden";
          _.visibilityChange = "mozvisibilitychange";
        } else if (typeof document.webkitHidden !== "undefined") {
          _.hidden = "webkitHidden";
          _.visibilityChange = "webkitvisibilitychange";
        }
        _.autoPlay = $.proxy(_.autoPlay, _);
        _.autoPlayClear = $.proxy(_.autoPlayClear, _);
        _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
        _.changeSlide = $.proxy(_.changeSlide, _);
        _.clickHandler = $.proxy(_.clickHandler, _);
        _.selectHandler = $.proxy(_.selectHandler, _);
        _.setPosition = $.proxy(_.setPosition, _);
        _.swipeHandler = $.proxy(_.swipeHandler, _);
        _.dragHandler = $.proxy(_.dragHandler, _);
        _.keyHandler = $.proxy(_.keyHandler, _);
        _.instanceUid = instanceUid++;
        _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;
        _.registerBreakpoints();
        _.init(true);
      }
      return Slick;
    })();
    Slick.prototype.activateADA = function () {
      var _ = this;
      _.$slideTrack
        .find(".slick-active")
        .attr({ "aria-hidden": "false" })
        .find("a, input, button, select")
        .attr({ tabindex: "0" });
    };
    Slick.prototype.addSlide = Slick.prototype.slickAdd = function (
      markup,
      index,
      addBefore
    ) {
      var _ = this;
      if (typeof index === "boolean") {
        addBefore = index;
        index = null;
      } else if (index < 0 || index >= _.slideCount) {
        return false;
      }
      _.unload();
      if (typeof index === "number") {
        if (index === 0 && _.$slides.length === 0) {
          $(markup).appendTo(_.$slideTrack);
        } else if (addBefore) {
          $(markup).insertBefore(_.$slides.eq(index));
        } else {
          $(markup).insertAfter(_.$slides.eq(index));
        }
      } else {
        if (addBefore === true) {
          $(markup).prependTo(_.$slideTrack);
        } else {
          $(markup).appendTo(_.$slideTrack);
        }
      }
      _.$slides = _.$slideTrack.children(this.options.slide);
      _.$slideTrack.children(this.options.slide).detach();
      _.$slideTrack.append(_.$slides);
      _.$slides.each(function (index, element) {
        $(element).attr("data-slick-index", index);
      });
      _.$slidesCache = _.$slides;
      _.reinit();
    };
    Slick.prototype.animateHeight = function () {
      var _ = this;
      if (
        _.options.slidesToShow === 1 &&
        _.options.adaptiveHeight === true &&
        _.options.vertical === false
      ) {
        var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
        _.$list.animate({ height: targetHeight }, _.options.speed);
      }
    };
    Slick.prototype.animateSlide = function (targetLeft, callback) {
      var animProps = {},
        _ = this;
      _.animateHeight();
      if (_.options.rtl === true && _.options.vertical === false) {
        targetLeft = -targetLeft;
      }
      if (_.transformsEnabled === false) {
        if (_.options.vertical === false) {
          _.$slideTrack.animate(
            { left: targetLeft },
            _.options.speed,
            _.options.easing,
            callback
          );
        } else {
          _.$slideTrack.animate(
            { top: targetLeft },
            _.options.speed,
            _.options.easing,
            callback
          );
        }
      } else {
        if (_.cssTransitions === false) {
          if (_.options.rtl === true) {
            _.currentLeft = -_.currentLeft;
          }
          $({ animStart: _.currentLeft }).animate(
            { animStart: targetLeft },
            {
              duration: _.options.speed,
              easing: _.options.easing,
              step: function (now) {
                now = Math.ceil(now);
                if (_.options.vertical === false) {
                  animProps[_.animType] = "translate(" + now + "px, 0px)";
                  _.$slideTrack.css(animProps);
                } else {
                  animProps[_.animType] = "translate(0px," + now + "px)";
                  _.$slideTrack.css(animProps);
                }
              },
              complete: function () {
                if (callback) {
                  callback.call();
                }
              },
            }
          );
        } else {
          _.applyTransition();
          targetLeft = Math.ceil(targetLeft);
          if (_.options.vertical === false) {
            animProps[_.animType] =
              "translate3d(" + targetLeft + "px, 0px, 0px)";
          } else {
            animProps[_.animType] =
              "translate3d(0px," + targetLeft + "px, 0px)";
          }
          _.$slideTrack.css(animProps);
          if (callback) {
            setTimeout(function () {
              _.disableTransition();
              callback.call();
            }, _.options.speed);
          }
        }
      }
    };
    Slick.prototype.getNavTarget = function () {
      var _ = this,
        asNavFor = _.options.asNavFor;
      if (asNavFor && asNavFor !== null) {
        asNavFor = $(asNavFor).not(_.$slider);
      }
      return asNavFor;
    };
    Slick.prototype.asNavFor = function (index) {
      var _ = this,
        asNavFor = _.getNavTarget();
      if (asNavFor !== null && typeof asNavFor === "object") {
        asNavFor.each(function () {
          var target = $(this).slick("getSlick");
          if (!target.unslicked) {
            target.slideHandler(index, true);
          }
        });
      }
    };
    Slick.prototype.applyTransition = function (slide) {
      var _ = this,
        transition = {};
      if (_.options.fade === false) {
        transition[_.transitionType] =
          _.transformType + " " + _.options.speed + "ms " + _.options.cssEase;
      } else {
        transition[_.transitionType] =
          "opacity " + _.options.speed + "ms " + _.options.cssEase;
      }
      if (_.options.fade === false) {
        _.$slideTrack.css(transition);
      } else {
        _.$slides.eq(slide).css(transition);
      }
    };
    Slick.prototype.autoPlay = function () {
      var _ = this;
      _.autoPlayClear();
      if (_.slideCount > _.options.slidesToShow) {
        _.autoPlayTimer = setInterval(
          _.autoPlayIterator,
          _.options.autoplaySpeed
        );
      }
    };
    Slick.prototype.autoPlayClear = function () {
      var _ = this;
      if (_.autoPlayTimer) {
        clearInterval(_.autoPlayTimer);
      }
    };
    Slick.prototype.autoPlayIterator = function () {
      var _ = this,
        slideTo = _.currentSlide + _.options.slidesToScroll;
      if (!_.paused && !_.interrupted && !_.focussed) {
        if (_.options.infinite === false) {
          if (_.direction === 1 && _.currentSlide + 1 === _.slideCount - 1) {
            _.direction = 0;
          } else if (_.direction === 0) {
            slideTo = _.currentSlide - _.options.slidesToScroll;
            if (_.currentSlide - 1 === 0) {
              _.direction = 1;
            }
          }
        }
        _.slideHandler(slideTo);
      }
    };
    Slick.prototype.buildArrows = function () {
      var _ = this;
      if (_.options.arrows === true) {
        _.$prevArrow = $(_.options.prevArrow).addClass("slick-arrow");
        _.$nextArrow = $(_.options.nextArrow).addClass("slick-arrow");
        if (_.slideCount > _.options.slidesToShow) {
          _.$prevArrow
            .removeClass("slick-hidden")
            .removeAttr("aria-hidden tabindex");
          _.$nextArrow
            .removeClass("slick-hidden")
            .removeAttr("aria-hidden tabindex");
          if (_.htmlExpr.test(_.options.prevArrow)) {
            _.$prevArrow.prependTo(_.options.appendArrows);
          }
          if (_.htmlExpr.test(_.options.nextArrow)) {
            _.$nextArrow.appendTo(_.options.appendArrows);
          }
          if (_.options.infinite !== true) {
            _.$prevArrow
              .addClass("slick-disabled")
              .attr("aria-disabled", "true");
          }
        } else {
          _.$prevArrow
            .add(_.$nextArrow)
            .addClass("slick-hidden")
            .attr({ "aria-disabled": "true", tabindex: "-1" });
        }
      }
    };
    Slick.prototype.buildDots = function () {
      var _ = this,
        i,
        dot;
      if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
        _.$slider.addClass("slick-dotted");
        dot = $("<ul />").addClass(_.options.dotsClass);
        for (i = 0; i <= _.getDotCount(); i += 1) {
          dot.append(
            $("<li />").append(_.options.customPaging.call(this, _, i))
          );
        }
        _.$dots = dot.appendTo(_.options.appendDots);
        _.$dots.find("li").first().addClass("slick-active");
      }
    };
    Slick.prototype.buildOut = function () {
      var _ = this;
      _.$slides = _.$slider
        .children(_.options.slide + ":not(.slick-cloned)")
        .addClass("slick-slide");
      _.slideCount = _.$slides.length;
      _.$slides.each(function (index, element) {
        $(element)
          .attr("data-slick-index", index)
          .data("originalStyling", $(element).attr("style") || "");
      });
      _.$slider.addClass("slick-slider");
      _.$slideTrack =
        _.slideCount === 0
          ? $('<div class="slick-track"/>').appendTo(_.$slider)
          : _.$slides.wrapAll('<div class="slick-track"/>').parent();
      _.$list = _.$slideTrack.wrap('<div class="slick-list"/>').parent();
      _.$slideTrack.css("opacity", 0);
      if (_.options.centerMode === true || _.options.swipeToSlide === true) {
        _.options.slidesToScroll = 1;
      }
      $("img[data-lazy]", _.$slider).not("[src]").addClass("slick-loading");
      _.setupInfinite();
      _.buildArrows();
      _.buildDots();
      _.updateDots();
      _.setSlideClasses(
        typeof _.currentSlide === "number" ? _.currentSlide : 0
      );
      if (_.options.draggable === true) {
        _.$list.addClass("draggable");
      }
    };
    Slick.prototype.buildRows = function () {
      var _ = this,
        a,
        b,
        c,
        newSlides,
        numOfSlides,
        originalSlides,
        slidesPerSection;
      newSlides = document.createDocumentFragment();
      originalSlides = _.$slider.children();
      if (_.options.rows > 0) {
        slidesPerSection = _.options.slidesPerRow * _.options.rows;
        numOfSlides = Math.ceil(originalSlides.length / slidesPerSection);
        for (a = 0; a < numOfSlides; a++) {
          var slide = document.createElement("div");
          for (b = 0; b < _.options.rows; b++) {
            var row = document.createElement("div");
            for (c = 0; c < _.options.slidesPerRow; c++) {
              var target =
                a * slidesPerSection + (b * _.options.slidesPerRow + c);
              if (originalSlides.get(target)) {
                row.appendChild(originalSlides.get(target));
              }
            }
            slide.appendChild(row);
          }
          newSlides.appendChild(slide);
        }
        _.$slider.empty().append(newSlides);
        _.$slider
          .children()
          .children()
          .children()
          .css({
            width: 100 / _.options.slidesPerRow + "%",
            display: "inline-block",
          });
      }
    };
    Slick.prototype.checkResponsive = function (initial, forceUpdate) {
      var _ = this,
        breakpoint,
        targetBreakpoint,
        respondToWidth,
        triggerBreakpoint = false;
      var sliderWidth = _.$slider.width();
      var windowWidth = window.innerWidth || $(window).width();
      if (_.respondTo === "window") {
        respondToWidth = windowWidth;
      } else if (_.respondTo === "slider") {
        respondToWidth = sliderWidth;
      } else if (_.respondTo === "min") {
        respondToWidth = Math.min(windowWidth, sliderWidth);
      }
      if (
        _.options.responsive &&
        _.options.responsive.length &&
        _.options.responsive !== null
      ) {
        targetBreakpoint = null;
        for (breakpoint in _.breakpoints) {
          if (_.breakpoints.hasOwnProperty(breakpoint)) {
            if (_.originalSettings.mobileFirst === false) {
              if (respondToWidth < _.breakpoints[breakpoint]) {
                targetBreakpoint = _.breakpoints[breakpoint];
              }
            } else {
              if (respondToWidth > _.breakpoints[breakpoint]) {
                targetBreakpoint = _.breakpoints[breakpoint];
              }
            }
          }
        }
        if (targetBreakpoint !== null) {
          if (_.activeBreakpoint !== null) {
            if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
              _.activeBreakpoint = targetBreakpoint;
              if (_.breakpointSettings[targetBreakpoint] === "unslick") {
                _.unslick(targetBreakpoint);
              } else {
                _.options = $.extend(
                  {},
                  _.originalSettings,
                  _.breakpointSettings[targetBreakpoint]
                );
                if (initial === true) {
                  _.currentSlide = _.options.initialSlide;
                }
                _.refresh(initial);
              }
              triggerBreakpoint = targetBreakpoint;
            }
          } else {
            _.activeBreakpoint = targetBreakpoint;
            if (_.breakpointSettings[targetBreakpoint] === "unslick") {
              _.unslick(targetBreakpoint);
            } else {
              _.options = $.extend(
                {},
                _.originalSettings,
                _.breakpointSettings[targetBreakpoint]
              );
              if (initial === true) {
                _.currentSlide = _.options.initialSlide;
              }
              _.refresh(initial);
            }
            triggerBreakpoint = targetBreakpoint;
          }
        } else {
          if (_.activeBreakpoint !== null) {
            _.activeBreakpoint = null;
            _.options = _.originalSettings;
            if (initial === true) {
              _.currentSlide = _.options.initialSlide;
            }
            _.refresh(initial);
            triggerBreakpoint = targetBreakpoint;
          }
        }
        if (!initial && triggerBreakpoint !== false) {
          _.$slider.trigger("breakpoint", [_, triggerBreakpoint]);
        }
      }
    };
    Slick.prototype.changeSlide = function (event, dontAnimate) {
      var _ = this,
        $target = $(event.currentTarget),
        indexOffset,
        slideOffset,
        unevenOffset;
      if ($target.is("a")) {
        event.preventDefault();
      }
      if (!$target.is("li")) {
        $target = $target.closest("li");
      }
      unevenOffset = _.slideCount % _.options.slidesToScroll !== 0;
      indexOffset = unevenOffset
        ? 0
        : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;
      switch (event.data.message) {
        case "previous":
          slideOffset =
            indexOffset === 0
              ? _.options.slidesToScroll
              : _.options.slidesToShow - indexOffset;
          if (_.slideCount > _.options.slidesToShow) {
            _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
          }
          break;
        case "next":
          slideOffset =
            indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
          if (_.slideCount > _.options.slidesToShow) {
            _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
          }
          break;
        case "index":
          var index =
            event.data.index === 0
              ? 0
              : event.data.index || $target.index() * _.options.slidesToScroll;
          _.slideHandler(_.checkNavigable(index), false, dontAnimate);
          $target.children().trigger("focus");
          break;
        default:
          return;
      }
    };
    Slick.prototype.checkNavigable = function (index) {
      var _ = this,
        navigables,
        prevNavigable;
      navigables = _.getNavigableIndexes();
      prevNavigable = 0;
      if (index > navigables[navigables.length - 1]) {
        index = navigables[navigables.length - 1];
      } else {
        for (var n in navigables) {
          if (index < navigables[n]) {
            index = prevNavigable;
            break;
          }
          prevNavigable = navigables[n];
        }
      }
      return index;
    };
    Slick.prototype.cleanUpEvents = function () {
      var _ = this;
      if (_.options.dots && _.$dots !== null) {
        $("li", _.$dots)
          .off("click.slick", _.changeSlide)
          .off("mouseenter.slick", $.proxy(_.interrupt, _, true))
          .off("mouseleave.slick", $.proxy(_.interrupt, _, false));
        if (_.options.accessibility === true) {
          _.$dots.off("keydown.slick", _.keyHandler);
        }
      }
      _.$slider.off("focus.slick blur.slick");
      if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
        _.$prevArrow && _.$prevArrow.off("click.slick", _.changeSlide);
        _.$nextArrow && _.$nextArrow.off("click.slick", _.changeSlide);
        if (_.options.accessibility === true) {
          _.$prevArrow && _.$prevArrow.off("keydown.slick", _.keyHandler);
          _.$nextArrow && _.$nextArrow.off("keydown.slick", _.keyHandler);
        }
      }
      _.$list.off("touchstart.slick mousedown.slick", _.swipeHandler);
      _.$list.off("touchmove.slick mousemove.slick", _.swipeHandler);
      _.$list.off("touchend.slick mouseup.slick", _.swipeHandler);
      _.$list.off("touchcancel.slick mouseleave.slick", _.swipeHandler);
      _.$list.off("click.slick", _.clickHandler);
      $(document).off(_.visibilityChange, _.visibility);
      _.cleanUpSlideEvents();
      if (_.options.accessibility === true) {
        _.$list.off("keydown.slick", _.keyHandler);
      }
      if (_.options.focusOnSelect === true) {
        $(_.$slideTrack).children().off("click.slick", _.selectHandler);
      }
      $(window).off(
        "orientationchange.slick.slick-" + _.instanceUid,
        _.orientationChange
      );
      $(window).off("resize.slick.slick-" + _.instanceUid, _.resize);
      $("[draggable!=true]", _.$slideTrack).off("dragstart", _.preventDefault);
      $(window).off("load.slick.slick-" + _.instanceUid, _.setPosition);
    };
    Slick.prototype.cleanUpSlideEvents = function () {
      var _ = this;
      _.$list.off("mouseenter.slick", $.proxy(_.interrupt, _, true));
      _.$list.off("mouseleave.slick", $.proxy(_.interrupt, _, false));
    };
    Slick.prototype.cleanUpRows = function () {
      var _ = this,
        originalSlides;
      if (_.options.rows > 0) {
        originalSlides = _.$slides.children().children();
        originalSlides.removeAttr("style");
        _.$slider.empty().append(originalSlides);
      }
    };
    Slick.prototype.clickHandler = function (event) {
      var _ = this;
      if (_.shouldClick === false) {
        event.stopImmediatePropagation();
        event.stopPropagation();
        event.preventDefault();
      }
    };
    Slick.prototype.destroy = function (refresh) {
      var _ = this;
      _.autoPlayClear();
      _.touchObject = {};
      _.cleanUpEvents();
      $(".slick-cloned", _.$slider).detach();
      if (_.$dots) {
        _.$dots.remove();
      }
      if (_.$prevArrow && _.$prevArrow.length) {
        _.$prevArrow
          .removeClass("slick-disabled slick-arrow slick-hidden")
          .removeAttr("aria-hidden aria-disabled tabindex")
          .css("display", "");
        if (_.htmlExpr.test(_.options.prevArrow)) {
          _.$prevArrow.remove();
        }
      }
      if (_.$nextArrow && _.$nextArrow.length) {
        _.$nextArrow
          .removeClass("slick-disabled slick-arrow slick-hidden")
          .removeAttr("aria-hidden aria-disabled tabindex")
          .css("display", "");
        if (_.htmlExpr.test(_.options.nextArrow)) {
          _.$nextArrow.remove();
        }
      }
      if (_.$slides) {
        _.$slides
          .removeClass(
            "slick-slide slick-active slick-center slick-visible slick-current"
          )
          .removeAttr("aria-hidden")
          .removeAttr("data-slick-index")
          .each(function () {
            $(this).attr("style", $(this).data("originalStyling"));
          });
        _.$slideTrack.children(this.options.slide).detach();
        _.$slideTrack.detach();
        _.$list.detach();
        _.$slider.append(_.$slides);
      }
      _.cleanUpRows();
      _.$slider.removeClass("slick-slider");
      _.$slider.removeClass("slick-initialized");
      _.$slider.removeClass("slick-dotted");
      _.unslicked = true;
      if (!refresh) {
        _.$slider.trigger("destroy", [_]);
      }
    };
    Slick.prototype.disableTransition = function (slide) {
      var _ = this,
        transition = {};
      transition[_.transitionType] = "";
      if (_.options.fade === false) {
        _.$slideTrack.css(transition);
      } else {
        _.$slides.eq(slide).css(transition);
      }
    };
    Slick.prototype.fadeSlide = function (slideIndex, callback) {
      var _ = this;
      if (_.cssTransitions === false) {
        _.$slides.eq(slideIndex).css({ zIndex: _.options.zIndex });
        _.$slides
          .eq(slideIndex)
          .animate({ opacity: 1 }, _.options.speed, _.options.easing, callback);
      } else {
        _.applyTransition(slideIndex);
        _.$slides.eq(slideIndex).css({ opacity: 1, zIndex: _.options.zIndex });
        if (callback) {
          setTimeout(function () {
            _.disableTransition(slideIndex);
            callback.call();
          }, _.options.speed);
        }
      }
    };
    Slick.prototype.fadeSlideOut = function (slideIndex) {
      var _ = this;
      if (_.cssTransitions === false) {
        _.$slides
          .eq(slideIndex)
          .animate(
            { opacity: 0, zIndex: _.options.zIndex - 2 },
            _.options.speed,
            _.options.easing
          );
      } else {
        _.applyTransition(slideIndex);
        _.$slides
          .eq(slideIndex)
          .css({ opacity: 0, zIndex: _.options.zIndex - 2 });
      }
    };
    Slick.prototype.filterSlides = Slick.prototype.slickFilter = function (
      filter
    ) {
      var _ = this;
      if (filter !== null) {
        _.$slidesCache = _.$slides;
        _.unload();
        _.$slideTrack.children(this.options.slide).detach();
        _.$slidesCache.filter(filter).appendTo(_.$slideTrack);
        _.reinit();
      }
    };
    Slick.prototype.focusHandler = function () {
      var _ = this;
      _.$slider
        .off("focus.slick blur.slick")
        .on("focus.slick", "*", function (event) {
          var $sf = $(this);
          setTimeout(function () {
            if (_.options.pauseOnFocus) {
              if ($sf.is(":focus")) {
                _.focussed = true;
                _.autoPlay();
              }
            }
          }, 0);
        })
        .on("blur.slick", "*", function (event) {
          var $sf = $(this);
          if (_.options.pauseOnFocus) {
            _.focussed = false;
            _.autoPlay();
          }
        });
    };
    Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function () {
      var _ = this;
      return _.currentSlide;
    };
    Slick.prototype.getDotCount = function () {
      var _ = this;
      var breakPoint = 0;
      var counter = 0;
      var pagerQty = 0;
      if (_.options.infinite === true) {
        if (_.slideCount <= _.options.slidesToShow) {
          ++pagerQty;
        } else {
          while (breakPoint < _.slideCount) {
            ++pagerQty;
            breakPoint = counter + _.options.slidesToScroll;
            counter +=
              _.options.slidesToScroll <= _.options.slidesToShow
                ? _.options.slidesToScroll
                : _.options.slidesToShow;
          }
        }
      } else if (_.options.centerMode === true) {
        pagerQty = _.slideCount;
      } else if (!_.options.asNavFor) {
        pagerQty =
          1 +
          Math.ceil(
            (_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll
          );
      } else {
        while (breakPoint < _.slideCount) {
          ++pagerQty;
          breakPoint = counter + _.options.slidesToScroll;
          counter +=
            _.options.slidesToScroll <= _.options.slidesToShow
              ? _.options.slidesToScroll
              : _.options.slidesToShow;
        }
      }
      return pagerQty - 1;
    };
    Slick.prototype.getLeft = function (slideIndex) {
      var _ = this,
        targetLeft,
        verticalHeight,
        verticalOffset = 0,
        targetSlide,
        coef;
      _.slideOffset = 0;
      verticalHeight = _.$slides.first().outerHeight(true);
      if (_.options.infinite === true) {
        if (_.slideCount > _.options.slidesToShow) {
          _.slideOffset = _.slideWidth * _.options.slidesToShow * -1;
          coef = -1;
          if (_.options.vertical === true && _.options.centerMode === true) {
            if (_.options.slidesToShow === 2) {
              coef = -1.5;
            } else if (_.options.slidesToShow === 1) {
              coef = -2;
            }
          }
          verticalOffset = verticalHeight * _.options.slidesToShow * coef;
        }
        if (_.slideCount % _.options.slidesToScroll !== 0) {
          if (
            slideIndex + _.options.slidesToScroll > _.slideCount &&
            _.slideCount > _.options.slidesToShow
          ) {
            if (slideIndex > _.slideCount) {
              _.slideOffset =
                (_.options.slidesToShow - (slideIndex - _.slideCount)) *
                _.slideWidth *
                -1;
              verticalOffset =
                (_.options.slidesToShow - (slideIndex - _.slideCount)) *
                verticalHeight *
                -1;
            } else {
              _.slideOffset =
                (_.slideCount % _.options.slidesToScroll) * _.slideWidth * -1;
              verticalOffset =
                (_.slideCount % _.options.slidesToScroll) * verticalHeight * -1;
            }
          }
        }
      } else {
        if (slideIndex + _.options.slidesToShow > _.slideCount) {
          _.slideOffset =
            (slideIndex + _.options.slidesToShow - _.slideCount) * _.slideWidth;
          verticalOffset =
            (slideIndex + _.options.slidesToShow - _.slideCount) *
            verticalHeight;
        }
      }
      if (_.slideCount <= _.options.slidesToShow) {
        _.slideOffset = 0;
        verticalOffset = 0;
      }
      if (
        _.options.centerMode === true &&
        _.slideCount <= _.options.slidesToShow
      ) {
        _.slideOffset =
          (_.slideWidth * Math.floor(_.options.slidesToShow)) / 2 -
          (_.slideWidth * _.slideCount) / 2;
      } else if (_.options.centerMode === true && _.options.infinite === true) {
        _.slideOffset +=
          _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
      } else if (_.options.centerMode === true) {
        _.slideOffset = 0;
        _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
      }
      if (_.options.vertical === false) {
        targetLeft = slideIndex * _.slideWidth * -1 + _.slideOffset;
      } else {
        targetLeft = slideIndex * verticalHeight * -1 + verticalOffset;
      }
      if (_.options.variableWidth === true) {
        if (
          _.slideCount <= _.options.slidesToShow ||
          _.options.infinite === false
        ) {
          targetSlide = _.$slideTrack.children(".slick-slide").eq(slideIndex);
        } else {
          targetSlide = _.$slideTrack
            .children(".slick-slide")
            .eq(slideIndex + _.options.slidesToShow);
        }
        if (_.options.rtl === true) {
          if (targetSlide[0]) {
            targetLeft =
              (_.$slideTrack.width() -
                targetSlide[0].offsetLeft -
                targetSlide.width()) *
              -1;
          } else {
            targetLeft = 0;
          }
        } else {
          targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
        }
        if (_.options.centerMode === true) {
          if (
            _.slideCount <= _.options.slidesToShow ||
            _.options.infinite === false
          ) {
            targetSlide = _.$slideTrack.children(".slick-slide").eq(slideIndex);
          } else {
            targetSlide = _.$slideTrack
              .children(".slick-slide")
              .eq(slideIndex + _.options.slidesToShow + 1);
          }
          if (_.options.rtl === true) {
            if (targetSlide[0]) {
              targetLeft =
                (_.$slideTrack.width() -
                  targetSlide[0].offsetLeft -
                  targetSlide.width()) *
                -1;
            } else {
              targetLeft = 0;
            }
          } else {
            targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
          }
          targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
        }
      }
      return targetLeft;
    };
    Slick.prototype.getOption = Slick.prototype.slickGetOption = function (
      option
    ) {
      var _ = this;
      return _.options[option];
    };
    Slick.prototype.getNavigableIndexes = function () {
      var _ = this,
        breakPoint = 0,
        counter = 0,
        indexes = [],
        max;
      if (_.options.infinite === false) {
        max = _.slideCount;
      } else {
        breakPoint = _.options.slidesToScroll * -1;
        counter = _.options.slidesToScroll * -1;
        max = _.slideCount * 2;
      }
      while (breakPoint < max) {
        indexes.push(breakPoint);
        breakPoint = counter + _.options.slidesToScroll;
        counter +=
          _.options.slidesToScroll <= _.options.slidesToShow
            ? _.options.slidesToScroll
            : _.options.slidesToShow;
      }
      return indexes;
    };
    Slick.prototype.getSlick = function () {
      return this;
    };
    Slick.prototype.getSlideCount = function () {
      var _ = this,
        slidesTraversed,
        swipedSlide,
        swipeTarget,
        centerOffset;
      centerOffset =
        _.options.centerMode === true ? Math.floor(_.$list.width() / 2) : 0;
      swipeTarget = _.swipeLeft * -1 + centerOffset;
      if (_.options.swipeToSlide === true) {
        _.$slideTrack.find(".slick-slide").each(function (index, slide) {
          var slideOuterWidth, slideOffset, slideRightBoundary;
          slideOuterWidth = $(slide).outerWidth();
          slideOffset = slide.offsetLeft;
          if (_.options.centerMode !== true) {
            slideOffset += slideOuterWidth / 2;
          }
          slideRightBoundary = slideOffset + slideOuterWidth;
          if (swipeTarget < slideRightBoundary) {
            swipedSlide = slide;
            return false;
          }
        });
        slidesTraversed =
          Math.abs($(swipedSlide).attr("data-slick-index") - _.currentSlide) ||
          1;
        return slidesTraversed;
      } else {
        return _.options.slidesToScroll;
      }
    };
    Slick.prototype.goTo = Slick.prototype.slickGoTo = function (
      slide,
      dontAnimate
    ) {
      var _ = this;
      _.changeSlide(
        { data: { message: "index", index: parseInt(slide) } },
        dontAnimate
      );
    };
    Slick.prototype.init = function (creation) {
      var _ = this;
      if (!$(_.$slider).hasClass("slick-initialized")) {
        $(_.$slider).addClass("slick-initialized");
        _.buildRows();
        _.buildOut();
        _.setProps();
        _.startLoad();
        _.loadSlider();
        _.initializeEvents();
        _.updateArrows();
        _.updateDots();
        _.checkResponsive(true);
        _.focusHandler();
      }
      if (creation) {
        _.$slider.trigger("init", [_]);
      }
      if (_.options.accessibility === true) {
        _.initADA();
      }
      if (_.options.autoplay) {
        _.paused = false;
        _.autoPlay();
      }
    };
    Slick.prototype.initADA = function () {
      var _ = this,
        numDotGroups = Math.ceil(_.slideCount / _.options.slidesToShow),
        tabControlIndexes = _.getNavigableIndexes().filter(function (val) {
          return val >= 0 && val < _.slideCount;
        });
      _.$slides
        .add(_.$slideTrack.find(".slick-cloned"))
        .attr({ "aria-hidden": "true", tabindex: "-1" })
        .find("a, input, button, select")
        .attr({ tabindex: "-1" });
      if (_.$dots !== null) {
        _.$slides.not(_.$slideTrack.find(".slick-cloned")).each(function (i) {
          var slideControlIndex = tabControlIndexes.indexOf(i);
          $(this).attr({
            role: "tabpanel",
            id: "slick-slide" + _.instanceUid + i,
            tabindex: -1,
          });
          if (slideControlIndex !== -1) {
            var ariaButtonControl =
              "slick-slide-control" + _.instanceUid + slideControlIndex;
            if ($("#" + ariaButtonControl).length) {
              $(this).attr({ "aria-describedby": ariaButtonControl });
            }
          }
        });
        _.$dots
          .attr("role", "tablist")
          .find("li")
          .each(function (i) {
            var mappedSlideIndex = tabControlIndexes[i];
            $(this).attr({ role: "presentation" });
            $(this)
              .find("button")
              .first()
              .attr({
                role: "tab",
                id: "slick-slide-control" + _.instanceUid + i,
                "aria-controls":
                  "slick-slide" + _.instanceUid + mappedSlideIndex,
                "aria-label": i + 1 + " of " + numDotGroups,
                "aria-selected": null,
                tabindex: "-1",
              });
          })
          .eq(_.currentSlide)
          .find("button")
          .attr({ "aria-selected": "true", tabindex: "0" })
          .end();
      }
      for (
        var i = _.currentSlide, max = i + _.options.slidesToShow;
        i < max;
        i++
      ) {
        if (_.options.focusOnChange) {
          _.$slides.eq(i).attr({ tabindex: "0" });
        } else {
          _.$slides.eq(i).removeAttr("tabindex");
        }
      }
      _.activateADA();
    };
    Slick.prototype.initArrowEvents = function () {
      var _ = this;
      if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
        _.$prevArrow
          .off("click.slick")
          .on("click.slick", { message: "previous" }, _.changeSlide);
        _.$nextArrow
          .off("click.slick")
          .on("click.slick", { message: "next" }, _.changeSlide);
        if (_.options.accessibility === true) {
          _.$prevArrow.on("keydown.slick", _.keyHandler);
          _.$nextArrow.on("keydown.slick", _.keyHandler);
        }
      }
    };
    Slick.prototype.initDotEvents = function () {
      var _ = this;
      if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
        $("li", _.$dots).on("click.slick", { message: "index" }, _.changeSlide);
        if (_.options.accessibility === true) {
          _.$dots.on("keydown.slick", _.keyHandler);
        }
      }
      if (
        _.options.dots === true &&
        _.options.pauseOnDotsHover === true &&
        _.slideCount > _.options.slidesToShow
      ) {
        $("li", _.$dots)
          .on("mouseenter.slick", $.proxy(_.interrupt, _, true))
          .on("mouseleave.slick", $.proxy(_.interrupt, _, false));
      }
    };
    Slick.prototype.initSlideEvents = function () {
      var _ = this;
      if (_.options.pauseOnHover) {
        _.$list.on("mouseenter.slick", $.proxy(_.interrupt, _, true));
        _.$list.on("mouseleave.slick", $.proxy(_.interrupt, _, false));
      }
    };
    Slick.prototype.initializeEvents = function () {
      var _ = this;
      _.initArrowEvents();
      _.initDotEvents();
      _.initSlideEvents();
      _.$list.on(
        "touchstart.slick mousedown.slick",
        { action: "start" },
        _.swipeHandler
      );
      _.$list.on(
        "touchmove.slick mousemove.slick",
        { action: "move" },
        _.swipeHandler
      );
      _.$list.on(
        "touchend.slick mouseup.slick",
        { action: "end" },
        _.swipeHandler
      );
      _.$list.on(
        "touchcancel.slick mouseleave.slick",
        { action: "end" },
        _.swipeHandler
      );
      _.$list.on("click.slick", _.clickHandler);
      $(document).on(_.visibilityChange, $.proxy(_.visibility, _));
      if (_.options.accessibility === true) {
        _.$list.on("keydown.slick", _.keyHandler);
      }
      if (_.options.focusOnSelect === true) {
        $(_.$slideTrack).children().on("click.slick", _.selectHandler);
      }
      $(window).on(
        "orientationchange.slick.slick-" + _.instanceUid,
        $.proxy(_.orientationChange, _)
      );
      $(window).on("resize.slick.slick-" + _.instanceUid, $.proxy(_.resize, _));
      $("[draggable!=true]", _.$slideTrack).on("dragstart", _.preventDefault);
      $(window).on("load.slick.slick-" + _.instanceUid, _.setPosition);
      $(_.setPosition);
    };
    Slick.prototype.initUI = function () {
      var _ = this;
      if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
        _.$prevArrow.show();
        _.$nextArrow.show();
      }
      if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
        _.$dots.show();
      }
    };
    Slick.prototype.keyHandler = function (event) {
      var _ = this;
      if (!event.target.tagName.match("TEXTAREA|INPUT|SELECT")) {
        if (event.keyCode === 37 && _.options.accessibility === true) {
          _.changeSlide({
            data: { message: _.options.rtl === true ? "next" : "previous" },
          });
        } else if (event.keyCode === 39 && _.options.accessibility === true) {
          _.changeSlide({
            data: { message: _.options.rtl === true ? "previous" : "next" },
          });
        }
      }
    };
    Slick.prototype.lazyLoad = function () {
      var _ = this,
        loadRange,
        cloneRange,
        rangeStart,
        rangeEnd;
      function loadImages(imagesScope) {
        $("img[data-lazy]", imagesScope).each(function () {
          var image = $(this),
            imageSource = $(this).attr("data-lazy"),
            imageSrcSet = $(this).attr("data-srcset"),
            imageSizes =
              $(this).attr("data-sizes") || _.$slider.attr("data-sizes"),
            imageToLoad = document.createElement("img");
          imageToLoad.onload = function () {
            image.animate({ opacity: 0 }, 100, function () {
              if (imageSrcSet) {
                image.attr("srcset", imageSrcSet);
                if (imageSizes) {
                  image.attr("sizes", imageSizes);
                }
              }
              image
                .attr("src", imageSource)
                .animate({ opacity: 1 }, 200, function () {
                  image
                    .removeAttr("data-lazy data-srcset data-sizes")
                    .removeClass("slick-loading");
                });
              _.$slider.trigger("lazyLoaded", [_, image, imageSource]);
            });
          };
          imageToLoad.onerror = function () {
            image
              .removeAttr("data-lazy")
              .removeClass("slick-loading")
              .addClass("slick-lazyload-error");
            _.$slider.trigger("lazyLoadError", [_, image, imageSource]);
          };
          imageToLoad.src = imageSource;
        });
      }
      if (_.options.centerMode === true) {
        if (_.options.infinite === true) {
          rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
          rangeEnd = rangeStart + _.options.slidesToShow + 2;
        } else {
          rangeStart = Math.max(
            0,
            _.currentSlide - (_.options.slidesToShow / 2 + 1)
          );
          rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
        }
      } else {
        rangeStart = _.options.infinite
          ? _.options.slidesToShow + _.currentSlide
          : _.currentSlide;
        rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
        if (_.options.fade === true) {
          if (rangeStart > 0) rangeStart--;
          if (rangeEnd <= _.slideCount) rangeEnd++;
        }
      }
      loadRange = _.$slider.find(".slick-slide").slice(rangeStart, rangeEnd);
      if (_.options.lazyLoad === "anticipated") {
        var prevSlide = rangeStart - 1,
          nextSlide = rangeEnd,
          $slides = _.$slider.find(".slick-slide");
        for (var i = 0; i < _.options.slidesToScroll; i++) {
          if (prevSlide < 0) prevSlide = _.slideCount - 1;
          loadRange = loadRange.add($slides.eq(prevSlide));
          loadRange = loadRange.add($slides.eq(nextSlide));
          prevSlide--;
          nextSlide++;
        }
      }
      loadImages(loadRange);
      if (_.slideCount <= _.options.slidesToShow) {
        cloneRange = _.$slider.find(".slick-slide");
        loadImages(cloneRange);
      } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
        cloneRange = _.$slider
          .find(".slick-cloned")
          .slice(0, _.options.slidesToShow);
        loadImages(cloneRange);
      } else if (_.currentSlide === 0) {
        cloneRange = _.$slider
          .find(".slick-cloned")
          .slice(_.options.slidesToShow * -1);
        loadImages(cloneRange);
      }
    };
    Slick.prototype.loadSlider = function () {
      var _ = this;
      _.setPosition();
      _.$slideTrack.css({ opacity: 1 });
      _.$slider.removeClass("slick-loading");
      _.initUI();
      if (_.options.lazyLoad === "progressive") {
        _.progressiveLazyLoad();
      }
    };
    Slick.prototype.next = Slick.prototype.slickNext = function () {
      var _ = this;
      _.changeSlide({ data: { message: "next" } });
    };
    Slick.prototype.orientationChange = function () {
      var _ = this;
      _.checkResponsive();
      _.setPosition();
    };
    Slick.prototype.pause = Slick.prototype.slickPause = function () {
      var _ = this;
      _.autoPlayClear();
      _.paused = true;
    };
    Slick.prototype.play = Slick.prototype.slickPlay = function () {
      var _ = this;
      _.autoPlay();
      _.options.autoplay = true;
      _.paused = false;
      _.focussed = false;
      _.interrupted = false;
    };
    Slick.prototype.postSlide = function (index) {
      var _ = this;
      if (!_.unslicked) {
        _.$slider.trigger("afterChange", [_, index]);
        _.animating = false;
        if (_.slideCount > _.options.slidesToShow) {
          _.setPosition();
        }
        _.swipeLeft = null;
        if (_.options.autoplay) {
          _.autoPlay();
        }
        if (_.options.accessibility === true) {
          _.initADA();
          if (_.options.focusOnChange) {
            var $currentSlide = $(_.$slides.get(_.currentSlide));
            $currentSlide.attr("tabindex", 0).focus();
          }
        }
      }
    };
    Slick.prototype.prev = Slick.prototype.slickPrev = function () {
      var _ = this;
      _.changeSlide({ data: { message: "previous" } });
    };
    Slick.prototype.preventDefault = function (event) {
      event.preventDefault();
    };
    Slick.prototype.progressiveLazyLoad = function (tryCount) {
      tryCount = tryCount || 1;
      var _ = this,
        $imgsToLoad = $("img[data-lazy]", _.$slider),
        image,
        imageSource,
        imageSrcSet,
        imageSizes,
        imageToLoad;
      if ($imgsToLoad.length) {
        image = $imgsToLoad.first();
        imageSource = image.attr("data-lazy");
        imageSrcSet = image.attr("data-srcset");
        imageSizes = image.attr("data-sizes") || _.$slider.attr("data-sizes");
        imageToLoad = document.createElement("img");
        imageToLoad.onload = function () {
          if (imageSrcSet) {
            image.attr("srcset", imageSrcSet);
            if (imageSizes) {
              image.attr("sizes", imageSizes);
            }
          }
          image
            .attr("src", imageSource)
            .removeAttr("data-lazy data-srcset data-sizes")
            .removeClass("slick-loading");
          if (_.options.adaptiveHeight === true) {
            _.setPosition();
          }
          _.$slider.trigger("lazyLoaded", [_, image, imageSource]);
          _.progressiveLazyLoad();
        };
        imageToLoad.onerror = function () {
          if (tryCount < 3) {
            setTimeout(function () {
              _.progressiveLazyLoad(tryCount + 1);
            }, 500);
          } else {
            image
              .removeAttr("data-lazy")
              .removeClass("slick-loading")
              .addClass("slick-lazyload-error");
            _.$slider.trigger("lazyLoadError", [_, image, imageSource]);
            _.progressiveLazyLoad();
          }
        };
        imageToLoad.src = imageSource;
      } else {
        _.$slider.trigger("allImagesLoaded", [_]);
      }
    };
    Slick.prototype.refresh = function (initializing) {
      var _ = this,
        currentSlide,
        lastVisibleIndex;
      lastVisibleIndex = _.slideCount - _.options.slidesToShow;
      if (!_.options.infinite && _.currentSlide > lastVisibleIndex) {
        _.currentSlide = lastVisibleIndex;
      }
      if (_.slideCount <= _.options.slidesToShow) {
        _.currentSlide = 0;
      }
      currentSlide = _.currentSlide;
      _.destroy(true);
      $.extend(_, _.initials, { currentSlide: currentSlide });
      _.init();
      if (!initializing) {
        _.changeSlide(
          { data: { message: "index", index: currentSlide } },
          false
        );
      }
    };
    Slick.prototype.registerBreakpoints = function () {
      var _ = this,
        breakpoint,
        currentBreakpoint,
        l,
        responsiveSettings = _.options.responsive || null;
      if ($.type(responsiveSettings) === "array" && responsiveSettings.length) {
        _.respondTo = _.options.respondTo || "window";
        for (breakpoint in responsiveSettings) {
          l = _.breakpoints.length - 1;
          if (responsiveSettings.hasOwnProperty(breakpoint)) {
            currentBreakpoint = responsiveSettings[breakpoint].breakpoint;
            while (l >= 0) {
              if (_.breakpoints[l] && _.breakpoints[l] === currentBreakpoint) {
                _.breakpoints.splice(l, 1);
              }
              l--;
            }
            _.breakpoints.push(currentBreakpoint);
            _.breakpointSettings[currentBreakpoint] =
              responsiveSettings[breakpoint].settings;
          }
        }
        _.breakpoints.sort(function (a, b) {
          return _.options.mobileFirst ? a - b : b - a;
        });
      }
    };
    Slick.prototype.reinit = function () {
      var _ = this;
      _.$slides = _.$slideTrack
        .children(_.options.slide)
        .addClass("slick-slide");
      _.slideCount = _.$slides.length;
      if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) {
        _.currentSlide = _.currentSlide - _.options.slidesToScroll;
      }
      if (_.slideCount <= _.options.slidesToShow) {
        _.currentSlide = 0;
      }
      _.registerBreakpoints();
      _.setProps();
      _.setupInfinite();
      _.buildArrows();
      _.updateArrows();
      _.initArrowEvents();
      _.buildDots();
      _.updateDots();
      _.initDotEvents();
      _.cleanUpSlideEvents();
      _.initSlideEvents();
      _.checkResponsive(false, true);
      if (_.options.focusOnSelect === true) {
        $(_.$slideTrack).children().on("click.slick", _.selectHandler);
      }
      _.setSlideClasses(
        typeof _.currentSlide === "number" ? _.currentSlide : 0
      );
      _.setPosition();
      _.focusHandler();
      _.paused = !_.options.autoplay;
      _.autoPlay();
      _.$slider.trigger("reInit", [_]);
    };
    Slick.prototype.resize = function () {
      var _ = this;
      if ($(window).width() !== _.windowWidth) {
        clearTimeout(_.windowDelay);
        _.windowDelay = window.setTimeout(function () {
          _.windowWidth = $(window).width();
          _.checkResponsive();
          if (!_.unslicked) {
            _.setPosition();
          }
        }, 50);
      }
    };
    Slick.prototype.removeSlide = Slick.prototype.slickRemove = function (
      index,
      removeBefore,
      removeAll
    ) {
      var _ = this;
      if (typeof index === "boolean") {
        removeBefore = index;
        index = removeBefore === true ? 0 : _.slideCount - 1;
      } else {
        index = removeBefore === true ? --index : index;
      }
      if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) {
        return false;
      }
      _.unload();
      if (removeAll === true) {
        _.$slideTrack.children().remove();
      } else {
        _.$slideTrack.children(this.options.slide).eq(index).remove();
      }
      _.$slides = _.$slideTrack.children(this.options.slide);
      _.$slideTrack.children(this.options.slide).detach();
      _.$slideTrack.append(_.$slides);
      _.$slidesCache = _.$slides;
      _.reinit();
    };
    Slick.prototype.setCSS = function (position) {
      var _ = this,
        positionProps = {},
        x,
        y;
      if (_.options.rtl === true) {
        position = -position;
      }
      x = _.positionProp == "left" ? Math.ceil(position) + "px" : "0px";
      y = _.positionProp == "top" ? Math.ceil(position) + "px" : "0px";
      positionProps[_.positionProp] = position;
      if (_.transformsEnabled === false) {
        _.$slideTrack.css(positionProps);
      } else {
        positionProps = {};
        if (_.cssTransitions === false) {
          positionProps[_.animType] = "translate(" + x + ", " + y + ")";
          _.$slideTrack.css(positionProps);
        } else {
          positionProps[_.animType] = "translate3d(" + x + ", " + y + ", 0px)";
          _.$slideTrack.css(positionProps);
        }
      }
    };
    Slick.prototype.setDimensions = function () {
      var _ = this;
      if (_.options.vertical === false) {
        if (_.options.centerMode === true) {
          _.$list.css({ padding: "0px " + _.options.centerPadding });
        }
      } else {
        _.$list.height(
          _.$slides.first().outerHeight(true) * _.options.slidesToShow
        );
        if (_.options.centerMode === true) {
          _.$list.css({ padding: _.options.centerPadding + " 0px" });
        }
      }
      _.listWidth = _.$list.width();
      _.listHeight = _.$list.height();
      if (_.options.vertical === false && _.options.variableWidth === false) {
        _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
        _.$slideTrack.width(
          Math.ceil(
            _.slideWidth * _.$slideTrack.children(".slick-slide").length
          )
        );
      } else if (_.options.variableWidth === true) {
        _.$slideTrack.width(5e3 * _.slideCount);
      } else {
        _.slideWidth = Math.ceil(_.listWidth);
        _.$slideTrack.height(
          Math.ceil(
            _.$slides.first().outerHeight(true) *
              _.$slideTrack.children(".slick-slide").length
          )
        );
      }
      var offset =
        _.$slides.first().outerWidth(true) - _.$slides.first().width();
      if (_.options.variableWidth === false)
        _.$slideTrack.children(".slick-slide").width(_.slideWidth - offset);
    };
    Slick.prototype.setFade = function () {
      var _ = this,
        targetLeft;
      _.$slides.each(function (index, element) {
        targetLeft = _.slideWidth * index * -1;
        if (_.options.rtl === true) {
          $(element).css({
            position: "relative",
            right: targetLeft,
            top: 0,
            zIndex: _.options.zIndex - 2,
            opacity: 0,
          });
        } else {
          $(element).css({
            position: "relative",
            left: targetLeft,
            top: 0,
            zIndex: _.options.zIndex - 2,
            opacity: 0,
          });
        }
      });
      _.$slides
        .eq(_.currentSlide)
        .css({ zIndex: _.options.zIndex - 1, opacity: 1 });
    };
    Slick.prototype.setHeight = function () {
      var _ = this;
      if (
        _.options.slidesToShow === 1 &&
        _.options.adaptiveHeight === true &&
        _.options.vertical === false
      ) {
        var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
        _.$list.css("height", targetHeight);
      }
    };
    Slick.prototype.setOption = Slick.prototype.slickSetOption = function () {
      var _ = this,
        l,
        item,
        option,
        value,
        refresh = false,
        type;
      if ($.type(arguments[0]) === "object") {
        option = arguments[0];
        refresh = arguments[1];
        type = "multiple";
      } else if ($.type(arguments[0]) === "string") {
        option = arguments[0];
        value = arguments[1];
        refresh = arguments[2];
        if (arguments[0] === "responsive" && $.type(arguments[1]) === "array") {
          type = "responsive";
        } else if (typeof arguments[1] !== "undefined") {
          type = "single";
        }
      }
      if (type === "single") {
        _.options[option] = value;
      } else if (type === "multiple") {
        $.each(option, function (opt, val) {
          _.options[opt] = val;
        });
      } else if (type === "responsive") {
        for (item in value) {
          if ($.type(_.options.responsive) !== "array") {
            _.options.responsive = [value[item]];
          } else {
            l = _.options.responsive.length - 1;
            while (l >= 0) {
              if (
                _.options.responsive[l].breakpoint === value[item].breakpoint
              ) {
                _.options.responsive.splice(l, 1);
              }
              l--;
            }
            _.options.responsive.push(value[item]);
          }
        }
      }
      if (refresh) {
        _.unload();
        _.reinit();
      }
    };
    Slick.prototype.setPosition = function () {
      var _ = this;
      _.setDimensions();
      _.setHeight();
      if (_.options.fade === false) {
        _.setCSS(_.getLeft(_.currentSlide));
      } else {
        _.setFade();
      }
      _.$slider.trigger("setPosition", [_]);
    };
    Slick.prototype.setProps = function () {
      var _ = this,
        bodyStyle = document.body.style;
      _.positionProp = _.options.vertical === true ? "top" : "left";
      if (_.positionProp === "top") {
        _.$slider.addClass("slick-vertical");
      } else {
        _.$slider.removeClass("slick-vertical");
      }
      if (
        bodyStyle.WebkitTransition !== undefined ||
        bodyStyle.MozTransition !== undefined ||
        bodyStyle.msTransition !== undefined
      ) {
        if (_.options.useCSS === true) {
          _.cssTransitions = true;
        }
      }
      if (_.options.fade) {
        if (typeof _.options.zIndex === "number") {
          if (_.options.zIndex < 3) {
            _.options.zIndex = 3;
          }
        } else {
          _.options.zIndex = _.defaults.zIndex;
        }
      }
      if (bodyStyle.OTransform !== undefined) {
        _.animType = "OTransform";
        _.transformType = "-o-transform";
        _.transitionType = "OTransition";
        if (
          bodyStyle.perspectiveProperty === undefined &&
          bodyStyle.webkitPerspective === undefined
        )
          _.animType = false;
      }
      if (bodyStyle.MozTransform !== undefined) {
        _.animType = "MozTransform";
        _.transformType = "-moz-transform";
        _.transitionType = "MozTransition";
        if (
          bodyStyle.perspectiveProperty === undefined &&
          bodyStyle.MozPerspective === undefined
        )
          _.animType = false;
      }
      if (bodyStyle.webkitTransform !== undefined) {
        _.animType = "webkitTransform";
        _.transformType = "-webkit-transform";
        _.transitionType = "webkitTransition";
        if (
          bodyStyle.perspectiveProperty === undefined &&
          bodyStyle.webkitPerspective === undefined
        )
          _.animType = false;
      }
      if (bodyStyle.msTransform !== undefined) {
        _.animType = "msTransform";
        _.transformType = "-ms-transform";
        _.transitionType = "msTransition";
        if (bodyStyle.msTransform === undefined) _.animType = false;
      }
      if (bodyStyle.transform !== undefined && _.animType !== false) {
        _.animType = "transform";
        _.transformType = "transform";
        _.transitionType = "transition";
      }
      _.transformsEnabled =
        _.options.useTransform && _.animType !== null && _.animType !== false;
    };
    Slick.prototype.setSlideClasses = function (index) {
      var _ = this,
        centerOffset,
        allSlides,
        indexOffset,
        remainder;
      allSlides = _.$slider
        .find(".slick-slide")
        .removeClass("slick-active slick-center slick-current")
        .attr("aria-hidden", "true");
      _.$slides.eq(index).addClass("slick-current");
      if (_.options.centerMode === true) {
        var evenCoef = _.options.slidesToShow % 2 === 0 ? 1 : 0;
        centerOffset = Math.floor(_.options.slidesToShow / 2);
        if (_.options.infinite === true) {
          if (
            index >= centerOffset &&
            index <= _.slideCount - 1 - centerOffset
          ) {
            _.$slides
              .slice(index - centerOffset + evenCoef, index + centerOffset + 1)
              .addClass("slick-active")
              .attr("aria-hidden", "false");
          } else {
            indexOffset = _.options.slidesToShow + index;
            allSlides
              .slice(
                indexOffset - centerOffset + 1 + evenCoef,
                indexOffset + centerOffset + 2
              )
              .addClass("slick-active")
              .attr("aria-hidden", "false");
          }
          if (index === 0) {
            allSlides
              .eq(allSlides.length - 1 - _.options.slidesToShow)
              .addClass("slick-center");
          } else if (index === _.slideCount - 1) {
            allSlides.eq(_.options.slidesToShow).addClass("slick-center");
          }
        }
        _.$slides.eq(index).addClass("slick-center");
      } else {
        if (index >= 0 && index <= _.slideCount - _.options.slidesToShow) {
          _.$slides
            .slice(index, index + _.options.slidesToShow)
            .addClass("slick-active")
            .attr("aria-hidden", "false");
        } else if (allSlides.length <= _.options.slidesToShow) {
          allSlides.addClass("slick-active").attr("aria-hidden", "false");
        } else {
          remainder = _.slideCount % _.options.slidesToShow;
          indexOffset =
            _.options.infinite === true
              ? _.options.slidesToShow + index
              : index;
          if (
            _.options.slidesToShow == _.options.slidesToScroll &&
            _.slideCount - index < _.options.slidesToShow
          ) {
            allSlides
              .slice(
                indexOffset - (_.options.slidesToShow - remainder),
                indexOffset + remainder
              )
              .addClass("slick-active")
              .attr("aria-hidden", "false");
          } else {
            allSlides
              .slice(indexOffset, indexOffset + _.options.slidesToShow)
              .addClass("slick-active")
              .attr("aria-hidden", "false");
          }
        }
      }
      if (
        _.options.lazyLoad === "ondemand" ||
        _.options.lazyLoad === "anticipated"
      ) {
        _.lazyLoad();
      }
    };
    Slick.prototype.setupInfinite = function () {
      var _ = this,
        i,
        slideIndex,
        infiniteCount;
      if (_.options.fade === true) {
        _.options.centerMode = false;
      }
      if (_.options.infinite === true && _.options.fade === false) {
        slideIndex = null;
        if (_.slideCount > _.options.slidesToShow) {
          if (_.options.centerMode === true) {
            infiniteCount = _.options.slidesToShow + 1;
          } else {
            infiniteCount = _.options.slidesToShow;
          }
          for (i = _.slideCount; i > _.slideCount - infiniteCount; i -= 1) {
            slideIndex = i - 1;
            $(_.$slides[slideIndex])
              .clone(true)
              .attr("id", "")
              .attr("data-slick-index", slideIndex - _.slideCount)
              .prependTo(_.$slideTrack)
              .addClass("slick-cloned");
          }
          for (i = 0; i < infiniteCount + _.slideCount; i += 1) {
            slideIndex = i;
            $(_.$slides[slideIndex])
              .clone(true)
              .attr("id", "")
              .attr("data-slick-index", slideIndex + _.slideCount)
              .appendTo(_.$slideTrack)
              .addClass("slick-cloned");
          }
          _.$slideTrack
            .find(".slick-cloned")
            .find("[id]")
            .each(function () {
              $(this).attr("id", "");
            });
        }
      }
    };
    Slick.prototype.interrupt = function (toggle) {
      var _ = this;
      if (!toggle) {
        _.autoPlay();
      }
      _.interrupted = toggle;
    };
    Slick.prototype.selectHandler = function (event) {
      var _ = this;
      var targetElement = $(event.target).is(".slick-slide")
        ? $(event.target)
        : $(event.target).parents(".slick-slide");
      var index = parseInt(targetElement.attr("data-slick-index"));
      if (!index) index = 0;
      if (_.slideCount <= _.options.slidesToShow) {
        _.slideHandler(index, false, true);
        return;
      }
      _.slideHandler(index);
    };
    Slick.prototype.slideHandler = function (index, sync, dontAnimate) {
      var targetSlide,
        animSlide,
        oldSlide,
        slideLeft,
        targetLeft = null,
        _ = this,
        navTarget;
      sync = sync || false;
      if (_.animating === true && _.options.waitForAnimate === true) {
        return;
      }
      if (_.options.fade === true && _.currentSlide === index) {
        return;
      }
      if (sync === false) {
        _.asNavFor(index);
      }
      targetSlide = index;
      targetLeft = _.getLeft(targetSlide);
      slideLeft = _.getLeft(_.currentSlide);
      _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;
      if (
        _.options.infinite === false &&
        _.options.centerMode === false &&
        (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)
      ) {
        if (_.options.fade === false) {
          targetSlide = _.currentSlide;
          if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
            _.animateSlide(slideLeft, function () {
              _.postSlide(targetSlide);
            });
          } else {
            _.postSlide(targetSlide);
          }
        }
        return;
      } else if (
        _.options.infinite === false &&
        _.options.centerMode === true &&
        (index < 0 || index > _.slideCount - _.options.slidesToScroll)
      ) {
        if (_.options.fade === false) {
          targetSlide = _.currentSlide;
          if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
            _.animateSlide(slideLeft, function () {
              _.postSlide(targetSlide);
            });
          } else {
            _.postSlide(targetSlide);
          }
        }
        return;
      }
      if (_.options.autoplay) {
        clearInterval(_.autoPlayTimer);
      }
      if (targetSlide < 0) {
        if (_.slideCount % _.options.slidesToScroll !== 0) {
          animSlide = _.slideCount - (_.slideCount % _.options.slidesToScroll);
        } else {
          animSlide = _.slideCount + targetSlide;
        }
      } else if (targetSlide >= _.slideCount) {
        if (_.slideCount % _.options.slidesToScroll !== 0) {
          animSlide = 0;
        } else {
          animSlide = targetSlide - _.slideCount;
        }
      } else {
        animSlide = targetSlide;
      }
      _.animating = true;
      _.$slider.trigger("beforeChange", [_, _.currentSlide, animSlide]);
      oldSlide = _.currentSlide;
      _.currentSlide = animSlide;
      _.setSlideClasses(_.currentSlide);
      if (_.options.asNavFor) {
        navTarget = _.getNavTarget();
        navTarget = navTarget.slick("getSlick");
        if (navTarget.slideCount <= navTarget.options.slidesToShow) {
          navTarget.setSlideClasses(_.currentSlide);
        }
      }
      _.updateDots();
      _.updateArrows();
      if (_.options.fade === true) {
        if (dontAnimate !== true) {
          _.fadeSlideOut(oldSlide);
          _.fadeSlide(animSlide, function () {
            _.postSlide(animSlide);
          });
        } else {
          _.postSlide(animSlide);
        }
        _.animateHeight();
        return;
      }
      if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
        _.animateSlide(targetLeft, function () {
          _.postSlide(animSlide);
        });
      } else {
        _.postSlide(animSlide);
      }
    };
    Slick.prototype.startLoad = function () {
      var _ = this;
      if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
        _.$prevArrow.hide();
        _.$nextArrow.hide();
      }
      if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
        _.$dots.hide();
      }
      _.$slider.addClass("slick-loading");
    };
    Slick.prototype.swipeDirection = function () {
      var xDist,
        yDist,
        r,
        swipeAngle,
        _ = this;
      xDist = _.touchObject.startX - _.touchObject.curX;
      yDist = _.touchObject.startY - _.touchObject.curY;
      r = Math.atan2(yDist, xDist);
      swipeAngle = Math.round((r * 180) / Math.PI);
      if (swipeAngle < 0) {
        swipeAngle = 360 - Math.abs(swipeAngle);
      }
      if (swipeAngle <= 45 && swipeAngle >= 0) {
        return _.options.rtl === false ? "left" : "right";
      }
      if (swipeAngle <= 360 && swipeAngle >= 315) {
        return _.options.rtl === false ? "left" : "right";
      }
      if (swipeAngle >= 135 && swipeAngle <= 225) {
        return _.options.rtl === false ? "right" : "left";
      }
      if (_.options.verticalSwiping === true) {
        if (swipeAngle >= 35 && swipeAngle <= 135) {
          return "down";
        } else {
          return "up";
        }
      }
      return "vertical";
    };
    Slick.prototype.swipeEnd = function (event) {
      var _ = this,
        slideCount,
        direction;
      _.dragging = false;
      _.swiping = false;
      if (_.scrolling) {
        _.scrolling = false;
        return false;
      }
      _.interrupted = false;
      _.shouldClick = _.touchObject.swipeLength > 10 ? false : true;
      if (_.touchObject.curX === undefined) {
        return false;
      }
      if (_.touchObject.edgeHit === true) {
        _.$slider.trigger("edge", [_, _.swipeDirection()]);
      }
      if (_.touchObject.swipeLength >= _.touchObject.minSwipe) {
        direction = _.swipeDirection();
        switch (direction) {
          case "left":
          case "down":
            slideCount = _.options.swipeToSlide
              ? _.checkNavigable(_.currentSlide + _.getSlideCount())
              : _.currentSlide + _.getSlideCount();
            _.currentDirection = 0;
            break;
          case "right":
          case "up":
            slideCount = _.options.swipeToSlide
              ? _.checkNavigable(_.currentSlide - _.getSlideCount())
              : _.currentSlide - _.getSlideCount();
            _.currentDirection = 1;
            break;
          default:
        }
        if (direction != "vertical") {
          _.slideHandler(slideCount);
          _.touchObject = {};
          _.$slider.trigger("swipe", [_, direction]);
        }
      } else {
        if (_.touchObject.startX !== _.touchObject.curX) {
          _.slideHandler(_.currentSlide);
          _.touchObject = {};
        }
      }
    };
    Slick.prototype.swipeHandler = function (event) {
      var _ = this;
      if (
        _.options.swipe === false ||
        ("ontouchend" in document && _.options.swipe === false)
      ) {
        return;
      } else if (
        _.options.draggable === false &&
        event.type.indexOf("mouse") !== -1
      ) {
        return;
      }
      _.touchObject.fingerCount =
        event.originalEvent && event.originalEvent.touches !== undefined
          ? event.originalEvent.touches.length
          : 1;
      _.touchObject.minSwipe = _.listWidth / _.options.touchThreshold;
      if (_.options.verticalSwiping === true) {
        _.touchObject.minSwipe = _.listHeight / _.options.touchThreshold;
      }
      switch (event.data.action) {
        case "start":
          _.swipeStart(event);
          break;
        case "move":
          _.swipeMove(event);
          break;
        case "end":
          _.swipeEnd(event);
          break;
      }
    };
    Slick.prototype.swipeMove = function (event) {
      var _ = this,
        edgeWasHit = false,
        curLeft,
        swipeDirection,
        swipeLength,
        positionOffset,
        touches,
        verticalSwipeLength;
      touches =
        event.originalEvent !== undefined ? event.originalEvent.touches : null;
      if (!_.dragging || _.scrolling || (touches && touches.length !== 1)) {
        return false;
      }
      curLeft = _.getLeft(_.currentSlide);
      _.touchObject.curX =
        touches !== undefined ? touches[0].pageX : event.clientX;
      _.touchObject.curY =
        touches !== undefined ? touches[0].pageY : event.clientY;
      _.touchObject.swipeLength = Math.round(
        Math.sqrt(Math.pow(_.touchObject.curX - _.touchObject.startX, 2))
      );
      verticalSwipeLength = Math.round(
        Math.sqrt(Math.pow(_.touchObject.curY - _.touchObject.startY, 2))
      );
      if (!_.options.verticalSwiping && !_.swiping && verticalSwipeLength > 4) {
        _.scrolling = true;
        return false;
      }
      if (_.options.verticalSwiping === true) {
        _.touchObject.swipeLength = verticalSwipeLength;
      }
      swipeDirection = _.swipeDirection();
      if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
        _.swiping = true;
        event.preventDefault();
      }
      positionOffset =
        (_.options.rtl === false ? 1 : -1) *
        (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
      if (_.options.verticalSwiping === true) {
        positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
      }
      swipeLength = _.touchObject.swipeLength;
      _.touchObject.edgeHit = false;
      if (_.options.infinite === false) {
        if (
          (_.currentSlide === 0 && swipeDirection === "right") ||
          (_.currentSlide >= _.getDotCount() && swipeDirection === "left")
        ) {
          swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
          _.touchObject.edgeHit = true;
        }
      }
      if (_.options.vertical === false) {
        _.swipeLeft = curLeft + swipeLength * positionOffset;
      } else {
        _.swipeLeft =
          curLeft +
          swipeLength * (_.$list.height() / _.listWidth) * positionOffset;
      }
      if (_.options.verticalSwiping === true) {
        _.swipeLeft = curLeft + swipeLength * positionOffset;
      }
      if (_.options.fade === true || _.options.touchMove === false) {
        return false;
      }
      if (_.animating === true) {
        _.swipeLeft = null;
        return false;
      }
      _.setCSS(_.swipeLeft);
    };
    Slick.prototype.swipeStart = function (event) {
      var _ = this,
        touches;
      _.interrupted = true;
      if (
        _.touchObject.fingerCount !== 1 ||
        _.slideCount <= _.options.slidesToShow
      ) {
        _.touchObject = {};
        return false;
      }
      if (
        event.originalEvent !== undefined &&
        event.originalEvent.touches !== undefined
      ) {
        touches = event.originalEvent.touches[0];
      }
      _.touchObject.startX = _.touchObject.curX =
        touches !== undefined ? touches.pageX : event.clientX;
      _.touchObject.startY = _.touchObject.curY =
        touches !== undefined ? touches.pageY : event.clientY;
      _.dragging = true;
    };
    Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function () {
      var _ = this;
      if (_.$slidesCache !== null) {
        _.unload();
        _.$slideTrack.children(this.options.slide).detach();
        _.$slidesCache.appendTo(_.$slideTrack);
        _.reinit();
      }
    };
    Slick.prototype.unload = function () {
      var _ = this;
      $(".slick-cloned", _.$slider).remove();
      if (_.$dots) {
        _.$dots.remove();
      }
      if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) {
        _.$prevArrow.remove();
      }
      if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) {
        _.$nextArrow.remove();
      }
      _.$slides
        .removeClass("slick-slide slick-active slick-visible slick-current")
        .attr("aria-hidden", "true")
        .css("width", "");
    };
    Slick.prototype.unslick = function (fromBreakpoint) {
      var _ = this;
      _.$slider.trigger("unslick", [_, fromBreakpoint]);
      _.destroy();
    };
    Slick.prototype.updateArrows = function () {
      var _ = this,
        centerOffset;
      centerOffset = Math.floor(_.options.slidesToShow / 2);
      if (
        _.options.arrows === true &&
        _.slideCount > _.options.slidesToShow &&
        !_.options.infinite
      ) {
        _.$prevArrow
          .removeClass("slick-disabled")
          .attr("aria-disabled", "false");
        _.$nextArrow
          .removeClass("slick-disabled")
          .attr("aria-disabled", "false");
        if (_.currentSlide === 0) {
          _.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true");
          _.$nextArrow
            .removeClass("slick-disabled")
            .attr("aria-disabled", "false");
        } else if (
          _.currentSlide >= _.slideCount - _.options.slidesToShow &&
          _.options.centerMode === false
        ) {
          _.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true");
          _.$prevArrow
            .removeClass("slick-disabled")
            .attr("aria-disabled", "false");
        } else if (
          _.currentSlide >= _.slideCount - 1 &&
          _.options.centerMode === true
        ) {
          _.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true");
          _.$prevArrow
            .removeClass("slick-disabled")
            .attr("aria-disabled", "false");
        }
      }
    };
    Slick.prototype.updateDots = function () {
      var _ = this;
      if (_.$dots !== null) {
        _.$dots.find("li").removeClass("slick-active").end();
        _.$dots
          .find("li")
          .eq(Math.floor(_.currentSlide / _.options.slidesToScroll))
          .addClass("slick-active");
      }
    };
    Slick.prototype.visibility = function () {
      var _ = this;
      if (_.options.autoplay) {
        if (document[_.hidden]) {
          _.interrupted = true;
        } else {
          _.interrupted = false;
        }
      }
    };
    $.fn.slick = function () {
      var _ = this,
        opt = arguments[0],
        args = Array.prototype.slice.call(arguments, 1),
        l = _.length,
        i,
        ret;
      for (i = 0; i < l; i++) {
        if (typeof opt == "object" || typeof opt == "undefined")
          _[i].slick = new Slick(_[i], opt);
        else ret = _[i].slick[opt].apply(_[i].slick, args);
        if (typeof ret != "undefined") return ret;
      }
      return _;
    };
  }),
  /*!
   * jquery.ba-throttle-debounce.min.js
   */
  /*
   * jQuery throttle / debounce - v1.1 - 3/7/2010
   * http://benalman.com/projects/jquery-throttle-debounce-plugin/
   *
   * Copyright (c) 2010 "Cowboy" Ben Alman
   * Dual licensed under the MIT and GPL licenses.
   * http://benalman.com/about/license/
   */
  (function (e, t) {
    var n,
      i = e.jQuery || e.Cowboy || (e.Cowboy = {});
    (i.throttle = n = function (e, n, o, r) {
      function s() {
        function i() {
          (l = +new Date()), o.apply(u, d);
        }
        function s() {
          a = t;
        }
        var u = this,
          c = +new Date() - l,
          d = arguments;
        r && !a && i(),
          a && clearTimeout(a),
          r === t && c > e
            ? i()
            : n !== !0 && (a = setTimeout(r ? s : i, r === t ? e - c : e));
      }
      var a,
        l = 0;
      return (
        "boolean" != typeof n && ((r = o), (o = n), (n = t)),
        i.guid && (s.guid = o.guid = o.guid || i.guid++),
        s
      );
    }),
      (i.debounce = function (e, i, o) {
        return o === t ? n(e, i, !1) : n(e, o, i !== !1);
      });
  })(this);

/**
 * sticky-sidebar - A JavaScript plugin for making smart and high performance.
 * @version v3.3.1
 * @link https://github.com/abouolia/sticky-sidebar
 * @author Ahmed Bouhuolia
 * @license The MIT License (MIT)
 **/
!(function (t, e) {
  "object" == typeof exports && "undefined" != typeof module
    ? e(exports)
    : "function" == typeof define && define.amd
    ? define(["exports"], e)
    : e((t.StickySidebar = {}));
})(this, function (t) {
  "use strict";
  "undefined" != typeof window
    ? window
    : "undefined" != typeof global
    ? global
    : "undefined" != typeof self && self;
  var e,
    i,
    n =
      ((function (t, e) {
        (function (t) {
          Object.defineProperty(t, "__esModule", { value: !0 });
          var l,
            n,
            e = (function () {
              function n(t, e) {
                for (var i = 0; i < e.length; i++) {
                  var n = e[i];
                  (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(t, n.key, n);
                }
              }
              return function (t, e, i) {
                return e && n(t.prototype, e), i && n(t, i), t;
              };
            })(),
            i =
              ((l = ".stickySidebar"),
              (n = {
                topSpacing: 0,
                bottomSpacing: 0,
                containerSelector: !1,
                innerWrapperSelector: ".inner-wrapper-sticky",
                stickyClass: "is-affixed",
                resizeSensor: !0,
                minWidth: !1,
              }),
              (function () {
                function c(t) {
                  var e = this,
                    i =
                      1 < arguments.length && void 0 !== arguments[1]
                        ? arguments[1]
                        : {};
                  if (
                    ((function (t, e) {
                      if (!(t instanceof e))
                        throw new TypeError(
                          "Cannot call a class as a function"
                        );
                    })(this, c),
                    (this.options = c.extend(n, i)),
                    (this.sidebar =
                      "string" == typeof t ? document.querySelector(t) : t),
                    void 0 === this.sidebar)
                  )
                    throw new Error("There is no specific sidebar element.");
                  (this.sidebarInner = !1),
                    (this.container = this.sidebar.parentElement),
                    (this.affixedType = "STATIC"),
                    (this.direction = "down"),
                    (this.support = { transform: !1, transform3d: !1 }),
                    (this._initialized = !1),
                    (this._reStyle = !1),
                    (this._breakpoint = !1),
                    (this.dimensions = {
                      translateY: 0,
                      maxTranslateY: 0,
                      topSpacing: 0,
                      lastTopSpacing: 0,
                      bottomSpacing: 0,
                      lastBottomSpacing: 0,
                      sidebarHeight: 0,
                      sidebarWidth: 0,
                      containerTop: 0,
                      containerHeight: 0,
                      viewportHeight: 0,
                      viewportTop: 0,
                      lastViewportTop: 0,
                    }),
                    ["handleEvent"].forEach(function (t) {
                      e[t] = e[t].bind(e);
                    }),
                    this.initialize();
                }
                return (
                  e(
                    c,
                    [
                      {
                        key: "initialize",
                        value: function () {
                          var i = this;
                          if (
                            (this._setSupportFeatures(),
                            this.options.innerWrapperSelector &&
                              ((this.sidebarInner = this.sidebar.querySelector(
                                this.options.innerWrapperSelector
                              )),
                              null === this.sidebarInner &&
                                (this.sidebarInner = !1)),
                            !this.sidebarInner)
                          ) {
                            var t = document.createElement("div");
                            for (
                              t.setAttribute("class", "inner-wrapper-sticky"),
                                this.sidebar.appendChild(t);
                              this.sidebar.firstChild != t;

                            )
                              t.appendChild(this.sidebar.firstChild);
                            this.sidebarInner = this.sidebar.querySelector(
                              ".inner-wrapper-sticky"
                            );
                          }
                          if (this.options.containerSelector) {
                            var e = document.querySelectorAll(
                              this.options.containerSelector
                            );
                            if (
                              ((e = Array.prototype.slice.call(e)).forEach(
                                function (t, e) {
                                  t.contains(i.sidebar) && (i.container = t);
                                }
                              ),
                              !e.length)
                            )
                              throw new Error(
                                "The container does not contains on the sidebar."
                              );
                          }
                          "function" != typeof this.options.topSpacing &&
                            (this.options.topSpacing =
                              parseInt(this.options.topSpacing) || 0),
                            "function" != typeof this.options.bottomSpacing &&
                              (this.options.bottomSpacing =
                                parseInt(this.options.bottomSpacing) || 0),
                            this._widthBreakpoint(),
                            this.calcDimensions(),
                            this.stickyPosition(),
                            this.bindEvents(),
                            (this._initialized = !0);
                        },
                      },
                      {
                        key: "bindEvents",
                        value: function () {
                          window.addEventListener("resize", this, {
                            passive: !0,
                            capture: !1,
                          }),
                            window.addEventListener("scroll", this, {
                              passive: !0,
                              capture: !1,
                            }),
                            this.sidebar.addEventListener("update" + l, this),
                            this.options.resizeSensor &&
                              "undefined" != typeof ResizeSensor &&
                              (new ResizeSensor(
                                this.sidebarInner,
                                this.handleEvent
                              ),
                              new ResizeSensor(
                                this.container,
                                this.handleEvent
                              ));
                        },
                      },
                      {
                        key: "handleEvent",
                        value: function (t) {
                          this.updateSticky(t);
                        },
                      },
                      {
                        key: "calcDimensions",
                        value: function () {
                          if (!this._breakpoint) {
                            var t = this.dimensions;
                            (t.containerTop = c.offsetRelative(
                              this.container
                            ).top),
                              (t.containerHeight = this.container.clientHeight),
                              (t.containerBottom =
                                t.containerTop + t.containerHeight),
                              (t.sidebarHeight = this.sidebarInner.offsetHeight),
                              (t.sidebarWidth = this.sidebarInner.offsetWidth),
                              (t.viewportHeight = window.innerHeight),
                              (t.maxTranslateY =
                                t.containerHeight - t.sidebarHeight),
                              this._calcDimensionsWithScroll();
                          }
                        },
                      },
                      {
                        key: "_calcDimensionsWithScroll",
                        value: function () {
                          var t = this.dimensions;
                          (t.sidebarLeft = c.offsetRelative(this.sidebar).left),
                            (t.viewportTop =
                              document.documentElement.scrollTop ||
                              document.body.scrollTop),
                            (t.viewportBottom =
                              t.viewportTop + t.viewportHeight),
                            (t.viewportLeft =
                              document.documentElement.scrollLeft ||
                              document.body.scrollLeft),
                            (t.topSpacing = this.options.topSpacing),
                            (t.bottomSpacing = this.options.bottomSpacing),
                            "function" == typeof t.topSpacing &&
                              (t.topSpacing =
                                parseInt(t.topSpacing(this.sidebar)) || 0),
                            "function" == typeof t.bottomSpacing &&
                              (t.bottomSpacing =
                                parseInt(t.bottomSpacing(this.sidebar)) || 0),
                            "VIEWPORT-TOP" === this.affixedType
                              ? t.topSpacing < t.lastTopSpacing &&
                                ((t.translateY +=
                                  t.lastTopSpacing - t.topSpacing),
                                (this._reStyle = !0))
                              : "VIEWPORT-BOTTOM" === this.affixedType &&
                                t.bottomSpacing < t.lastBottomSpacing &&
                                ((t.translateY +=
                                  t.lastBottomSpacing - t.bottomSpacing),
                                (this._reStyle = !0)),
                            (t.lastTopSpacing = t.topSpacing),
                            (t.lastBottomSpacing = t.bottomSpacing);
                        },
                      },
                      {
                        key: "isSidebarFitsViewport",
                        value: function () {
                          var t = this.dimensions,
                            e =
                              "down" === this.scrollDirection
                                ? t.lastBottomSpacing
                                : t.lastTopSpacing;
                          return (
                            this.dimensions.sidebarHeight + e <
                            this.dimensions.viewportHeight
                          );
                        },
                      },
                      {
                        key: "observeScrollDir",
                        value: function () {
                          var t = this.dimensions;
                          if (t.lastViewportTop !== t.viewportTop) {
                            var e =
                              "down" === this.direction ? Math.min : Math.max;
                            t.viewportTop ===
                              e(t.viewportTop, t.lastViewportTop) &&
                              (this.direction =
                                "down" === this.direction ? "up" : "down");
                          }
                        },
                      },
                      {
                        key: "getAffixType",
                        value: function () {
                          this._calcDimensionsWithScroll();
                          var t = this.dimensions,
                            e = t.viewportTop + t.topSpacing,
                            i = this.affixedType;
                          return (
                            e <= t.containerTop ||
                            t.containerHeight <= t.sidebarHeight
                              ? ((t.translateY = 0), (i = "STATIC"))
                              : (i =
                                  "up" === this.direction
                                    ? this._getAffixTypeScrollingUp()
                                    : this._getAffixTypeScrollingDown()),
                            (t.translateY = Math.max(0, t.translateY)),
                            (t.translateY = Math.min(
                              t.containerHeight,
                              t.translateY
                            )),
                            (t.translateY = Math.round(t.translateY)),
                            (t.lastViewportTop = t.viewportTop),
                            i
                          );
                        },
                      },
                      {
                        key: "_getAffixTypeScrollingDown",
                        value: function () {
                          var t = this.dimensions,
                            e = t.sidebarHeight + t.containerTop,
                            i = t.viewportTop + t.topSpacing,
                            n = t.viewportBottom - t.bottomSpacing,
                            o = this.affixedType;
                          return (
                            this.isSidebarFitsViewport()
                              ? t.sidebarHeight + i >= t.containerBottom
                                ? ((t.translateY = t.containerBottom - e),
                                  (o = "CONTAINER-BOTTOM"))
                                : i >= t.containerTop &&
                                  ((t.translateY = i - t.containerTop),
                                  (o = "VIEWPORT-TOP"))
                              : t.containerBottom <= n
                              ? ((t.translateY = t.containerBottom - e),
                                (o = "CONTAINER-BOTTOM"))
                              : e + t.translateY <= n
                              ? ((t.translateY = n - e),
                                (o = "VIEWPORT-BOTTOM"))
                              : t.containerTop + t.translateY <= i &&
                                0 !== t.translateY &&
                                t.maxTranslateY !== t.translateY &&
                                (o = "VIEWPORT-UNBOTTOM"),
                            o
                          );
                        },
                      },
                      {
                        key: "_getAffixTypeScrollingUp",
                        value: function () {
                          var t = this.dimensions,
                            e = t.sidebarHeight + t.containerTop,
                            i = t.viewportTop + t.topSpacing,
                            n = t.viewportBottom - t.bottomSpacing,
                            o = this.affixedType;
                          return (
                            i <= t.translateY + t.containerTop
                              ? ((t.translateY = i - t.containerTop),
                                (o = "VIEWPORT-TOP"))
                              : t.containerBottom <= n
                              ? ((t.translateY = t.containerBottom - e),
                                (o = "CONTAINER-BOTTOM"))
                              : this.isSidebarFitsViewport() ||
                                (t.containerTop <= i &&
                                  0 !== t.translateY &&
                                  t.maxTranslateY !== t.translateY &&
                                  (o = "VIEWPORT-UNBOTTOM")),
                            o
                          );
                        },
                      },
                      {
                        key: "_getStyle",
                        value: function (t) {
                          if (void 0 !== t) {
                            var e = { inner: {}, outer: {} },
                              i = this.dimensions;
                            switch (t) {
                              case "VIEWPORT-TOP":
                                e.inner = {
                                  position: "fixed",
                                  top: i.topSpacing,
                                  left: i.sidebarLeft - i.viewportLeft,
                                  width: i.sidebarWidth,
                                };
                                break;
                              case "VIEWPORT-BOTTOM":
                                e.inner = {
                                  position: "fixed",
                                  top: "auto",
                                  left: i.sidebarLeft,
                                  bottom: i.bottomSpacing,
                                  width: i.sidebarWidth,
                                };
                                break;
                              case "CONTAINER-BOTTOM":
                              case "VIEWPORT-UNBOTTOM":
                                var n = this._getTranslate(
                                  0,
                                  i.translateY + "px"
                                );
                                e.inner = n
                                  ? { transform: n }
                                  : {
                                      position: "absolute",
                                      top: i.translateY,
                                      width: i.sidebarWidth,
                                    };
                            }
                            switch (t) {
                              case "VIEWPORT-TOP":
                              case "VIEWPORT-BOTTOM":
                              case "VIEWPORT-UNBOTTOM":
                              case "CONTAINER-BOTTOM":
                                e.outer = {
                                  height: i.sidebarHeight,
                                  position: "relative",
                                };
                            }
                            return (
                              (e.outer = c.extend(
                                { height: "", position: "" },
                                e.outer
                              )),
                              (e.inner = c.extend(
                                {
                                  position: "relative",
                                  top: "",
                                  left: "",
                                  bottom: "",
                                  width: "",
                                  transform: "",
                                },
                                e.inner
                              )),
                              e
                            );
                          }
                        },
                      },
                      {
                        key: "stickyPosition",
                        value: function (t) {
                          if (!this._breakpoint) {
                            (t = this._reStyle || t || !1),
                              this.options.topSpacing,
                              this.options.bottomSpacing;
                            var e = this.getAffixType(),
                              i = this._getStyle(e);
                            if ((this.affixedType != e || t) && e) {
                              var n =
                                "affix." +
                                e.toLowerCase().replace("viewport-", "") +
                                l;
                              for (var o in (c.eventTrigger(this.sidebar, n),
                              "STATIC" === e
                                ? c.removeClass(
                                    this.sidebar,
                                    this.options.stickyClass
                                  )
                                : c.addClass(
                                    this.sidebar,
                                    this.options.stickyClass
                                  ),
                              i.outer)) {
                                var s =
                                  "number" == typeof i.outer[o] ? "px" : "";
                                this.sidebar.style[o] = i.outer[o] + s;
                              }
                              for (var r in i.inner) {
                                var a =
                                  "number" == typeof i.inner[r] ? "px" : "";
                                this.sidebarInner.style[r] = i.inner[r] + a;
                              }
                              var p =
                                "affixed." +
                                e.toLowerCase().replace("viewport-", "") +
                                l;
                              c.eventTrigger(this.sidebar, p);
                            } else
                              this._initialized &&
                                (this.sidebarInner.style.left = i.inner.left);
                            this.affixedType = e;
                          }
                        },
                      },
                      {
                        key: "_widthBreakpoint",
                        value: function () {
                          window.innerWidth <= this.options.minWidth
                            ? ((this._breakpoint = !0),
                              (this.affixedType = "STATIC"),
                              this.sidebar.removeAttribute("style"),
                              c.removeClass(
                                this.sidebar,
                                this.options.stickyClass
                              ),
                              this.sidebarInner.removeAttribute("style"))
                            : (this._breakpoint = !1);
                        },
                      },
                      {
                        key: "updateSticky",
                        value: function () {
                          var t,
                            e = this,
                            i =
                              0 < arguments.length && void 0 !== arguments[0]
                                ? arguments[0]
                                : {};
                          this._running ||
                            ((this._running = !0),
                            (t = i.type),
                            requestAnimationFrame(function () {
                              switch (t) {
                                case "scroll":
                                  e._calcDimensionsWithScroll(),
                                    e.observeScrollDir(),
                                    e.stickyPosition();
                                  break;
                                case "resize":
                                default:
                                  e._widthBreakpoint(),
                                    e.calcDimensions(),
                                    e.stickyPosition(!0);
                              }
                              e._running = !1;
                            }));
                        },
                      },
                      {
                        key: "_setSupportFeatures",
                        value: function () {
                          var t = this.support;
                          (t.transform = c.supportTransform()),
                            (t.transform3d = c.supportTransform(!0));
                        },
                      },
                      {
                        key: "_getTranslate",
                        value: function () {
                          var t =
                              0 < arguments.length && void 0 !== arguments[0]
                                ? arguments[0]
                                : 0,
                            e =
                              1 < arguments.length && void 0 !== arguments[1]
                                ? arguments[1]
                                : 0,
                            i =
                              2 < arguments.length && void 0 !== arguments[2]
                                ? arguments[2]
                                : 0;
                          return this.support.transform3d
                            ? "translate3d(" + t + ", " + e + ", " + i + ")"
                            : !!this.support.translate &&
                                "translate(" + t + ", " + e + ")";
                        },
                      },
                      {
                        key: "destroy",
                        value: function () {
                          window.removeEventListener("resize", this, {
                            capture: !1,
                          }),
                            window.removeEventListener("scroll", this, {
                              capture: !1,
                            }),
                            this.sidebar.classList.remove(
                              this.options.stickyClass
                            ),
                            (this.sidebar.style.minHeight = ""),
                            this.sidebar.removeEventListener(
                              "update" + l,
                              this
                            );
                          var t = { inner: {}, outer: {} };
                          for (var e in ((t.inner = {
                            position: "",
                            top: "",
                            left: "",
                            bottom: "",
                            width: "",
                            transform: "",
                          }),
                          (t.outer = { height: "", position: "" }),
                          t.outer))
                            this.sidebar.style[e] = t.outer[e];
                          for (var i in t.inner)
                            this.sidebarInner.style[i] = t.inner[i];
                          this.options.resizeSensor &&
                            "undefined" != typeof ResizeSensor &&
                            (ResizeSensor.detach(
                              this.sidebarInner,
                              this.handleEvent
                            ),
                            ResizeSensor.detach(
                              this.container,
                              this.handleEvent
                            ));
                        },
                      },
                    ],
                    [
                      {
                        key: "supportTransform",
                        value: function (t) {
                          var i = !1,
                            e = t ? "perspective" : "transform",
                            n = e.charAt(0).toUpperCase() + e.slice(1),
                            o = document.createElement("support").style;
                          return (
                            (
                              e +
                              " " +
                              ["Webkit", "Moz", "O", "ms"].join(n + " ") +
                              n
                            )
                              .split(" ")
                              .forEach(function (t, e) {
                                if (void 0 !== o[t]) return (i = t), !1;
                              }),
                            i
                          );
                        },
                      },
                      {
                        key: "eventTrigger",
                        value: function (t, e, i) {
                          try {
                            var n = new CustomEvent(e, { detail: i });
                          } catch (t) {
                            (n = document.createEvent(
                              "CustomEvent"
                            )).initCustomEvent(e, !0, !0, i);
                          }
                          t.dispatchEvent(n);
                        },
                      },
                      {
                        key: "extend",
                        value: function (t, e) {
                          var i = {};
                          for (var n in t)
                            void 0 !== e[n] ? (i[n] = e[n]) : (i[n] = t[n]);
                          return i;
                        },
                      },
                      {
                        key: "offsetRelative",
                        value: function (t) {
                          var e = { left: 0, top: 0 };
                          do {
                            var i = t.offsetTop,
                              n = t.offsetLeft;
                            isNaN(i) || (e.top += i),
                              isNaN(n) || (e.left += n),
                              (t =
                                "BODY" === t.tagName
                                  ? t.parentElement
                                  : t.offsetParent);
                          } while (t);
                          return e;
                        },
                      },
                      {
                        key: "addClass",
                        value: function (t, e) {
                          c.hasClass(t, e) ||
                            (t.classList
                              ? t.classList.add(e)
                              : (t.className += " " + e));
                        },
                      },
                      {
                        key: "removeClass",
                        value: function (t, e) {
                          c.hasClass(t, e) &&
                            (t.classList
                              ? t.classList.remove(e)
                              : (t.className = t.className.replace(
                                  new RegExp(
                                    "(^|\\b)" +
                                      e.split(" ").join("|") +
                                      "(\\b|$)",
                                    "gi"
                                  ),
                                  " "
                                )));
                        },
                      },
                      {
                        key: "hasClass",
                        value: function (t, e) {
                          return t.classList
                            ? t.classList.contains(e)
                            : new RegExp("(^| )" + e + "( |$)", "gi").test(
                                t.className
                              );
                        },
                      },
                      {
                        key: "defaults",
                        get: function () {
                          return n;
                        },
                      },
                    ]
                  ),
                  c
                );
              })());
          (t.default = i), (window.StickySidebar = i);
        })(e);
      })((e = { exports: {} }), e.exports),
      e.exports),
    o =
      (i = n) &&
      i.__esModule &&
      Object.prototype.hasOwnProperty.call(i, "default")
        ? i.default
        : i;
  (t.default = o),
    (t.__moduleExports = n),
    Object.defineProperty(t, "__esModule", { value: !0 });
});

/*
    A simple jQuery modal (http://github.com/kylefox/jquery-modal)
    Version 0.9.2
*/
!(function (o) {
  "object" == typeof module && "object" == typeof module.exports
    ? o(require("jquery"), window, document)
    : o(jQuery, window, document);
})(function (o, t, i, e) {
  var s = [],
    l = function () {
      return s.length ? s[s.length - 1] : null;
    },
    n = function () {
      var o,
        t = !1;
      for (o = s.length - 1; o >= 0; o--)
        s[o].$blocker &&
          (s[o].$blocker.toggleClass("current", !t).toggleClass("behind", t),
          (t = !0));
    };
  (o.modal = function (t, i) {
    var e, n;
    if (
      ((this.$body = o("body")),
      (this.options = o.extend({}, o.modal.defaults, i)),
      (this.options.doFade = !isNaN(parseInt(this.options.fadeDuration, 10))),
      (this.$blocker = null),
      this.options.closeExisting)
    )
      for (; o.modal.isActive(); ) o.modal.close();
    if ((s.push(this), t.is("a")))
      if (((n = t.attr("href")), (this.anchor = t), /^#/.test(n))) {
        if (((this.$elm = o(n)), 1 !== this.$elm.length)) return null;
        this.$body.append(this.$elm), this.open();
      } else
        (this.$elm = o("<div>")),
          this.$body.append(this.$elm),
          (e = function (o, t) {
            t.elm.remove();
          }),
          this.showSpinner(),
          t.trigger(o.modal.AJAX_SEND),
          o
            .get(n)
            .done(function (i) {
              if (o.modal.isActive()) {
                t.trigger(o.modal.AJAX_SUCCESS);
                var s = l();
                s.$elm.empty().append(i).on(o.modal.CLOSE, e),
                  s.hideSpinner(),
                  s.open(),
                  t.trigger(o.modal.AJAX_COMPLETE);
              }
            })
            .fail(function () {
              t.trigger(o.modal.AJAX_FAIL);
              var i = l();
              i.hideSpinner(), s.pop(), t.trigger(o.modal.AJAX_COMPLETE);
            });
    else
      (this.$elm = t),
        (this.anchor = t),
        this.$body.append(this.$elm),
        this.open();
  }),
    (o.modal.prototype = {
      constructor: o.modal,
      open: function () {
        var t = this;
        this.block(),
          this.anchor.blur(),
          this.options.doFade
            ? setTimeout(function () {
                t.show();
              }, this.options.fadeDuration * this.options.fadeDelay)
            : this.show(),
          o(i)
            .off("keydown.modal")
            .on("keydown.modal", function (o) {
              var t = l();
              27 === o.which && t.options.escapeClose && t.close();
            }),
          this.options.clickClose &&
            this.$blocker.click(function (t) {
              t.target === this && o.modal.close();
            });
      },
      close: function () {
        s.pop(),
          this.unblock(),
          this.hide(),
          o.modal.isActive() || o(i).off("keydown.modal");
      },
      block: function () {
        this.$elm.trigger(o.modal.BEFORE_BLOCK, [this._ctx()]),
          this.$body.css("overflow", "hidden"),
          (this.$blocker = o(
            '<div class="' +
              this.options.blockerClass +
              ' blocker current"></div>'
          ).appendTo(this.$body)),
          n(),
          this.options.doFade &&
            this.$blocker
              .css("opacity", 0)
              .animate({ opacity: 1 }, this.options.fadeDuration),
          this.$elm.trigger(o.modal.BLOCK, [this._ctx()]);
      },
      unblock: function (t) {
        !t && this.options.doFade
          ? this.$blocker.fadeOut(
              this.options.fadeDuration,
              this.unblock.bind(this, !0)
            )
          : (this.$blocker.children().appendTo(this.$body),
            this.$blocker.remove(),
            (this.$blocker = null),
            n(),
            o.modal.isActive() || this.$body.css("overflow", ""));
      },
      show: function () {
        this.$elm.trigger(o.modal.BEFORE_OPEN, [this._ctx()]),
          this.options.showClose &&
            ((this.closeButton = o(
              '<a href="#close-modal" rel="modal:close" class="close-modal ' +
                this.options.closeClass +
                '">' +
                this.options.closeText +
                "</a>"
            )),
            this.$elm.append(this.closeButton)),
          this.$elm.addClass(this.options.modalClass).appendTo(this.$blocker),
          this.options.doFade
            ? this.$elm
                .css({ opacity: 0, display: "inline-block" })
                .animate({ opacity: 1 }, this.options.fadeDuration)
            : this.$elm.css("display", "inline-block"),
          this.$elm.trigger(o.modal.OPEN, [this._ctx()]);
      },
      hide: function () {
        this.$elm.trigger(o.modal.BEFORE_CLOSE, [this._ctx()]),
          this.closeButton && this.closeButton.remove();
        var t = this;
        this.options.doFade
          ? this.$elm.fadeOut(this.options.fadeDuration, function () {
              t.$elm.trigger(o.modal.AFTER_CLOSE, [t._ctx()]);
            })
          : this.$elm.hide(0, function () {
              t.$elm.trigger(o.modal.AFTER_CLOSE, [t._ctx()]);
            }),
          this.$elm.trigger(o.modal.CLOSE, [this._ctx()]);
      },
      showSpinner: function () {
        this.options.showSpinner &&
          ((this.spinner =
            this.spinner ||
            o(
              '<div class="' + this.options.modalClass + '-spinner"></div>'
            ).append(this.options.spinnerHtml)),
          this.$body.append(this.spinner),
          this.spinner.show());
      },
      hideSpinner: function () {
        this.spinner && this.spinner.remove();
      },
      _ctx: function () {
        return {
          elm: this.$elm,
          $elm: this.$elm,
          $blocker: this.$blocker,
          options: this.options,
          $anchor: this.anchor,
        };
      },
    }),
    (o.modal.close = function (t) {
      if (o.modal.isActive()) {
        t && t.preventDefault();
        var i = l();
        return i.close(), i.$elm;
      }
    }),
    (o.modal.isActive = function () {
      return s.length > 0;
    }),
    (o.modal.getCurrent = l),
    (o.modal.defaults = {
      closeExisting: !0,
      escapeClose: !0,
      clickClose: !0,
      closeText: "Close",
      closeClass: "",
      modalClass: "modal",
      blockerClass: "jquery-modal",
      spinnerHtml:
        '<div class="rect1"></div><div class="rect2"></div><div class="rect3"></div><div class="rect4"></div>',
      showSpinner: !0,
      showClose: !0,
      fadeDuration: null,
      fadeDelay: 1,
    }),
    (o.modal.BEFORE_BLOCK = "modal:before-block"),
    (o.modal.BLOCK = "modal:block"),
    (o.modal.BEFORE_OPEN = "modal:before-open"),
    (o.modal.OPEN = "modal:open"),
    (o.modal.BEFORE_CLOSE = "modal:before-close"),
    (o.modal.CLOSE = "modal:close"),
    (o.modal.AFTER_CLOSE = "modal:after-close"),
    (o.modal.AJAX_SEND = "modal:ajax:send"),
    (o.modal.AJAX_SUCCESS = "modal:ajax:success"),
    (o.modal.AJAX_FAIL = "modal:ajax:fail"),
    (o.modal.AJAX_COMPLETE = "modal:ajax:complete"),
    (o.fn.modal = function (t) {
      return 1 === this.length && new o.modal(this, t), this;
    }),
    o(i).on("click.modal", 'a[rel~="modal:close"]', o.modal.close),
    o(i).on("click.modal", 'a[rel~="modal:open"]', function (t) {
      t.preventDefault(), o(this).modal();
    });
});

/*
 *	Sweetalert
 */
!(function (t, e) {
  "object" == typeof exports && "undefined" != typeof module
    ? (module.exports = e())
    : "function" == typeof define && define.amd
    ? define(e)
    : (t.Sweetalert2 = e());
})(this, function () {
  "use strict";
  function r(t) {
    return (r =
      "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
        ? function (t) {
            return typeof t;
          }
        : function (t) {
            return t &&
              "function" == typeof Symbol &&
              t.constructor === Symbol &&
              t !== Symbol.prototype
              ? "symbol"
              : typeof t;
          })(t);
  }
  function o(t, e) {
    if (!(t instanceof e))
      throw new TypeError("Cannot call a class as a function");
  }
  function i(t, e) {
    for (var n = 0; n < e.length; n++) {
      var o = e[n];
      (o.enumerable = o.enumerable || !1),
        (o.configurable = !0),
        "value" in o && (o.writable = !0),
        Object.defineProperty(t, o.key, o);
    }
  }
  function a(t, e, n) {
    return e && i(t.prototype, e), n && i(t, n), t;
  }
  function c() {
    return (c =
      Object.assign ||
      function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var o in n)
            Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
        }
        return t;
      }).apply(this, arguments);
  }
  function s(t) {
    return (s = Object.setPrototypeOf
      ? Object.getPrototypeOf
      : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        })(t);
  }
  function u(t, e) {
    return (u =
      Object.setPrototypeOf ||
      function (t, e) {
        return (t.__proto__ = e), t;
      })(t, e);
  }
  function l(t, e, n) {
    return (l = (function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return (
          Date.prototype.toString.call(
            Reflect.construct(Date, [], function () {})
          ),
          !0
        );
      } catch (t) {
        return !1;
      }
    })()
      ? Reflect.construct
      : function (t, e, n) {
          var o = [null];
          o.push.apply(o, e);
          var i = new (Function.bind.apply(t, o))();
          return n && u(i, n.prototype), i;
        }).apply(null, arguments);
  }
  function d(t, e) {
    return !e || ("object" != typeof e && "function" != typeof e)
      ? (function (t) {
          if (void 0 === t)
            throw new ReferenceError(
              "this hasn't been initialised - super() hasn't been called"
            );
          return t;
        })(t)
      : e;
  }
  function p(t, e, n) {
    return (p =
      "undefined" != typeof Reflect && Reflect.get
        ? Reflect.get
        : function (t, e, n) {
            var o = (function (t, e) {
              for (
                ;
                !Object.prototype.hasOwnProperty.call(t, e) &&
                null !== (t = s(t));

              );
              return t;
            })(t, e);
            if (o) {
              var i = Object.getOwnPropertyDescriptor(o, e);
              return i.get ? i.get.call(n) : i.value;
            }
          })(t, e, n || t);
  }
  function f(e) {
    return Object.keys(e).map(function (t) {
      return e[t];
    });
  }
  function m(t) {
    return Array.prototype.slice.call(t);
  }
  function g(t) {
    console.error("".concat(q, " ").concat(t));
  }
  function h(t, e) {
    var n;
    (n = '"'
      .concat(
        t,
        '" is deprecated and will be removed in the next major release. Please use "'
      )
      .concat(e, '" instead.')),
      -1 === N.indexOf(n) && (N.push(n), R(n));
  }
  function v(t) {
    return t && Promise.resolve(t) === t;
  }
  function b(t) {
    return t instanceof Element || ("object" === r((e = t)) && e.jquery);
    var e;
  }
  function t(t) {
    var e = {};
    for (var n in t) e[t[n]] = "swal2-" + t[n];
    return e;
  }
  function y(t) {
    var e = z();
    return e ? e.querySelector(t) : null;
  }
  function e(t) {
    return y(".".concat(t));
  }
  function n() {
    var t = W();
    return m(t.querySelectorAll(".".concat(F.icon)));
  }
  function w() {
    var t = n().filter(function (t) {
      return dt(t);
    });
    return t.length ? t[0] : null;
  }
  function C() {
    return e(F.title);
  }
  function k() {
    return e(F.content);
  }
  function x() {
    return e(F.image);
  }
  function A() {
    return e(F["progress-steps"]);
  }
  function P() {
    return e(F["validation-message"]);
  }
  function B() {
    return y(".".concat(F.actions, " .").concat(F.confirm));
  }
  function E() {
    return y(".".concat(F.actions, " .").concat(F.cancel));
  }
  function S() {
    return e(F.actions);
  }
  function T() {
    return e(F.header);
  }
  function L() {
    return e(F.footer);
  }
  function O() {
    return e(F["timer-progress-bar"]);
  }
  function M() {
    return e(F.close);
  }
  function H() {
    var t = m(
        W().querySelectorAll(
          '[tabindex]:not([tabindex="-1"]):not([tabindex="0"])'
        )
      ).sort(function (t, e) {
        return (
          (t = parseInt(t.getAttribute("tabindex"))),
          (e = parseInt(e.getAttribute("tabindex"))) < t ? 1 : t < e ? -1 : 0
        );
      }),
      e = m(
        W().querySelectorAll(
          '\n  a[href],\n  area[href],\n  input:not([disabled]),\n  select:not([disabled]),\n  textarea:not([disabled]),\n  button:not([disabled]),\n  iframe,\n  object,\n  embed,\n  [tabindex="0"],\n  [contenteditable],\n  audio[controls],\n  video[controls],\n  summary\n'
        )
      ).filter(function (t) {
        return "-1" !== t.getAttribute("tabindex");
      });
    return (function (t) {
      for (var e = [], n = 0; n < t.length; n++)
        -1 === e.indexOf(t[n]) && e.push(t[n]);
      return e;
    })(t.concat(e)).filter(function (t) {
      return dt(t);
    });
  }
  function j() {
    return !K() && !document.body.classList.contains(F["no-backdrop"]);
  }
  function V(t, e) {
    if (!e) return !1;
    for (var n = e.split(/\s+/), o = 0; o < n.length; o++)
      if (!t.classList.contains(n[o])) return !1;
    return !0;
  }
  function I(t, e, n) {
    var o, i;
    if (
      ((i = e),
      m((o = t).classList).forEach(function (t) {
        -1 === f(F).indexOf(t) &&
          -1 === f(_).indexOf(t) &&
          -1 === f(i.showClass).indexOf(t) &&
          o.classList.remove(t);
      }),
      e.customClass && e.customClass[n])
    ) {
      if ("string" != typeof e.customClass[n] && !e.customClass[n].forEach)
        return R(
          "Invalid type of customClass."
            .concat(n, '! Expected string or iterable object, got "')
            .concat(r(e.customClass[n]), '"')
        );
      st(t, e.customClass[n]);
    }
  }
  var q = "SweetAlert2:",
    R = function (t) {
      console.warn("".concat(q, " ").concat(t));
    },
    N = [],
    D = function (t) {
      return "function" == typeof t ? t() : t;
    },
    U = Object.freeze({
      cancel: "cancel",
      backdrop: "backdrop",
      close: "close",
      esc: "esc",
      timer: "timer",
    }),
    F = t([
      "container",
      "shown",
      "height-auto",
      "iosfix",
      "popup",
      "modal",
      "no-backdrop",
      "toast",
      "toast-shown",
      "toast-column",
      "show",
      "hide",
      "close",
      "title",
      "header",
      "content",
      "html-container",
      "actions",
      "confirm",
      "cancel",
      "footer",
      "icon",
      "icon-content",
      "image",
      "input",
      "file",
      "range",
      "select",
      "radio",
      "checkbox",
      "label",
      "textarea",
      "inputerror",
      "validation-message",
      "progress-steps",
      "active-progress-step",
      "progress-step",
      "progress-step-line",
      "loading",
      "styled",
      "top",
      "top-start",
      "top-end",
      "top-left",
      "top-right",
      "center",
      "center-start",
      "center-end",
      "center-left",
      "center-right",
      "bottom",
      "bottom-start",
      "bottom-end",
      "bottom-left",
      "bottom-right",
      "grow-row",
      "grow-column",
      "grow-fullscreen",
      "rtl",
      "timer-progress-bar",
      "scrollbar-measure",
      "icon-success",
      "icon-warning",
      "icon-info",
      "icon-question",
      "icon-error",
    ]),
    _ = t(["success", "warning", "info", "question", "error"]),
    z = function () {
      return document.body.querySelector(".".concat(F.container));
    },
    W = function () {
      return e(F.popup);
    },
    K = function () {
      return document.body.classList.contains(F["toast-shown"]);
    },
    Y = { previousBodyPadding: null };
  function Z(t, e) {
    if (!e) return null;
    switch (e) {
      case "select":
      case "textarea":
      case "file":
        return lt(t, F[e]);
      case "checkbox":
        return t.querySelector(".".concat(F.checkbox, " input"));
      case "radio":
        return (
          t.querySelector(".".concat(F.radio, " input:checked")) ||
          t.querySelector(".".concat(F.radio, " input:first-child"))
        );
      case "range":
        return t.querySelector(".".concat(F.range, " input"));
      default:
        return lt(t, F.input);
    }
  }
  function Q(t) {
    if ((t.focus(), "file" !== t.type)) {
      var e = t.value;
      (t.value = ""), (t.value = e);
    }
  }
  function $(t, e, n) {
    t &&
      e &&
      ("string" == typeof e && (e = e.split(/\s+/).filter(Boolean)),
      e.forEach(function (e) {
        t.forEach
          ? t.forEach(function (t) {
              n ? t.classList.add(e) : t.classList.remove(e);
            })
          : n
          ? t.classList.add(e)
          : t.classList.remove(e);
      }));
  }
  function J(t, e, n) {
    n || 0 === parseInt(n)
      ? (t.style[e] = "number" == typeof n ? "".concat(n, "px") : n)
      : t.style.removeProperty(e);
  }
  function X(t, e) {
    var n = 1 < arguments.length && void 0 !== e ? e : "flex";
    (t.style.opacity = ""), (t.style.display = n);
  }
  function G(t) {
    (t.style.opacity = ""), (t.style.display = "none");
  }
  function tt(t, e, n) {
    e ? X(t, n) : G(t);
  }
  function et(t) {
    var e = window.getComputedStyle(t),
      n = parseFloat(e.getPropertyValue("animation-duration") || "0"),
      o = parseFloat(e.getPropertyValue("transition-duration") || "0");
    return 0 < n || 0 < o;
  }
  function nt(t, e) {
    var n = 1 < arguments.length && void 0 !== e && e,
      o = O();
    dt(o) &&
      (n && ((o.style.transition = "none"), (o.style.width = "100%")),
      setTimeout(function () {
        (o.style.transition = "width ".concat(t / 1e3, "s linear")),
          (o.style.width = "0%");
      }, 10));
  }
  function ot() {
    return "undefined" == typeof window || "undefined" == typeof document;
  }
  function it(t) {
    Je.isVisible() && ct !== t.target.value && Je.resetValidationMessage(),
      (ct = t.target.value);
  }
  function rt(t, e) {
    t instanceof HTMLElement
      ? e.appendChild(t)
      : "object" === r(t)
      ? mt(e, t)
      : t && (e.innerHTML = t);
  }
  function at(t, e) {
    var n = S(),
      o = B(),
      i = E();
    e.showConfirmButton || e.showCancelButton || G(n),
      I(n, e, "actions"),
      gt(o, "confirm", e),
      gt(i, "cancel", e),
      e.buttonsStyling
        ? (function (t, e, n) {
            st([t, e], F.styled),
              n.confirmButtonColor &&
                (t.style.backgroundColor = n.confirmButtonColor);
            n.cancelButtonColor &&
              (e.style.backgroundColor = n.cancelButtonColor);
            var o = window
              .getComputedStyle(t)
              .getPropertyValue("background-color");
            (t.style.borderLeftColor = o), (t.style.borderRightColor = o);
          })(o, i, e)
        : (ut([o, i], F.styled),
          (o.style.backgroundColor = o.style.borderLeftColor = o.style.borderRightColor =
            ""),
          (i.style.backgroundColor = i.style.borderLeftColor = i.style.borderRightColor =
            "")),
      e.reverseButtons && o.parentNode.insertBefore(i, o);
  }
  var ct,
    st = function (t, e) {
      $(t, e, !0);
    },
    ut = function (t, e) {
      $(t, e, !1);
    },
    lt = function (t, e) {
      for (var n = 0; n < t.childNodes.length; n++)
        if (V(t.childNodes[n], e)) return t.childNodes[n];
    },
    dt = function (t) {
      return !(
        !t || !(t.offsetWidth || t.offsetHeight || t.getClientRects().length)
      );
    },
    pt = '\n <div aria-labelledby="'
      .concat(F.title, '" aria-describedby="')
      .concat(F.content, '" class="')
      .concat(F.popup, '" tabindex="-1">\n   <div class="')
      .concat(F.header, '">\n     <ul class="')
      .concat(F["progress-steps"], '"></ul>\n     <div class="')
      .concat(F.icon, " ")
      .concat(_.error, '"></div>\n     <div class="')
      .concat(F.icon, " ")
      .concat(_.question, '"></div>\n     <div class="')
      .concat(F.icon, " ")
      .concat(_.warning, '"></div>\n     <div class="')
      .concat(F.icon, " ")
      .concat(_.info, '"></div>\n     <div class="')
      .concat(F.icon, " ")
      .concat(_.success, '"></div>\n     <img class="')
      .concat(F.image, '" />\n     <h2 class="')
      .concat(F.title, '" id="')
      .concat(F.title, '"></h2>\n     <button type="button" class="')
      .concat(F.close, '"></button>\n   </div>\n   <div class="')
      .concat(F.content, '">\n     <div id="')
      .concat(F.content, '" class="')
      .concat(F["html-container"], '"></div>\n     <input class="')
      .concat(F.input, '" />\n     <input type="file" class="')
      .concat(F.file, '" />\n     <div class="')
      .concat(
        F.range,
        '">\n       <input type="range" />\n       <output></output>\n     </div>\n     <select class="'
      )
      .concat(F.select, '"></select>\n     <div class="')
      .concat(F.radio, '"></div>\n     <label for="')
      .concat(F.checkbox, '" class="')
      .concat(
        F.checkbox,
        '">\n       <input type="checkbox" />\n       <span class="'
      )
      .concat(F.label, '"></span>\n     </label>\n     <textarea class="')
      .concat(F.textarea, '"></textarea>\n     <div class="')
      .concat(F["validation-message"], '" id="')
      .concat(F["validation-message"], '"></div>\n   </div>\n   <div class="')
      .concat(F.actions, '">\n     <button type="button" class="')
      .concat(F.confirm, '">OK</button>\n     <button type="button" class="')
      .concat(F.cancel, '">Cancel</button>\n   </div>\n   <div class="')
      .concat(F.footer, '"></div>\n   <div class="')
      .concat(F["timer-progress-bar"], '"></div>\n </div>\n')
      .replace(/(^|\n)\s*/g, ""),
    ft = function (t) {
      var e;
      if (
        ((e = z()) &&
          (e.parentNode.removeChild(e),
          ut(
            [document.documentElement, document.body],
            [F["no-backdrop"], F["toast-shown"], F["has-column"]]
          )),
        ot())
      )
        g("SweetAlert2 requires document to initialize");
      else {
        var n = document.createElement("div");
        (n.className = F.container), (n.innerHTML = pt);
        var o,
          i,
          r,
          a,
          c,
          s,
          u,
          l,
          d,
          p,
          f,
          m,
          h = "string" == typeof (o = t.target) ? document.querySelector(o) : o;
        h.appendChild(n),
          (i = t),
          (r = W()).setAttribute("role", i.toast ? "alert" : "dialog"),
          r.setAttribute("aria-live", i.toast ? "polite" : "assertive"),
          i.toast || r.setAttribute("aria-modal", "true"),
          (a = h),
          "rtl" === window.getComputedStyle(a).direction && st(z(), F.rtl),
          (c = k()),
          (s = lt(c, F.input)),
          (u = lt(c, F.file)),
          (l = c.querySelector(".".concat(F.range, " input"))),
          (d = c.querySelector(".".concat(F.range, " output"))),
          (p = lt(c, F.select)),
          (f = c.querySelector(".".concat(F.checkbox, " input"))),
          (m = lt(c, F.textarea)),
          (s.oninput = it),
          (u.onchange = it),
          (p.onchange = it),
          (f.onchange = it),
          (m.oninput = it),
          (l.oninput = function (t) {
            it(t), (d.value = l.value);
          }),
          (l.onchange = function (t) {
            it(t), (l.nextSibling.value = l.value);
          });
      }
    },
    mt = function (t, e) {
      if (((t.innerHTML = ""), 0 in e))
        for (var n = 0; n in e; n++) t.appendChild(e[n].cloneNode(!0));
      else t.appendChild(e.cloneNode(!0));
    },
    ht = (function () {
      if (ot()) return !1;
      var t = document.createElement("div"),
        e = {
          WebkitAnimation: "webkitAnimationEnd",
          OAnimation: "oAnimationEnd oanimationend",
          animation: "animationend",
        };
      for (var n in e)
        if (Object.prototype.hasOwnProperty.call(e, n) && void 0 !== t.style[n])
          return e[n];
      return !1;
    })();
  function gt(t, e, n) {
    var o;
    tt(
      t,
      n["show".concat((o = e).charAt(0).toUpperCase() + o.slice(1), "Button")],
      "inline-block"
    ),
      (t.innerHTML = n["".concat(e, "ButtonText")]),
      t.setAttribute("aria-label", n["".concat(e, "ButtonAriaLabel")]),
      (t.className = F[e]),
      I(t, n, "".concat(e, "Button")),
      st(t, n["".concat(e, "ButtonClass")]);
  }
  function vt(t, e) {
    var n = z();
    if (n) {
      var o, i, r, a;
      (o = n),
        "string" == typeof (i = e.backdrop)
          ? (o.style.background = i)
          : i ||
            st([document.documentElement, document.body], F["no-backdrop"]),
        !e.backdrop &&
          e.allowOutsideClick &&
          R(
            '"allowOutsideClick" parameter requires `backdrop` parameter to be set to `true`'
          ),
        (r = n),
        (a = e.position) in F
          ? st(r, F[a])
          : (R('The "position" parameter is not valid, defaulting to "center"'),
            st(r, F.center)),
        (function (t, e) {
          if (e && "string" == typeof e) {
            var n = "grow-".concat(e);
            n in F && st(t, F[n]);
          }
        })(n, e.grow),
        I(n, e, "container");
      var c = document.body.getAttribute("data-swal2-queue-step");
      c &&
        (n.setAttribute("data-queue-step", c),
        document.body.removeAttribute("data-swal2-queue-step"));
    }
  }
  function bt(t, e) {
    (t.placeholder && !e.inputPlaceholder) ||
      (t.placeholder = e.inputPlaceholder);
  }
  var yt = {
      promise: new WeakMap(),
      innerParams: new WeakMap(),
      domCache: new WeakMap(),
    },
    wt = ["input", "file", "range", "select", "radio", "checkbox", "textarea"],
    Ct = function (t) {
      if (!Pt[t.input])
        return g(
          'Unexpected type of input! Expected "text", "email", "password", "number", "tel", "select", "radio", "checkbox", "textarea", "file" or "url", got "'.concat(
            t.input,
            '"'
          )
        );
      var e = At(t.input),
        n = Pt[t.input](e, t);
      X(n),
        setTimeout(function () {
          Q(n);
        });
    },
    kt = function (t, e) {
      var n = Z(k(), t);
      if (n)
        for (var o in (!(function (t) {
          for (var e = 0; e < t.attributes.length; e++) {
            var n = t.attributes[e].name;
            -1 === ["type", "value", "style"].indexOf(n) &&
              t.removeAttribute(n);
          }
        })(n),
        e))
          ("range" === t && "placeholder" === o) || n.setAttribute(o, e[o]);
    },
    xt = function (t) {
      var e = At(t.input);
      t.customClass && st(e, t.customClass.input);
    },
    At = function (t) {
      var e = F[t] ? F[t] : F.input;
      return lt(k(), e);
    },
    Pt = {};
  (Pt.text = Pt.email = Pt.password = Pt.number = Pt.tel = Pt.url = function (
    t,
    e
  ) {
    return (
      "string" == typeof e.inputValue || "number" == typeof e.inputValue
        ? (t.value = e.inputValue)
        : v(e.inputValue) ||
          R(
            'Unexpected type of inputValue! Expected "string", "number" or "Promise", got "'.concat(
              r(e.inputValue),
              '"'
            )
          ),
      bt(t, e),
      (t.type = e.input),
      t
    );
  }),
    (Pt.file = function (t, e) {
      return bt(t, e), t;
    }),
    (Pt.range = function (t, e) {
      var n = t.querySelector("input"),
        o = t.querySelector("output");
      return (
        (n.value = e.inputValue),
        (n.type = e.input),
        (o.value = e.inputValue),
        t
      );
    }),
    (Pt.select = function (t, e) {
      if (((t.innerHTML = ""), e.inputPlaceholder)) {
        var n = document.createElement("option");
        (n.innerHTML = e.inputPlaceholder),
          (n.value = ""),
          (n.disabled = !0),
          (n.selected = !0),
          t.appendChild(n);
      }
      return t;
    }),
    (Pt.radio = function (t) {
      return (t.innerHTML = ""), t;
    }),
    (Pt.checkbox = function (t, e) {
      var n = Z(k(), "checkbox");
      return (
        (n.value = 1),
        (n.id = F.checkbox),
        (n.checked = Boolean(e.inputValue)),
        (t.querySelector("span").innerHTML = e.inputPlaceholder),
        t
      );
    }),
    (Pt.textarea = function (e, t) {
      if (((e.value = t.inputValue), bt(e, t), "MutationObserver" in window)) {
        var n = parseInt(window.getComputedStyle(W()).width),
          o =
            parseInt(window.getComputedStyle(W()).paddingLeft) +
            parseInt(window.getComputedStyle(W()).paddingRight);
        new MutationObserver(function () {
          var t = e.offsetWidth + o;
          W().style.width = n < t ? "".concat(t, "px") : null;
        }).observe(e, { attributes: !0, attributeFilter: ["style"] });
      }
      return e;
    });
  function Bt(t, e) {
    var n,
      o,
      i,
      r,
      a,
      c = k().querySelector("#".concat(F.content));
    e.html
      ? (rt(e.html, c), X(c, "block"))
      : e.text
      ? ((c.textContent = e.text), X(c, "block"))
      : G(c),
      (n = t),
      (o = e),
      (i = k()),
      (r = yt.innerParams.get(n)),
      (a = !r || o.input !== r.input),
      wt.forEach(function (t) {
        var e = F[t],
          n = lt(i, e);
        kt(t, o.inputAttributes), (n.className = e), a && G(n);
      }),
      o.input && (a && Ct(o), xt(o)),
      I(k(), e, "content");
  }
  function Et() {
    return z().getAttribute("data-queue-step");
  }
  function St(t, s) {
    var u = A();
    if (!s.progressSteps || 0 === s.progressSteps.length) return G(u);
    X(u), (u.innerHTML = "");
    var l = parseInt(
      void 0 === s.currentProgressStep ? Et() : s.currentProgressStep
    );
    l >= s.progressSteps.length &&
      R(
        "Invalid currentProgressStep parameter, it should be less than progressSteps.length (currentProgressStep like JS arrays starts from 0)"
      ),
      s.progressSteps.forEach(function (t, e) {
        var n,
          o,
          i,
          r,
          a =
            ((n = t),
            (o = document.createElement("li")),
            st(o, F["progress-step"]),
            (o.innerHTML = n),
            o);
        if (
          (u.appendChild(a),
          e === l && st(a, F["active-progress-step"]),
          e !== s.progressSteps.length - 1)
        ) {
          var c =
            ((i = t),
            (r = document.createElement("li")),
            st(r, F["progress-step-line"]),
            i.progressStepsDistance &&
              (r.style.width = i.progressStepsDistance),
            r);
          u.appendChild(c);
        }
      });
  }
  function Tt(t, e) {
    var n,
      o,
      i,
      r,
      a = T();
    I(a, e, "header"),
      St(0, e),
      (function (t, e) {
        var n = yt.innerParams.get(t);
        if (n && e.icon === n.icon && w()) I(w(), e, "icon");
        else if ((Mt(), e.icon))
          if (-1 !== Object.keys(_).indexOf(e.icon)) {
            var o = y(".".concat(F.icon, ".").concat(_[e.icon]));
            X(o), jt(o, e), Ht(), I(o, e, "icon"), st(o, e.showClass.icon);
          } else
            g(
              'Unknown icon! Expected "success", "error", "warning", "info" or "question", got "'.concat(
                e.icon,
                '"'
              )
            );
      })(t, e),
      (function (t) {
        var e = x();
        if (!t.imageUrl) return G(e);
        X(e),
          e.setAttribute("src", t.imageUrl),
          e.setAttribute("alt", t.imageAlt),
          J(e, "width", t.imageWidth),
          J(e, "height", t.imageHeight),
          (e.className = F.image),
          I(e, t, "image");
      })(e),
      (n = e),
      (o = C()),
      tt(o, n.title || n.titleText),
      n.title && rt(n.title, o),
      n.titleText && (o.innerText = n.titleText),
      I(o, n, "title"),
      (i = e),
      ((r = M()).innerHTML = i.closeButtonHtml),
      I(r, i, "closeButton"),
      tt(r, i.showCloseButton),
      r.setAttribute("aria-label", i.closeButtonAriaLabel);
  }
  function Lt(t, e) {
    var n, o, i, r;
    (n = e),
      (o = W()),
      J(o, "width", n.width),
      J(o, "padding", n.padding),
      n.background && (o.style.background = n.background),
      qt(o, n),
      vt(0, e),
      Tt(t, e),
      Bt(t, e),
      at(0, e),
      (i = e),
      (r = L()),
      tt(r, i.footer),
      i.footer && rt(i.footer, r),
      I(r, i, "footer"),
      "function" == typeof e.onRender && e.onRender(W());
  }
  function Ot() {
    return B() && B().click();
  }
  var Mt = function () {
      for (var t = n(), e = 0; e < t.length; e++) G(t[e]);
    },
    Ht = function () {
      for (
        var t = W(),
          e = window.getComputedStyle(t).getPropertyValue("background-color"),
          n = t.querySelectorAll(
            "[class^=swal2-success-circular-line], .swal2-success-fix"
          ),
          o = 0;
        o < n.length;
        o++
      )
        n[o].style.backgroundColor = e;
    },
    jt = function (t, e) {
      if (((t.innerHTML = ""), e.iconHtml)) t.innerHTML = Vt(e.iconHtml);
      else if ("success" === e.icon)
        t.innerHTML =
          '\n      <div class="swal2-success-circular-line-left"></div>\n      <span class="swal2-success-line-tip"></span> <span class="swal2-success-line-long"></span>\n      <div class="swal2-success-ring"></div> <div class="swal2-success-fix"></div>\n      <div class="swal2-success-circular-line-right"></div>\n    ';
      else if ("error" === e.icon)
        t.innerHTML =
          '\n      <span class="swal2-x-mark">\n        <span class="swal2-x-mark-line-left"></span>\n        <span class="swal2-x-mark-line-right"></span>\n      </span>\n    ';
      else {
        t.innerHTML = Vt({ question: "?", warning: "!", info: "i" }[e.icon]);
      }
    },
    Vt = function (t) {
      return '<div class="'.concat(F["icon-content"], '">').concat(t, "</div>");
    },
    It = [],
    qt = function (t, e) {
      (t.className = ""
        .concat(F.popup, " ")
        .concat(dt(t) ? e.showClass.popup : "")),
        e.toast
          ? (st([document.documentElement, document.body], F["toast-shown"]),
            st(t, F.toast))
          : st(t, F.modal),
        I(t, e, "popup"),
        "string" == typeof e.customClass && st(t, e.customClass),
        e.icon && st(t, F["icon-".concat(e.icon)]);
    };
  function Rt() {
    var t = W();
    t || Je.fire(), (t = W());
    var e = S(),
      n = B();
    X(e),
      X(n, "inline-block"),
      st([t, e], F.loading),
      (n.disabled = !0),
      t.setAttribute("data-loading", !0),
      t.setAttribute("aria-busy", !0),
      t.focus();
  }
  function Nt() {
    return new Promise(function (t) {
      var e = window.scrollX,
        n = window.scrollY;
      (zt.restoreFocusTimeout = setTimeout(function () {
        zt.previousActiveElement && zt.previousActiveElement.focus
          ? (zt.previousActiveElement.focus(),
            (zt.previousActiveElement = null))
          : document.body && document.body.focus(),
          t();
      }, 100)),
        void 0 !== e && void 0 !== n && window.scrollTo(e, n);
    });
  }
  function Dt() {
    if (zt.timeout)
      return (
        (function () {
          var t = O(),
            e = parseInt(window.getComputedStyle(t).width);
          t.style.removeProperty("transition"), (t.style.width = "100%");
          var n = parseInt(window.getComputedStyle(t).width),
            o = parseInt((e / n) * 100);
          t.style.removeProperty("transition"),
            (t.style.width = "".concat(o, "%"));
        })(),
        zt.timeout.stop()
      );
  }
  function Ut() {
    if (zt.timeout) {
      var t = zt.timeout.start();
      return nt(t), t;
    }
  }
  function Ft(t) {
    return Object.prototype.hasOwnProperty.call(Wt, t);
  }
  function _t(t) {
    return Yt[t];
  }
  var zt = {},
    Wt = {
      title: "",
      titleText: "",
      text: "",
      html: "",
      footer: "",
      icon: void 0,
      iconHtml: void 0,
      toast: !1,
      animation: !0,
      showClass: {
        popup: "swal2-show",
        backdrop: "swal2-backdrop-show",
        icon: "swal2-icon-show",
      },
      hideClass: {
        popup: "swal2-hide",
        backdrop: "swal2-backdrop-hide",
        icon: "swal2-icon-hide",
      },
      customClass: void 0,
      target: "body",
      backdrop: !0,
      heightAuto: !0,
      allowOutsideClick: !0,
      allowEscapeKey: !0,
      allowEnterKey: !0,
      stopKeydownPropagation: !0,
      keydownListenerCapture: !1,
      showConfirmButton: !0,
      showCancelButton: !1,
      preConfirm: void 0,
      confirmButtonText: "OK",
      confirmButtonAriaLabel: "",
      confirmButtonColor: void 0,
      cancelButtonText: "Cancel",
      cancelButtonAriaLabel: "",
      cancelButtonColor: void 0,
      buttonsStyling: !0,
      reverseButtons: !1,
      focusConfirm: !0,
      focusCancel: !1,
      showCloseButton: !1,
      closeButtonHtml: "&times;",
      closeButtonAriaLabel: "Close this dialog",
      showLoaderOnConfirm: !1,
      imageUrl: void 0,
      imageWidth: void 0,
      imageHeight: void 0,
      imageAlt: "",
      timer: void 0,
      timerProgressBar: !1,
      width: void 0,
      padding: void 0,
      background: void 0,
      input: void 0,
      inputPlaceholder: "",
      inputValue: "",
      inputOptions: {},
      inputAutoTrim: !0,
      inputAttributes: {},
      inputValidator: void 0,
      validationMessage: void 0,
      grow: !1,
      position: "center",
      progressSteps: [],
      currentProgressStep: void 0,
      progressStepsDistance: void 0,
      onBeforeOpen: void 0,
      onOpen: void 0,
      onRender: void 0,
      onClose: void 0,
      onAfterClose: void 0,
      scrollbarPadding: !0,
    },
    Kt = [
      "title",
      "titleText",
      "text",
      "html",
      "icon",
      "customClass",
      "showConfirmButton",
      "showCancelButton",
      "confirmButtonText",
      "confirmButtonAriaLabel",
      "confirmButtonColor",
      "cancelButtonText",
      "cancelButtonAriaLabel",
      "cancelButtonColor",
      "buttonsStyling",
      "reverseButtons",
      "imageUrl",
      "imageWidth",
      "imageHeight",
      "imageAlt",
      "progressSteps",
      "currentProgressStep",
    ],
    Yt = { animation: 'showClass" and "hideClass' },
    Zt = [
      "allowOutsideClick",
      "allowEnterKey",
      "backdrop",
      "focusConfirm",
      "focusCancel",
      "heightAuto",
      "keydownListenerCapture",
    ],
    Qt = Object.freeze({
      isValidParameter: Ft,
      isUpdatableParameter: function (t) {
        return -1 !== Kt.indexOf(t);
      },
      isDeprecatedParameter: _t,
      argsToParams: function (o) {
        var i = {};
        return (
          "object" !== r(o[0]) || b(o[0])
            ? ["title", "html", "icon"].forEach(function (t, e) {
                var n = o[e];
                "string" == typeof n || b(n)
                  ? (i[t] = n)
                  : void 0 !== n &&
                    g(
                      "Unexpected type of "
                        .concat(t, '! Expected "string" or "Element", got ')
                        .concat(r(n))
                    );
              })
            : c(i, o[0]),
          i
        );
      },
      isVisible: function () {
        return dt(W());
      },
      clickConfirm: Ot,
      clickCancel: function () {
        return E() && E().click();
      },
      getContainer: z,
      getPopup: W,
      getTitle: C,
      getContent: k,
      getHtmlContainer: function () {
        return e(F["html-container"]);
      },
      getImage: x,
      getIcon: w,
      getIcons: n,
      getCloseButton: M,
      getActions: S,
      getConfirmButton: B,
      getCancelButton: E,
      getHeader: T,
      getFooter: L,
      getFocusableElements: H,
      getValidationMessage: P,
      isLoading: function () {
        return W().hasAttribute("data-loading");
      },
      fire: function () {
        for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
          e[n] = arguments[n];
        return l(this, e);
      },
      mixin: function (n) {
        return (function (t) {
          function e() {
            return o(this, e), d(this, s(e).apply(this, arguments));
          }
          return (
            (function (t, e) {
              if ("function" != typeof e && null !== e)
                throw new TypeError(
                  "Super expression must either be null or a function"
                );
              (t.prototype = Object.create(e && e.prototype, {
                constructor: { value: t, writable: !0, configurable: !0 },
              })),
                e && u(t, e);
            })(e, t),
            a(e, [
              {
                key: "_main",
                value: function (t) {
                  return p(s(e.prototype), "_main", this).call(
                    this,
                    c({}, n, t)
                  );
                },
              },
            ]),
            e
          );
        })(this);
      },
      queue: function (t) {
        var r = this;
        It = t;
        function a(t, e) {
          (It = []), t(e);
        }
        var c = [];
        return new Promise(function (i) {
          !(function e(n, o) {
            n < It.length
              ? (document.body.setAttribute("data-swal2-queue-step", n),
                r.fire(It[n]).then(function (t) {
                  void 0 !== t.value
                    ? (c.push(t.value), e(n + 1, o))
                    : a(i, { dismiss: t.dismiss });
                }))
              : a(i, { value: c });
          })(0);
        });
      },
      getQueueStep: Et,
      insertQueueStep: function (t, e) {
        return e && e < It.length ? It.splice(e, 0, t) : It.push(t);
      },
      deleteQueueStep: function (t) {
        void 0 !== It[t] && It.splice(t, 1);
      },
      showLoading: Rt,
      enableLoading: Rt,
      getTimerLeft: function () {
        return zt.timeout && zt.timeout.getTimerLeft();
      },
      stopTimer: Dt,
      resumeTimer: Ut,
      toggleTimer: function () {
        var t = zt.timeout;
        return t && (t.running ? Dt() : Ut());
      },
      increaseTimer: function (t) {
        if (zt.timeout) {
          var e = zt.timeout.increase(t);
          return nt(e, !0), e;
        }
      },
      isTimerRunning: function () {
        return zt.timeout && zt.timeout.isRunning();
      },
    });
  function $t() {
    var t = yt.innerParams.get(this);
    if (t) {
      var e = yt.domCache.get(this);
      t.showConfirmButton ||
        (G(e.confirmButton), t.showCancelButton || G(e.actions)),
        ut([e.popup, e.actions], F.loading),
        e.popup.removeAttribute("aria-busy"),
        e.popup.removeAttribute("data-loading"),
        (e.confirmButton.disabled = !1),
        (e.cancelButton.disabled = !1);
    }
  }
  function Jt() {
    null === Y.previousBodyPadding &&
      document.body.scrollHeight > window.innerHeight &&
      ((Y.previousBodyPadding = parseInt(
        window.getComputedStyle(document.body).getPropertyValue("padding-right")
      )),
      (document.body.style.paddingRight = "".concat(
        Y.previousBodyPadding +
          (function () {
            var t = document.createElement("div");
            (t.className = F["scrollbar-measure"]),
              document.body.appendChild(t);
            var e = t.getBoundingClientRect().width - t.clientWidth;
            return document.body.removeChild(t), e;
          })(),
        "px"
      )));
  }
  function Xt() {
    return !!window.MSInputMethodContext && !!document.documentMode;
  }
  function Gt() {
    var t = z(),
      e = W();
    t.style.removeProperty("align-items"),
      e.offsetTop < 0 && (t.style.alignItems = "flex-start");
  }
  var te = function () {
      var n,
        o = z();
      (o.ontouchstart = function (t) {
        var e;
        n =
          t.target === o ||
          (!((e = o).scrollHeight > e.clientHeight) &&
            "INPUT" !== t.target.tagName);
      }),
        (o.ontouchmove = function (t) {
          n && (t.preventDefault(), t.stopPropagation());
        });
    },
    ee = { swalPromiseResolve: new WeakMap() };
  function ne(t, e, n, o) {
    n
      ? ae(t, o)
      : (Nt().then(function () {
          return ae(t, o);
        }),
        zt.keydownTarget.removeEventListener("keydown", zt.keydownHandler, {
          capture: zt.keydownListenerCapture,
        }),
        (zt.keydownHandlerAdded = !1)),
      e.parentNode && e.parentNode.removeChild(e),
      j() &&
        (null !== Y.previousBodyPadding &&
          ((document.body.style.paddingRight = "".concat(
            Y.previousBodyPadding,
            "px"
          )),
          (Y.previousBodyPadding = null)),
        (function () {
          if (V(document.body, F.iosfix)) {
            var t = parseInt(document.body.style.top, 10);
            ut(document.body, F.iosfix),
              (document.body.style.top = ""),
              (document.body.scrollTop = -1 * t);
          }
        })(),
        "undefined" != typeof window &&
          Xt() &&
          window.removeEventListener("resize", Gt),
        m(document.body.children).forEach(function (t) {
          t.hasAttribute("data-previous-aria-hidden")
            ? (t.setAttribute(
                "aria-hidden",
                t.getAttribute("data-previous-aria-hidden")
              ),
              t.removeAttribute("data-previous-aria-hidden"))
            : t.removeAttribute("aria-hidden");
        })),
      ut(
        [document.documentElement, document.body],
        [
          F.shown,
          F["height-auto"],
          F["no-backdrop"],
          F["toast-shown"],
          F["toast-column"],
        ]
      );
  }
  function oe(t) {
    var e = W();
    if (e) {
      var n = yt.innerParams.get(this);
      if (n && !V(e, n.hideClass.popup)) {
        var o = ee.swalPromiseResolve.get(this);
        ut(e, n.showClass.popup), st(e, n.hideClass.popup);
        var i = z();
        ut(i, n.showClass.backdrop),
          st(i, n.hideClass.backdrop),
          (function (t, e, n) {
            var o = z(),
              i = ht && et(e),
              r = n.onClose,
              a = n.onAfterClose;
            if (r !== null && typeof r === "function") {
              r(e);
            }
            if (i) {
              re(t, e, o, a);
            } else {
              ne(t, o, K(), a);
            }
          })(this, e, n),
          o(t || {});
      }
    }
  }
  function ie(t) {
    for (var e in t) t[e] = new WeakMap();
  }
  var re = function (t, e, n, o) {
      (zt.swalCloseEventFinishedCallback = ne.bind(null, t, n, K(), o)),
        e.addEventListener(ht, function (t) {
          t.target === e &&
            (zt.swalCloseEventFinishedCallback(),
            delete zt.swalCloseEventFinishedCallback);
        });
    },
    ae = function (t, e) {
      setTimeout(function () {
        null !== e && "function" == typeof e && e(),
          W() ||
            (delete t.params,
            delete zt.keydownHandler,
            delete zt.keydownTarget,
            ie(yt),
            ie(ee));
      });
    };
  function ce(t, e, n) {
    var o = yt.domCache.get(t);
    e.forEach(function (t) {
      o[t].disabled = n;
    });
  }
  function se(t, e) {
    if (!t) return !1;
    if ("radio" === t.type)
      for (
        var n = t.parentNode.parentNode.querySelectorAll("input"), o = 0;
        o < n.length;
        o++
      )
        n[o].disabled = e;
    else t.disabled = e;
  }
  var ue = (function () {
      function n(t, e) {
        o(this, n),
          (this.callback = t),
          (this.remaining = e),
          (this.running = !1),
          this.start();
      }
      return (
        a(n, [
          {
            key: "start",
            value: function () {
              return (
                this.running ||
                  ((this.running = !0),
                  (this.started = new Date()),
                  (this.id = setTimeout(this.callback, this.remaining))),
                this.remaining
              );
            },
          },
          {
            key: "stop",
            value: function () {
              return (
                this.running &&
                  ((this.running = !1),
                  clearTimeout(this.id),
                  (this.remaining -= new Date() - this.started)),
                this.remaining
              );
            },
          },
          {
            key: "increase",
            value: function (t) {
              var e = this.running;
              return (
                e && this.stop(),
                (this.remaining += t),
                e && this.start(),
                this.remaining
              );
            },
          },
          {
            key: "getTimerLeft",
            value: function () {
              return (
                this.running && (this.stop(), this.start()), this.remaining
              );
            },
          },
          {
            key: "isRunning",
            value: function () {
              return this.running;
            },
          },
        ]),
        n
      );
    })(),
    le = {
      email: function (t, e) {
        return /^[a-zA-Z0-9.+_-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]{2,24}$/.test(t)
          ? Promise.resolve()
          : Promise.resolve(e || "Invalid email address");
      },
      url: function (t, e) {
        return /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)$/.test(
          t
        )
          ? Promise.resolve()
          : Promise.resolve(e || "Invalid URL");
      },
    };
  function de(t) {
    var e, n;
    (e = t).inputValidator ||
      Object.keys(le).forEach(function (t) {
        e.input === t && (e.inputValidator = le[t]);
      }),
      t.showLoaderOnConfirm &&
        !t.preConfirm &&
        R(
          "showLoaderOnConfirm is set to true, but preConfirm is not defined.\nshowLoaderOnConfirm should be used together with preConfirm, see usage example:\nhttps://sweetalert2.github.io/#ajax-request"
        ),
      (t.animation = D(t.animation)),
      ((n = t).target &&
        ("string" != typeof n.target || document.querySelector(n.target)) &&
        ("string" == typeof n.target || n.target.appendChild)) ||
        (R('Target parameter is not valid, defaulting to "body"'),
        (n.target = "body")),
      "string" == typeof t.title &&
        (t.title = t.title.split("\n").join("<br />")),
      ft(t);
  }
  function pe(t) {
    var e = z(),
      n = W();
    "function" == typeof t.onBeforeOpen && t.onBeforeOpen(n),
      xe(e, n, t),
      Ce(e, n),
      j() && ke(e, t.scrollbarPadding),
      K() ||
        zt.previousActiveElement ||
        (zt.previousActiveElement = document.activeElement),
      "function" == typeof t.onOpen &&
        setTimeout(function () {
          return t.onOpen(n);
        });
  }
  function fe(t) {
    var e = W();
    if (t.target === e) {
      var n = z();
      e.removeEventListener(ht, fe), (n.style.overflowY = "auto");
    }
  }
  function me(t, e) {
    "select" === e.input || "radio" === e.input
      ? Ee(t, e)
      : -1 !==
          ["text", "email", "number", "tel", "textarea"].indexOf(e.input) &&
        v(e.inputValue) &&
        Se(t, e);
  }
  function he(t, e) {
    t.disableButtons(), e.input ? Oe(t, e) : Me(t, e, !0);
  }
  function ge(t, e) {
    t.disableButtons(), e(U.cancel);
  }
  function ve(t, e) {
    t.closePopup({ value: e });
  }
  function be(e, t, n, o) {
    t.keydownTarget &&
      t.keydownHandlerAdded &&
      (t.keydownTarget.removeEventListener("keydown", t.keydownHandler, {
        capture: t.keydownListenerCapture,
      }),
      (t.keydownHandlerAdded = !1)),
      n.toast ||
        ((t.keydownHandler = function (t) {
          return Ve(e, t, n, o);
        }),
        (t.keydownTarget = n.keydownListenerCapture ? window : W()),
        (t.keydownListenerCapture = n.keydownListenerCapture),
        t.keydownTarget.addEventListener("keydown", t.keydownHandler, {
          capture: t.keydownListenerCapture,
        }),
        (t.keydownHandlerAdded = !0));
  }
  function ye(t, e, n) {
    for (var o = H(), i = 0; i < o.length; i++)
      return (
        (e += n) === o.length ? (e = 0) : -1 === e && (e = o.length - 1),
        o[e].focus()
      );
    W().focus();
  }
  function we(t, e, n) {
    e.toast ? De(t, e, n) : (Fe(t), _e(t), ze(t, e, n));
  }
  var Ce = function (t, e) {
      ht && et(e)
        ? ((t.style.overflowY = "hidden"), e.addEventListener(ht, fe))
        : (t.style.overflowY = "auto");
    },
    ke = function (t, e) {
      !(function () {
        if (
          ((/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) ||
            ("MacIntel" === navigator.platform &&
              1 < navigator.maxTouchPoints)) &&
          !V(document.body, F.iosfix)
        ) {
          var t = document.body.scrollTop;
          (document.body.style.top = "".concat(-1 * t, "px")),
            st(document.body, F.iosfix),
            te();
        }
      })(),
        "undefined" != typeof window &&
          Xt() &&
          (Gt(), window.addEventListener("resize", Gt)),
        m(document.body.children).forEach(function (t) {
          t === z() ||
            (function (t, e) {
              if ("function" == typeof t.contains) return t.contains(e);
            })(t, z()) ||
            (t.hasAttribute("aria-hidden") &&
              t.setAttribute(
                "data-previous-aria-hidden",
                t.getAttribute("aria-hidden")
              ),
            t.setAttribute("aria-hidden", "true"));
        }),
        e && Jt(),
        setTimeout(function () {
          t.scrollTop = 0;
        });
    },
    xe = function (t, e, n) {
      st(t, n.showClass.backdrop),
        X(e),
        st(e, n.showClass.popup),
        st([document.documentElement, document.body], F.shown),
        n.heightAuto &&
          n.backdrop &&
          !n.toast &&
          st([document.documentElement, document.body], F["height-auto"]);
    },
    Ae = function (t) {
      return t.checked ? 1 : 0;
    },
    Pe = function (t) {
      return t.checked ? t.value : null;
    },
    Be = function (t) {
      return t.files.length
        ? null !== t.getAttribute("multiple")
          ? t.files
          : t.files[0]
        : null;
    },
    Ee = function (e, n) {
      function o(t) {
        return Te[n.input](i, Le(t), n);
      }
      var i = k();
      v(n.inputOptions)
        ? (Rt(),
          n.inputOptions.then(function (t) {
            e.hideLoading(), o(t);
          }))
        : "object" === r(n.inputOptions)
        ? o(n.inputOptions)
        : g(
            "Unexpected type of inputOptions! Expected object, Map or Promise, got ".concat(
              r(n.inputOptions)
            )
          );
    },
    Se = function (e, n) {
      var o = e.getInput();
      G(o),
        n.inputValue
          .then(function (t) {
            (o.value =
              "number" === n.input ? parseFloat(t) || 0 : "".concat(t)),
              X(o),
              o.focus(),
              e.hideLoading();
          })
          .catch(function (t) {
            g("Error in inputValue promise: ".concat(t)),
              (o.value = ""),
              X(o),
              o.focus(),
              e.hideLoading();
          });
    },
    Te = {
      select: function (t, e, i) {
        var r = lt(t, F.select);
        e.forEach(function (t) {
          var e = t[0],
            n = t[1],
            o = document.createElement("option");
          (o.value = e),
            (o.innerHTML = n),
            i.inputValue.toString() === e.toString() && (o.selected = !0),
            r.appendChild(o);
        }),
          r.focus();
      },
      radio: function (t, e, a) {
        var c = lt(t, F.radio);
        e.forEach(function (t) {
          var e = t[0],
            n = t[1],
            o = document.createElement("input"),
            i = document.createElement("label");
          (o.type = "radio"),
            (o.name = F.radio),
            (o.value = e),
            a.inputValue.toString() === e.toString() && (o.checked = !0);
          var r = document.createElement("span");
          (r.innerHTML = n),
            (r.className = F.label),
            i.appendChild(o),
            i.appendChild(r),
            c.appendChild(i);
        });
        var n = c.querySelectorAll("input");
        n.length && n[0].focus();
      },
    },
    Le = function (e) {
      var n = [];
      return (
        "undefined" != typeof Map && e instanceof Map
          ? e.forEach(function (t, e) {
              n.push([e, t]);
            })
          : Object.keys(e).forEach(function (t) {
              n.push([t, e[t]]);
            }),
        n
      );
    },
    Oe = function (e, n) {
      var o = (function (t, e) {
        var n = t.getInput();
        if (!n) return null;
        switch (e.input) {
          case "checkbox":
            return Ae(n);
          case "radio":
            return Pe(n);
          case "file":
            return Be(n);
          default:
            return e.inputAutoTrim ? n.value.trim() : n.value;
        }
      })(e, n);
      n.inputValidator
        ? (e.disableInput(),
          Promise.resolve()
            .then(function () {
              return n.inputValidator(o, n.validationMessage);
            })
            .then(function (t) {
              e.enableButtons(),
                e.enableInput(),
                t ? e.showValidationMessage(t) : Me(e, n, o);
            }))
        : e.getInput().checkValidity()
        ? Me(e, n, o)
        : (e.enableButtons(), e.showValidationMessage(n.validationMessage));
    },
    Me = function (e, t, n) {
      (t.showLoaderOnConfirm && Rt(), t.preConfirm)
        ? (e.resetValidationMessage(),
          Promise.resolve()
            .then(function () {
              return t.preConfirm(n, t.validationMessage);
            })
            .then(function (t) {
              dt(P()) || !1 === t
                ? e.hideLoading()
                : ve(e, void 0 === t ? n : t);
            }))
        : ve(e, n);
    },
    He = [
      "ArrowLeft",
      "ArrowRight",
      "ArrowUp",
      "ArrowDown",
      "Left",
      "Right",
      "Up",
      "Down",
    ],
    je = ["Escape", "Esc"],
    Ve = function (t, e, n, o) {
      n.stopKeydownPropagation && e.stopPropagation(),
        "Enter" === e.key
          ? Ie(t, e, n)
          : "Tab" === e.key
          ? qe(e, n)
          : -1 !== He.indexOf(e.key)
          ? Re()
          : -1 !== je.indexOf(e.key) && Ne(e, n, o);
    },
    Ie = function (t, e, n) {
      if (
        !e.isComposing &&
        e.target &&
        t.getInput() &&
        e.target.outerHTML === t.getInput().outerHTML
      ) {
        if (-1 !== ["textarea", "file"].indexOf(n.input)) return;
        Ot(), e.preventDefault();
      }
    },
    qe = function (t) {
      for (var e = t.target, n = H(), o = -1, i = 0; i < n.length; i++)
        if (e === n[i]) {
          o = i;
          break;
        }
      t.shiftKey ? ye(0, o, -1) : ye(0, o, 1),
        t.stopPropagation(),
        t.preventDefault();
    },
    Re = function () {
      var t = B(),
        e = E();
      document.activeElement === t && dt(e)
        ? e.focus()
        : document.activeElement === e && dt(t) && t.focus();
    },
    Ne = function (t, e, n) {
      D(e.allowEscapeKey) && (t.preventDefault(), n(U.esc));
    },
    De = function (t, e, n) {
      t.popup.onclick = function () {
        e.showConfirmButton ||
          e.showCancelButton ||
          e.showCloseButton ||
          e.input ||
          n(U.close);
      };
    },
    Ue = !1,
    Fe = function (e) {
      e.popup.onmousedown = function () {
        e.container.onmouseup = function (t) {
          (e.container.onmouseup = void 0),
            t.target === e.container && (Ue = !0);
        };
      };
    },
    _e = function (e) {
      e.container.onmousedown = function () {
        e.popup.onmouseup = function (t) {
          (e.popup.onmouseup = void 0),
            (t.target !== e.popup && !e.popup.contains(t.target)) || (Ue = !0);
        };
      };
    },
    ze = function (e, n, o) {
      e.container.onclick = function (t) {
        Ue
          ? (Ue = !1)
          : t.target === e.container && D(n.allowOutsideClick) && o(U.backdrop);
      };
    };
  var We = function (t, e, n) {
      var o = O();
      G(o),
        e.timer &&
          ((t.timeout = new ue(function () {
            n("timer"), delete t.timeout;
          }, e.timer)),
          e.timerProgressBar &&
            (X(o),
            setTimeout(function () {
              nt(e.timer);
            })));
    },
    Ke = function (t, e) {
      if (!e.toast)
        return D(e.allowEnterKey)
          ? e.focusCancel && dt(t.cancelButton)
            ? t.cancelButton.focus()
            : e.focusConfirm && dt(t.confirmButton)
            ? t.confirmButton.focus()
            : void ye(0, -1, 1)
          : Ye();
    },
    Ye = function () {
      document.activeElement &&
        "function" == typeof document.activeElement.blur &&
        document.activeElement.blur();
    };
  var Ze,
    Qe = Object.freeze({
      hideLoading: $t,
      disableLoading: $t,
      getInput: function (t) {
        var e = yt.innerParams.get(t || this),
          n = yt.domCache.get(t || this);
        return n ? Z(n.content, e.input) : null;
      },
      close: oe,
      closePopup: oe,
      closeModal: oe,
      closeToast: oe,
      enableButtons: function () {
        ce(this, ["confirmButton", "cancelButton"], !1);
      },
      disableButtons: function () {
        ce(this, ["confirmButton", "cancelButton"], !0);
      },
      enableInput: function () {
        return se(this.getInput(), !1);
      },
      disableInput: function () {
        return se(this.getInput(), !0);
      },
      showValidationMessage: function (t) {
        var e = yt.domCache.get(this);
        e.validationMessage.innerHTML = t;
        var n = window.getComputedStyle(e.popup);
        (e.validationMessage.style.marginLeft = "-".concat(
          n.getPropertyValue("padding-left")
        )),
          (e.validationMessage.style.marginRight = "-".concat(
            n.getPropertyValue("padding-right")
          )),
          X(e.validationMessage);
        var o = this.getInput();
        o &&
          (o.setAttribute("aria-invalid", !0),
          o.setAttribute("aria-describedBy", F["validation-message"]),
          Q(o),
          st(o, F.inputerror));
      },
      resetValidationMessage: function () {
        var t = yt.domCache.get(this);
        t.validationMessage && G(t.validationMessage);
        var e = this.getInput();
        e &&
          (e.removeAttribute("aria-invalid"),
          e.removeAttribute("aria-describedBy"),
          ut(e, F.inputerror));
      },
      getProgressSteps: function () {
        return yt.domCache.get(this).progressSteps;
      },
      _main: function (t) {
        !(function (t) {
          for (var e in t)
            Ft((i = e)) || R('Unknown parameter "'.concat(i, '"')),
              t.toast &&
                ((o = e),
                -1 !== Zt.indexOf(o) &&
                  R(
                    'The parameter "'.concat(o, '" is incompatible with toasts')
                  )),
              _t((n = e)) && h(n, _t(n));
          var n, o, i;
        })(t),
          W() &&
            zt.swalCloseEventFinishedCallback &&
            (zt.swalCloseEventFinishedCallback(),
            delete zt.swalCloseEventFinishedCallback),
          zt.deferDisposalTimer &&
            (clearTimeout(zt.deferDisposalTimer), delete zt.deferDisposalTimer);
        var e = (function (t) {
          var e = c({}, Wt.showClass, t.showClass),
            n = c({}, Wt.hideClass, t.hideClass),
            o = c({}, Wt, t);
          if (((o.showClass = e), (o.hideClass = n), t.animation === false)) {
            o.showClass = {
              popup: "",
              backdrop: "swal2-backdrop-show swal2-noanimation",
            };
            o.hideClass = {};
          }
          return o;
        })(t);
        de(e),
          Object.freeze(e),
          zt.timeout && (zt.timeout.stop(), delete zt.timeout),
          clearTimeout(zt.restoreFocusTimeout);
        var n = (function (t) {
          var e = {
            popup: W(),
            container: z(),
            content: k(),
            actions: S(),
            confirmButton: B(),
            cancelButton: E(),
            closeButton: M(),
            validationMessage: P(),
            progressSteps: A(),
          };
          return yt.domCache.set(t, e), e;
        })(this);
        return (
          Lt(this, e),
          yt.innerParams.set(this, e),
          (function (n, o, i) {
            return new Promise(function (t) {
              var e = function t(e) {
                n.closePopup({ dismiss: e });
              };
              ee.swalPromiseResolve.set(n, t);
              We(zt, i, e);
              o.confirmButton.onclick = function () {
                return he(n, i);
              };
              o.cancelButton.onclick = function () {
                return ge(n, e);
              };
              o.closeButton.onclick = function () {
                return e(U.close);
              };
              we(o, i, e);
              be(n, zt, i, e);
              if (i.toast && (i.input || i.footer || i.showCloseButton)) {
                st(document.body, F["toast-column"]);
              } else {
                ut(document.body, F["toast-column"]);
              }
              me(n, i);
              pe(i);
              Ke(o, i);
              o.container.scrollTop = 0;
            });
          })(this, n, e)
        );
      },
      update: function (e) {
        var t = W(),
          n = yt.innerParams.get(this);
        if (!t || V(t, n.hideClass.popup))
          return R(
            "You're trying to update the closed or closing popup, that won't work. Use the update() method in preConfirm parameter or show a new popup."
          );
        var o = {};
        Object.keys(e).forEach(function (t) {
          Je.isUpdatableParameter(t)
            ? (o[t] = e[t])
            : R(
                'Invalid parameter to update: "'.concat(
                  t,
                  '". Updatable params are listed here: https://github.com/sweetalert2/sweetalert2/blob/master/src/utils/params.js'
                )
              );
        });
        var i = c({}, n, o);
        Lt(this, i),
          yt.innerParams.set(this, i),
          Object.defineProperties(this, {
            params: {
              value: c({}, this.params, e),
              writable: !1,
              enumerable: !0,
            },
          });
      },
    });
  function $e() {
    if ("undefined" != typeof window) {
      "undefined" == typeof Promise &&
        g(
          "This package requires a Promise library, please include a shim to enable it in this browser (See: https://github.com/sweetalert2/sweetalert2/wiki/Migration-from-SweetAlert-to-SweetAlert2#1-ie-support)"
        ),
        (Ze = this);
      for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
        e[n] = arguments[n];
      var o = Object.freeze(this.constructor.argsToParams(e));
      Object.defineProperties(this, {
        params: { value: o, writable: !1, enumerable: !0, configurable: !0 },
      });
      var i = this._main(this.params);
      yt.promise.set(this, i);
    }
  }
  ($e.prototype.then = function (t) {
    return yt.promise.get(this).then(t);
  }),
    ($e.prototype.finally = function (t) {
      return yt.promise.get(this).finally(t);
    }),
    c($e.prototype, Qe),
    c($e, Qt),
    Object.keys(Qe).forEach(function (t) {
      $e[t] = function () {
        if (Ze) return Ze[t].apply(Ze, arguments);
      };
    }),
    ($e.DismissReason = U),
    ($e.version = "9.5.4");
  var Je = $e;
  return (Je.default = Je);
}),
  void 0 !== this &&
    this.Sweetalert2 &&
    (this.swal = this.sweetAlert = this.Swal = this.SweetAlert = this.Sweetalert2);
"undefined" != typeof document &&
  (function (e, t) {
    var n = e.createElement("style");
    if ((e.getElementsByTagName("head")[0].appendChild(n), n.styleSheet))
      n.styleSheet.disabled || (n.styleSheet.cssText = t);
    else
      try {
        n.innerHTML = t;
      } catch (e) {
        n.innerText = t;
      }
  })(
    document,
    '.swal2-popup.swal2-toast{-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row;-webkit-box-align:center;align-items:center;width:auto;padding:.625em;overflow-y:hidden;background:#fff;box-shadow:0 0 .625em #d9d9d9}.swal2-popup.swal2-toast .swal2-header{-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row}.swal2-popup.swal2-toast .swal2-title{-webkit-box-flex:1;flex-grow:1;-webkit-box-pack:start;justify-content:flex-start;margin:0 .6em;font-size:1em}.swal2-popup.swal2-toast .swal2-footer{margin:.5em 0 0;padding:.5em 0 0;font-size:.8em}.swal2-popup.swal2-toast .swal2-close{position:static;width:.8em;height:.8em;line-height:.8}.swal2-popup.swal2-toast .swal2-content{-webkit-box-pack:start;justify-content:flex-start;font-size:1em}.swal2-popup.swal2-toast .swal2-icon{width:2em;min-width:2em;height:2em;margin:0}.swal2-popup.swal2-toast .swal2-icon .swal2-icon-content{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;font-size:1.8em;font-weight:700}@media all and (-ms-high-contrast:none),(-ms-high-contrast:active){.swal2-popup.swal2-toast .swal2-icon .swal2-icon-content{font-size:.25em}}.swal2-popup.swal2-toast .swal2-icon.swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line]{top:.875em;width:1.375em}.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=left]{left:.3125em}.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=right]{right:.3125em}.swal2-popup.swal2-toast .swal2-actions{flex-basis:auto!important;width:auto;height:auto;margin:0 .3125em}.swal2-popup.swal2-toast .swal2-styled{margin:0 .3125em;padding:.3125em .625em;font-size:1em}.swal2-popup.swal2-toast .swal2-styled:focus{box-shadow:0 0 0 1px #fff,0 0 0 3px rgba(50,100,150,.4)}.swal2-popup.swal2-toast .swal2-success{border-color:#a5dc86}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-circular-line]{position:absolute;width:1.6em;height:3em;-webkit-transform:rotate(45deg);transform:rotate(45deg);border-radius:50%}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=left]{top:-.8em;left:-.5em;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);-webkit-transform-origin:2em 2em;transform-origin:2em 2em;border-radius:4em 0 0 4em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=right]{top:-.25em;left:.9375em;-webkit-transform-origin:0 1.5em;transform-origin:0 1.5em;border-radius:0 4em 4em 0}.swal2-popup.swal2-toast .swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-popup.swal2-toast .swal2-success .swal2-success-fix{top:0;left:.4375em;width:.4375em;height:2.6875em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-line]{height:.3125em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-line][class$=tip]{top:1.125em;left:.1875em;width:.75em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-line][class$=long]{top:.9375em;right:.1875em;width:1.375em}.swal2-popup.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-tip{-webkit-animation:swal2-toast-animate-success-line-tip .75s;animation:swal2-toast-animate-success-line-tip .75s}.swal2-popup.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-long{-webkit-animation:swal2-toast-animate-success-line-long .75s;animation:swal2-toast-animate-success-line-long .75s}.swal2-popup.swal2-toast.swal2-show{-webkit-animation:swal2-toast-show .5s;animation:swal2-toast-show .5s}.swal2-popup.swal2-toast.swal2-hide{-webkit-animation:swal2-toast-hide .1s forwards;animation:swal2-toast-hide .1s forwards}.swal2-container{display:-webkit-box;display:flex;position:fixed;z-index:1060;top:0;right:0;bottom:0;left:0;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center;padding:.625em;overflow-x:hidden;-webkit-transition:background-color .1s;transition:background-color .1s;-webkit-overflow-scrolling:touch}.swal2-container.swal2-backdrop-show{background:rgba(0,0,0,.4)}.swal2-container.swal2-backdrop-hide{background:0 0!important}.swal2-container.swal2-top{-webkit-box-align:start;align-items:flex-start}.swal2-container.swal2-top-left,.swal2-container.swal2-top-start{-webkit-box-align:start;align-items:flex-start;-webkit-box-pack:start;justify-content:flex-start}.swal2-container.swal2-top-end,.swal2-container.swal2-top-right{-webkit-box-align:start;align-items:flex-start;-webkit-box-pack:end;justify-content:flex-end}.swal2-container.swal2-center{-webkit-box-align:center;align-items:center}.swal2-container.swal2-center-left,.swal2-container.swal2-center-start{-webkit-box-align:center;align-items:center;-webkit-box-pack:start;justify-content:flex-start}.swal2-container.swal2-center-end,.swal2-container.swal2-center-right{-webkit-box-align:center;align-items:center;-webkit-box-pack:end;justify-content:flex-end}.swal2-container.swal2-bottom{-webkit-box-align:end;align-items:flex-end}.swal2-container.swal2-bottom-left,.swal2-container.swal2-bottom-start{-webkit-box-align:end;align-items:flex-end;-webkit-box-pack:start;justify-content:flex-start}.swal2-container.swal2-bottom-end,.swal2-container.swal2-bottom-right{-webkit-box-align:end;align-items:flex-end;-webkit-box-pack:end;justify-content:flex-end}.swal2-container.swal2-bottom-end>:first-child,.swal2-container.swal2-bottom-left>:first-child,.swal2-container.swal2-bottom-right>:first-child,.swal2-container.swal2-bottom-start>:first-child,.swal2-container.swal2-bottom>:first-child{margin-top:auto}.swal2-container.swal2-grow-fullscreen>.swal2-modal{display:-webkit-box!important;display:flex!important;-webkit-box-flex:1;flex:1;align-self:stretch;-webkit-box-pack:center;justify-content:center}.swal2-container.swal2-grow-row>.swal2-modal{display:-webkit-box!important;display:flex!important;-webkit-box-flex:1;flex:1;align-content:center;-webkit-box-pack:center;justify-content:center}.swal2-container.swal2-grow-column{-webkit-box-flex:1;flex:1;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column}.swal2-container.swal2-grow-column.swal2-bottom,.swal2-container.swal2-grow-column.swal2-center,.swal2-container.swal2-grow-column.swal2-top{-webkit-box-align:center;align-items:center}.swal2-container.swal2-grow-column.swal2-bottom-left,.swal2-container.swal2-grow-column.swal2-bottom-start,.swal2-container.swal2-grow-column.swal2-center-left,.swal2-container.swal2-grow-column.swal2-center-start,.swal2-container.swal2-grow-column.swal2-top-left,.swal2-container.swal2-grow-column.swal2-top-start{-webkit-box-align:start;align-items:flex-start}.swal2-container.swal2-grow-column.swal2-bottom-end,.swal2-container.swal2-grow-column.swal2-bottom-right,.swal2-container.swal2-grow-column.swal2-center-end,.swal2-container.swal2-grow-column.swal2-center-right,.swal2-container.swal2-grow-column.swal2-top-end,.swal2-container.swal2-grow-column.swal2-top-right{-webkit-box-align:end;align-items:flex-end}.swal2-container.swal2-grow-column>.swal2-modal{display:-webkit-box!important;display:flex!important;-webkit-box-flex:1;flex:1;align-content:center;-webkit-box-pack:center;justify-content:center}.swal2-container:not(.swal2-top):not(.swal2-top-start):not(.swal2-top-end):not(.swal2-top-left):not(.swal2-top-right):not(.swal2-center-start):not(.swal2-center-end):not(.swal2-center-left):not(.swal2-center-right):not(.swal2-bottom):not(.swal2-bottom-start):not(.swal2-bottom-end):not(.swal2-bottom-left):not(.swal2-bottom-right):not(.swal2-grow-fullscreen)>.swal2-modal{margin:auto}@media all and (-ms-high-contrast:none),(-ms-high-contrast:active){.swal2-container .swal2-modal{margin:0!important}}.swal2-popup{display:none;position:relative;box-sizing:border-box;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;-webkit-box-pack:center;justify-content:center;width:32em;max-width:100%;padding:1.25em;border:none;border-radius:.3125em;background:#fff;font-family:inherit;font-size:1rem}.swal2-popup:focus{outline:0}.swal2-popup.swal2-loading{overflow-y:hidden}.swal2-header{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;-webkit-box-align:center;align-items:center}.swal2-title{position:relative;max-width:100%;margin:0 0 .4em;padding:0;color:#595959;font-size:1.875em;font-weight:600;text-align:center;text-transform:none;word-wrap:break-word}.swal2-actions{display:-webkit-box;display:flex;z-index:1;flex-wrap:wrap;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center;width:100%;margin:1.25em auto 0}.swal2-actions:not(.swal2-loading) .swal2-styled[disabled]{opacity:.4}.swal2-actions:not(.swal2-loading) .swal2-styled:hover{background-image:-webkit-gradient(linear,left top,left bottom,from(rgba(0,0,0,.1)),to(rgba(0,0,0,.1)));background-image:linear-gradient(rgba(0,0,0,.1),rgba(0,0,0,.1))}.swal2-actions:not(.swal2-loading) .swal2-styled:active{background-image:-webkit-gradient(linear,left top,left bottom,from(rgba(0,0,0,.2)),to(rgba(0,0,0,.2)));background-image:linear-gradient(rgba(0,0,0,.2),rgba(0,0,0,.2))}.swal2-actions.swal2-loading .swal2-styled.swal2-confirm{box-sizing:border-box;width:2.5em;height:2.5em;margin:.46875em;padding:0;-webkit-animation:swal2-rotate-loading 1.5s linear 0s infinite normal;animation:swal2-rotate-loading 1.5s linear 0s infinite normal;border:.25em solid transparent;border-radius:100%;border-color:transparent;background-color:transparent!important;color:transparent;cursor:default;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.swal2-actions.swal2-loading .swal2-styled.swal2-cancel{margin-right:30px;margin-left:30px}.swal2-actions.swal2-loading :not(.swal2-styled).swal2-confirm::after{content:"";display:inline-block;width:15px;height:15px;margin-left:5px;-webkit-animation:swal2-rotate-loading 1.5s linear 0s infinite normal;animation:swal2-rotate-loading 1.5s linear 0s infinite normal;border:3px solid #999;border-radius:50%;border-right-color:transparent;box-shadow:1px 1px 1px #fff}.swal2-styled{margin:.3125em;padding:.625em 2em;box-shadow:none;font-weight:500}.swal2-styled:not([disabled]){cursor:pointer}.swal2-styled.swal2-confirm{border:0;border-radius:.25em;background:initial;background-color:#3085d6;color:#fff;font-size:1.0625em}.swal2-styled.swal2-cancel{border:0;border-radius:.25em;background:initial;background-color:#aaa;color:#fff;font-size:1.0625em}.swal2-styled:focus{outline:0;box-shadow:0 0 0 1px #fff,0 0 0 3px rgba(50,100,150,.4)}.swal2-styled::-moz-focus-inner{border:0}.swal2-footer{-webkit-box-pack:center;justify-content:center;margin:1.25em 0 0;padding:1em 0 0;border-top:1px solid #eee;color:#545454;font-size:1em}.swal2-timer-progress-bar{position:absolute;bottom:0;left:0;width:100%;height:.25em;background:rgba(0,0,0,.2)}.swal2-image{max-width:100%;margin:1.25em auto}.swal2-close{position:absolute;z-index:2;top:0;right:0;-webkit-box-pack:center;justify-content:center;width:1.2em;height:1.2em;padding:0;overflow:hidden;-webkit-transition:color .1s ease-out;transition:color .1s ease-out;border:none;border-radius:0;outline:initial;background:0 0;color:#ccc;font-family:serif;font-size:2.5em;line-height:1.2;cursor:pointer}.swal2-close:hover{-webkit-transform:none;transform:none;background:0 0;color:#f27474}.swal2-close::-moz-focus-inner{border:0}.swal2-content{z-index:1;-webkit-box-pack:center;justify-content:center;margin:0;padding:0;color:#545454;font-size:1.125em;font-weight:400;line-height:normal;text-align:center;word-wrap:break-word}.swal2-checkbox,.swal2-file,.swal2-input,.swal2-radio,.swal2-select,.swal2-textarea{margin:1em auto}.swal2-file,.swal2-input,.swal2-textarea{box-sizing:border-box;width:100%;-webkit-transition:border-color .3s,box-shadow .3s;transition:border-color .3s,box-shadow .3s;border:1px solid #d9d9d9;border-radius:.1875em;background:inherit;box-shadow:inset 0 1px 1px rgba(0,0,0,.06);color:inherit;font-size:1.125em}.swal2-file.swal2-inputerror,.swal2-input.swal2-inputerror,.swal2-textarea.swal2-inputerror{border-color:#f27474!important;box-shadow:0 0 2px #f27474!important}.swal2-file:focus,.swal2-input:focus,.swal2-textarea:focus{border:1px solid #b4dbed;outline:0;box-shadow:0 0 3px #c4e6f5}.swal2-file::-webkit-input-placeholder,.swal2-input::-webkit-input-placeholder,.swal2-textarea::-webkit-input-placeholder{color:#ccc}.swal2-file::-moz-placeholder,.swal2-input::-moz-placeholder,.swal2-textarea::-moz-placeholder{color:#ccc}.swal2-file:-ms-input-placeholder,.swal2-input:-ms-input-placeholder,.swal2-textarea:-ms-input-placeholder{color:#ccc}.swal2-file::-ms-input-placeholder,.swal2-input::-ms-input-placeholder,.swal2-textarea::-ms-input-placeholder{color:#ccc}.swal2-file::placeholder,.swal2-input::placeholder,.swal2-textarea::placeholder{color:#ccc}.swal2-range{margin:1em auto;background:#fff}.swal2-range input{width:80%}.swal2-range output{width:20%;color:inherit;font-weight:600;text-align:center}.swal2-range input,.swal2-range output{height:2.625em;padding:0;font-size:1.125em;line-height:2.625em}.swal2-input{height:2.625em;padding:0 .75em}.swal2-input[type=number]{max-width:10em}.swal2-file{background:inherit;font-size:1.125em}.swal2-textarea{height:6.75em;padding:.75em}.swal2-select{min-width:50%;max-width:100%;padding:.375em .625em;background:inherit;color:inherit;font-size:1.125em}.swal2-checkbox,.swal2-radio{-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center;background:#fff;color:inherit}.swal2-checkbox label,.swal2-radio label{margin:0 .6em;font-size:1.125em}.swal2-checkbox input,.swal2-radio input{margin:0 .4em}.swal2-validation-message{display:none;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center;padding:.625em;overflow:hidden;background:#f0f0f0;color:#666;font-size:1em;font-weight:300}.swal2-validation-message::before{content:"!";display:inline-block;width:1.5em;min-width:1.5em;height:1.5em;margin:0 .625em;border-radius:50%;background-color:#f27474;color:#fff;font-weight:600;line-height:1.5em;text-align:center}.swal2-icon{position:relative;box-sizing:content-box;-webkit-box-pack:center;justify-content:center;width:5em;height:5em;margin:1.25em auto 1.875em;border:.25em solid transparent;border-radius:50%;font-family:inherit;line-height:5em;cursor:default;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.swal2-icon .swal2-icon-content{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;font-size:3.75em}.swal2-icon.swal2-error{border-color:#f27474;color:#f27474}.swal2-icon.swal2-error .swal2-x-mark{position:relative;-webkit-box-flex:1;flex-grow:1}.swal2-icon.swal2-error [class^=swal2-x-mark-line]{display:block;position:absolute;top:2.3125em;width:2.9375em;height:.3125em;border-radius:.125em;background-color:#f27474}.swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=left]{left:1.0625em;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=right]{right:1em;-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}.swal2-icon.swal2-error.swal2-icon-show{-webkit-animation:swal2-animate-error-icon .5s;animation:swal2-animate-error-icon .5s}.swal2-icon.swal2-error.swal2-icon-show .swal2-x-mark{-webkit-animation:swal2-animate-error-x-mark .5s;animation:swal2-animate-error-x-mark .5s}.swal2-icon.swal2-warning{border-color:#facea8;color:#f8bb86}.swal2-icon.swal2-info{border-color:#9de0f6;color:#3fc3ee}.swal2-icon.swal2-question{border-color:#c9dae1;color:#87adbd}.swal2-icon.swal2-success{border-color:#a5dc86;color:#a5dc86}.swal2-icon.swal2-success [class^=swal2-success-circular-line]{position:absolute;width:3.75em;height:7.5em;-webkit-transform:rotate(45deg);transform:rotate(45deg);border-radius:50%}.swal2-icon.swal2-success [class^=swal2-success-circular-line][class$=left]{top:-.4375em;left:-2.0635em;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);-webkit-transform-origin:3.75em 3.75em;transform-origin:3.75em 3.75em;border-radius:7.5em 0 0 7.5em}.swal2-icon.swal2-success [class^=swal2-success-circular-line][class$=right]{top:-.6875em;left:1.875em;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);-webkit-transform-origin:0 3.75em;transform-origin:0 3.75em;border-radius:0 7.5em 7.5em 0}.swal2-icon.swal2-success .swal2-success-ring{position:absolute;z-index:2;top:-.25em;left:-.25em;box-sizing:content-box;width:100%;height:100%;border:.25em solid rgba(165,220,134,.3);border-radius:50%}.swal2-icon.swal2-success .swal2-success-fix{position:absolute;z-index:1;top:.5em;left:1.625em;width:.4375em;height:5.625em;-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}.swal2-icon.swal2-success [class^=swal2-success-line]{display:block;position:absolute;z-index:2;height:.3125em;border-radius:.125em;background-color:#a5dc86}.swal2-icon.swal2-success [class^=swal2-success-line][class$=tip]{top:2.875em;left:.875em;width:1.5625em;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.swal2-icon.swal2-success [class^=swal2-success-line][class$=long]{top:2.375em;right:.5em;width:2.9375em;-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}.swal2-icon.swal2-success.swal2-icon-show .swal2-success-line-tip{-webkit-animation:swal2-animate-success-line-tip .75s;animation:swal2-animate-success-line-tip .75s}.swal2-icon.swal2-success.swal2-icon-show .swal2-success-line-long{-webkit-animation:swal2-animate-success-line-long .75s;animation:swal2-animate-success-line-long .75s}.swal2-icon.swal2-success.swal2-icon-show .swal2-success-circular-line-right{-webkit-animation:swal2-rotate-success-circular-line 4.25s ease-in;animation:swal2-rotate-success-circular-line 4.25s ease-in}.swal2-progress-steps{-webkit-box-align:center;align-items:center;margin:0 0 1.25em;padding:0;background:inherit;font-weight:600}.swal2-progress-steps li{display:inline-block;position:relative}.swal2-progress-steps .swal2-progress-step{z-index:20;width:2em;height:2em;border-radius:2em;background:#3085d6;color:#fff;line-height:2em;text-align:center}.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step{background:#3085d6}.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step{background:#add8e6;color:#fff}.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step-line{background:#add8e6}.swal2-progress-steps .swal2-progress-step-line{z-index:10;width:2.5em;height:.4em;margin:0 -1px;background:#3085d6}[class^=swal2]{-webkit-tap-highlight-color:transparent}.swal2-show{-webkit-animation:swal2-show .3s;animation:swal2-show .3s}.swal2-hide{-webkit-animation:swal2-hide .15s forwards;animation:swal2-hide .15s forwards}.swal2-noanimation{-webkit-transition:none;transition:none}.swal2-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}.swal2-rtl .swal2-close{right:auto;left:0}.swal2-rtl .swal2-timer-progress-bar{right:0;left:auto}@supports (-ms-accelerator:true){.swal2-range input{width:100%!important}.swal2-range output{display:none}}@media all and (-ms-high-contrast:none),(-ms-high-contrast:active){.swal2-range input{width:100%!important}.swal2-range output{display:none}}@-moz-document url-prefix(){.swal2-close:focus{outline:2px solid rgba(50,100,150,.4)}}@-webkit-keyframes swal2-toast-show{0%{-webkit-transform:translateY(-.625em) rotateZ(2deg);transform:translateY(-.625em) rotateZ(2deg)}33%{-webkit-transform:translateY(0) rotateZ(-2deg);transform:translateY(0) rotateZ(-2deg)}66%{-webkit-transform:translateY(.3125em) rotateZ(2deg);transform:translateY(.3125em) rotateZ(2deg)}100%{-webkit-transform:translateY(0) rotateZ(0);transform:translateY(0) rotateZ(0)}}@keyframes swal2-toast-show{0%{-webkit-transform:translateY(-.625em) rotateZ(2deg);transform:translateY(-.625em) rotateZ(2deg)}33%{-webkit-transform:translateY(0) rotateZ(-2deg);transform:translateY(0) rotateZ(-2deg)}66%{-webkit-transform:translateY(.3125em) rotateZ(2deg);transform:translateY(.3125em) rotateZ(2deg)}100%{-webkit-transform:translateY(0) rotateZ(0);transform:translateY(0) rotateZ(0)}}@-webkit-keyframes swal2-toast-hide{100%{-webkit-transform:rotateZ(1deg);transform:rotateZ(1deg);opacity:0}}@keyframes swal2-toast-hide{100%{-webkit-transform:rotateZ(1deg);transform:rotateZ(1deg);opacity:0}}@-webkit-keyframes swal2-toast-animate-success-line-tip{0%{top:.5625em;left:.0625em;width:0}54%{top:.125em;left:.125em;width:0}70%{top:.625em;left:-.25em;width:1.625em}84%{top:1.0625em;left:.75em;width:.5em}100%{top:1.125em;left:.1875em;width:.75em}}@keyframes swal2-toast-animate-success-line-tip{0%{top:.5625em;left:.0625em;width:0}54%{top:.125em;left:.125em;width:0}70%{top:.625em;left:-.25em;width:1.625em}84%{top:1.0625em;left:.75em;width:.5em}100%{top:1.125em;left:.1875em;width:.75em}}@-webkit-keyframes swal2-toast-animate-success-line-long{0%{top:1.625em;right:1.375em;width:0}65%{top:1.25em;right:.9375em;width:0}84%{top:.9375em;right:0;width:1.125em}100%{top:.9375em;right:.1875em;width:1.375em}}@keyframes swal2-toast-animate-success-line-long{0%{top:1.625em;right:1.375em;width:0}65%{top:1.25em;right:.9375em;width:0}84%{top:.9375em;right:0;width:1.125em}100%{top:.9375em;right:.1875em;width:1.375em}}@-webkit-keyframes swal2-show{0%{-webkit-transform:scale(.7);transform:scale(.7)}45%{-webkit-transform:scale(1.05);transform:scale(1.05)}80%{-webkit-transform:scale(.95);transform:scale(.95)}100%{-webkit-transform:scale(1);transform:scale(1)}}@keyframes swal2-show{0%{-webkit-transform:scale(.7);transform:scale(.7)}45%{-webkit-transform:scale(1.05);transform:scale(1.05)}80%{-webkit-transform:scale(.95);transform:scale(.95)}100%{-webkit-transform:scale(1);transform:scale(1)}}@-webkit-keyframes swal2-hide{0%{-webkit-transform:scale(1);transform:scale(1);opacity:1}100%{-webkit-transform:scale(.5);transform:scale(.5);opacity:0}}@keyframes swal2-hide{0%{-webkit-transform:scale(1);transform:scale(1);opacity:1}100%{-webkit-transform:scale(.5);transform:scale(.5);opacity:0}}@-webkit-keyframes swal2-animate-success-line-tip{0%{top:1.1875em;left:.0625em;width:0}54%{top:1.0625em;left:.125em;width:0}70%{top:2.1875em;left:-.375em;width:3.125em}84%{top:3em;left:1.3125em;width:1.0625em}100%{top:2.8125em;left:.875em;width:1.5625em}}@keyframes swal2-animate-success-line-tip{0%{top:1.1875em;left:.0625em;width:0}54%{top:1.0625em;left:.125em;width:0}70%{top:2.1875em;left:-.375em;width:3.125em}84%{top:3em;left:1.3125em;width:1.0625em}100%{top:2.8125em;left:.875em;width:1.5625em}}@-webkit-keyframes swal2-animate-success-line-long{0%{top:3.375em;right:2.875em;width:0}65%{top:3.375em;right:2.875em;width:0}84%{top:2.1875em;right:0;width:3.4375em}100%{top:2.375em;right:.5em;width:2.9375em}}@keyframes swal2-animate-success-line-long{0%{top:3.375em;right:2.875em;width:0}65%{top:3.375em;right:2.875em;width:0}84%{top:2.1875em;right:0;width:3.4375em}100%{top:2.375em;right:.5em;width:2.9375em}}@-webkit-keyframes swal2-rotate-success-circular-line{0%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}5%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}12%{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}100%{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}}@keyframes swal2-rotate-success-circular-line{0%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}5%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}12%{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}100%{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}}@-webkit-keyframes swal2-animate-error-x-mark{0%{margin-top:1.625em;-webkit-transform:scale(.4);transform:scale(.4);opacity:0}50%{margin-top:1.625em;-webkit-transform:scale(.4);transform:scale(.4);opacity:0}80%{margin-top:-.375em;-webkit-transform:scale(1.15);transform:scale(1.15)}100%{margin-top:0;-webkit-transform:scale(1);transform:scale(1);opacity:1}}@keyframes swal2-animate-error-x-mark{0%{margin-top:1.625em;-webkit-transform:scale(.4);transform:scale(.4);opacity:0}50%{margin-top:1.625em;-webkit-transform:scale(.4);transform:scale(.4);opacity:0}80%{margin-top:-.375em;-webkit-transform:scale(1.15);transform:scale(1.15)}100%{margin-top:0;-webkit-transform:scale(1);transform:scale(1);opacity:1}}@-webkit-keyframes swal2-animate-error-icon{0%{-webkit-transform:rotateX(100deg);transform:rotateX(100deg);opacity:0}100%{-webkit-transform:rotateX(0);transform:rotateX(0);opacity:1}}@keyframes swal2-animate-error-icon{0%{-webkit-transform:rotateX(100deg);transform:rotateX(100deg);opacity:0}100%{-webkit-transform:rotateX(0);transform:rotateX(0);opacity:1}}@-webkit-keyframes swal2-rotate-loading{0%{-webkit-transform:rotate(0);transform:rotate(0)}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes swal2-rotate-loading{0%{-webkit-transform:rotate(0);transform:rotate(0)}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown){overflow:hidden}body.swal2-height-auto{height:auto!important}body.swal2-no-backdrop .swal2-container{top:auto;right:auto;bottom:auto;left:auto;max-width:calc(100% - .625em * 2);background-color:transparent!important}body.swal2-no-backdrop .swal2-container>.swal2-modal{box-shadow:0 0 10px rgba(0,0,0,.4)}body.swal2-no-backdrop .swal2-container.swal2-top{top:0;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}body.swal2-no-backdrop .swal2-container.swal2-top-left,body.swal2-no-backdrop .swal2-container.swal2-top-start{top:0;left:0}body.swal2-no-backdrop .swal2-container.swal2-top-end,body.swal2-no-backdrop .swal2-container.swal2-top-right{top:0;right:0}body.swal2-no-backdrop .swal2-container.swal2-center{top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}body.swal2-no-backdrop .swal2-container.swal2-center-left,body.swal2-no-backdrop .swal2-container.swal2-center-start{top:50%;left:0;-webkit-transform:translateY(-50%);transform:translateY(-50%)}body.swal2-no-backdrop .swal2-container.swal2-center-end,body.swal2-no-backdrop .swal2-container.swal2-center-right{top:50%;right:0;-webkit-transform:translateY(-50%);transform:translateY(-50%)}body.swal2-no-backdrop .swal2-container.swal2-bottom{bottom:0;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}body.swal2-no-backdrop .swal2-container.swal2-bottom-left,body.swal2-no-backdrop .swal2-container.swal2-bottom-start{bottom:0;left:0}body.swal2-no-backdrop .swal2-container.swal2-bottom-end,body.swal2-no-backdrop .swal2-container.swal2-bottom-right{right:0;bottom:0}@media print{body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown){overflow-y:scroll!important}body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown)>[aria-hidden=true]{display:none}body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown) .swal2-container{position:static!important}}body.swal2-toast-shown .swal2-container{background-color:transparent}body.swal2-toast-shown .swal2-container.swal2-top{top:0;right:auto;bottom:auto;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-top-end,body.swal2-toast-shown .swal2-container.swal2-top-right{top:0;right:0;bottom:auto;left:auto}body.swal2-toast-shown .swal2-container.swal2-top-left,body.swal2-toast-shown .swal2-container.swal2-top-start{top:0;right:auto;bottom:auto;left:0}body.swal2-toast-shown .swal2-container.swal2-center-left,body.swal2-toast-shown .swal2-container.swal2-center-start{top:50%;right:auto;bottom:auto;left:0;-webkit-transform:translateY(-50%);transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-center{top:50%;right:auto;bottom:auto;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}body.swal2-toast-shown .swal2-container.swal2-center-end,body.swal2-toast-shown .swal2-container.swal2-center-right{top:50%;right:0;bottom:auto;left:auto;-webkit-transform:translateY(-50%);transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-left,body.swal2-toast-shown .swal2-container.swal2-bottom-start{top:auto;right:auto;bottom:0;left:0}body.swal2-toast-shown .swal2-container.swal2-bottom{top:auto;right:auto;bottom:0;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-end,body.swal2-toast-shown .swal2-container.swal2-bottom-right{top:auto;right:0;bottom:0;left:auto}body.swal2-toast-column .swal2-toast{-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;-webkit-box-align:stretch;align-items:stretch}body.swal2-toast-column .swal2-toast .swal2-actions{-webkit-box-flex:1;flex:1;align-self:stretch;height:2.2em;margin-top:.3125em}body.swal2-toast-column .swal2-toast .swal2-loading{-webkit-box-pack:center;justify-content:center}body.swal2-toast-column .swal2-toast .swal2-input{height:2em;margin:.3125em auto;font-size:1em}body.swal2-toast-column .swal2-toast .swal2-validation-message{font-size:1em}'
  );

/**
 * mustache.js
 */
(function (global, factory) {
  typeof exports === "object" && typeof module !== "undefined"
    ? (module.exports = factory())
    : typeof define === "function" && define.amd
    ? define(factory)
    : ((global = global || self), (global.Mustache = factory()));
})(this, function () {
  "use strict";
  var objectToString = Object.prototype.toString;
  var isArray =
    Array.isArray ||
    function isArrayPolyfill(object) {
      return objectToString.call(object) === "[object Array]";
    };
  function isFunction(object) {
    return typeof object === "function";
  }
  function typeStr(obj) {
    return isArray(obj) ? "array" : typeof obj;
  }
  function escapeRegExp(string) {
    return string.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
  }
  function hasProperty(obj, propName) {
    return obj != null && typeof obj === "object" && propName in obj;
  }
  function primitiveHasOwnProperty(primitive, propName) {
    return (
      primitive != null &&
      typeof primitive !== "object" &&
      primitive.hasOwnProperty &&
      primitive.hasOwnProperty(propName)
    );
  }
  var regExpTest = RegExp.prototype.test;
  function testRegExp(re, string) {
    return regExpTest.call(re, string);
  }
  var nonSpaceRe = /\S/;
  function isWhitespace(string) {
    return !testRegExp(nonSpaceRe, string);
  }
  var entityMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
    "/": "&#x2F;",
    "`": "&#x60;",
    "=": "&#x3D;",
  };
  function escapeHtml(string) {
    return String(string).replace(/[&<>"'`=\/]/g, function fromEntityMap(s) {
      return entityMap[s];
    });
  }
  var whiteRe = /\s*/;
  var spaceRe = /\s+/;
  var equalsRe = /\s*=/;
  var curlyRe = /\s*\}/;
  var tagRe = /#|\^|\/|>|\{|&|=|!/;
  function parseTemplate(template, tags) {
    if (!template) return [];
    var lineHasNonSpace = false;
    var sections = [];
    var tokens = [];
    var spaces = [];
    var hasTag = false;
    var nonSpace = false;
    var indentation = "";
    var tagIndex = 0;
    function stripSpace() {
      if (hasTag && !nonSpace) {
        while (spaces.length) delete tokens[spaces.pop()];
      } else {
        spaces = [];
      }
      hasTag = false;
      nonSpace = false;
    }
    var openingTagRe, closingTagRe, closingCurlyRe;
    function compileTags(tagsToCompile) {
      if (typeof tagsToCompile === "string")
        tagsToCompile = tagsToCompile.split(spaceRe, 2);
      if (!isArray(tagsToCompile) || tagsToCompile.length !== 2)
        throw new Error("Invalid tags: " + tagsToCompile);
      openingTagRe = new RegExp(escapeRegExp(tagsToCompile[0]) + "\\s*");
      closingTagRe = new RegExp("\\s*" + escapeRegExp(tagsToCompile[1]));
      closingCurlyRe = new RegExp(
        "\\s*" + escapeRegExp("}" + tagsToCompile[1])
      );
    }
    compileTags(tags || mustache.tags);
    var scanner = new Scanner(template);
    var start, type, value, chr, token, openSection;
    while (!scanner.eos()) {
      start = scanner.pos;
      value = scanner.scanUntil(openingTagRe);
      if (value) {
        for (var i = 0, valueLength = value.length; i < valueLength; ++i) {
          chr = value.charAt(i);
          if (isWhitespace(chr)) {
            spaces.push(tokens.length);
            indentation += chr;
          } else {
            nonSpace = true;
            lineHasNonSpace = true;
            indentation += " ";
          }
          tokens.push(["text", chr, start, start + 1]);
          start += 1;
          if (chr === "\n") {
            stripSpace();
            indentation = "";
            tagIndex = 0;
            lineHasNonSpace = false;
          }
        }
      }
      if (!scanner.scan(openingTagRe)) break;
      hasTag = true;
      type = scanner.scan(tagRe) || "name";
      scanner.scan(whiteRe);
      if (type === "=") {
        value = scanner.scanUntil(equalsRe);
        scanner.scan(equalsRe);
        scanner.scanUntil(closingTagRe);
      } else if (type === "{") {
        value = scanner.scanUntil(closingCurlyRe);
        scanner.scan(curlyRe);
        scanner.scanUntil(closingTagRe);
        type = "&";
      } else {
        value = scanner.scanUntil(closingTagRe);
      }
      if (!scanner.scan(closingTagRe))
        throw new Error("Unclosed tag at " + scanner.pos);
      if (type == ">") {
        token = [
          type,
          value,
          start,
          scanner.pos,
          indentation,
          tagIndex,
          lineHasNonSpace,
        ];
      } else {
        token = [type, value, start, scanner.pos];
      }
      tagIndex++;
      tokens.push(token);
      if (type === "#" || type === "^") {
        sections.push(token);
      } else if (type === "/") {
        openSection = sections.pop();
        if (!openSection)
          throw new Error('Unopened section "' + value + '" at ' + start);
        if (openSection[1] !== value)
          throw new Error(
            'Unclosed section "' + openSection[1] + '" at ' + start
          );
      } else if (type === "name" || type === "{" || type === "&") {
        nonSpace = true;
      } else if (type === "=") {
        compileTags(value);
      }
    }
    stripSpace();
    openSection = sections.pop();
    if (openSection)
      throw new Error(
        'Unclosed section "' + openSection[1] + '" at ' + scanner.pos
      );
    return nestTokens(squashTokens(tokens));
  }
  function squashTokens(tokens) {
    var squashedTokens = [];
    var token, lastToken;
    for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
      token = tokens[i];
      if (token) {
        if (token[0] === "text" && lastToken && lastToken[0] === "text") {
          lastToken[1] += token[1];
          lastToken[3] = token[3];
        } else {
          squashedTokens.push(token);
          lastToken = token;
        }
      }
    }
    return squashedTokens;
  }
  function nestTokens(tokens) {
    var nestedTokens = [];
    var collector = nestedTokens;
    var sections = [];
    var token, section;
    for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
      token = tokens[i];
      switch (token[0]) {
        case "#":
        case "^":
          collector.push(token);
          sections.push(token);
          collector = token[4] = [];
          break;
        case "/":
          section = sections.pop();
          section[5] = token[2];
          collector =
            sections.length > 0
              ? sections[sections.length - 1][4]
              : nestedTokens;
          break;
        default:
          collector.push(token);
      }
    }
    return nestedTokens;
  }
  function Scanner(string) {
    this.string = string;
    this.tail = string;
    this.pos = 0;
  }
  Scanner.prototype.eos = function eos() {
    return this.tail === "";
  };
  Scanner.prototype.scan = function scan(re) {
    var match = this.tail.match(re);
    if (!match || match.index !== 0) return "";
    var string = match[0];
    this.tail = this.tail.substring(string.length);
    this.pos += string.length;
    return string;
  };
  Scanner.prototype.scanUntil = function scanUntil(re) {
    var index = this.tail.search(re),
      match;
    switch (index) {
      case -1:
        match = this.tail;
        this.tail = "";
        break;
      case 0:
        match = "";
        break;
      default:
        match = this.tail.substring(0, index);
        this.tail = this.tail.substring(index);
    }
    this.pos += match.length;
    return match;
  };
  function Context(view, parentContext) {
    this.view = view;
    this.cache = { ".": this.view };
    this.parent = parentContext;
  }
  Context.prototype.push = function push(view) {
    return new Context(view, this);
  };
  Context.prototype.lookup = function lookup(name) {
    var cache = this.cache;
    var value;
    if (cache.hasOwnProperty(name)) {
      value = cache[name];
    } else {
      var context = this,
        intermediateValue,
        names,
        index,
        lookupHit = false;
      while (context) {
        if (name.indexOf(".") > 0) {
          intermediateValue = context.view;
          names = name.split(".");
          index = 0;
          while (intermediateValue != null && index < names.length) {
            if (index === names.length - 1)
              lookupHit =
                hasProperty(intermediateValue, names[index]) ||
                primitiveHasOwnProperty(intermediateValue, names[index]);
            intermediateValue = intermediateValue[names[index++]];
          }
        } else {
          intermediateValue = context.view[name];
          lookupHit = hasProperty(context.view, name);
        }
        if (lookupHit) {
          value = intermediateValue;
          break;
        }
        context = context.parent;
      }
      cache[name] = value;
    }
    if (isFunction(value)) value = value.call(this.view);
    return value;
  };
  function Writer() {
    this.cache = {};
  }
  Writer.prototype.clearCache = function clearCache() {
    this.cache = {};
  };
  Writer.prototype.parse = function parse(template, tags) {
    var cache = this.cache;
    var cacheKey = template + ":" + (tags || mustache.tags).join(":");
    var tokens = cache[cacheKey];
    if (tokens == null)
      tokens = cache[cacheKey] = parseTemplate(template, tags);
    return tokens;
  };
  Writer.prototype.render = function render(template, view, partials, tags) {
    var tokens = this.parse(template, tags);
    var context = view instanceof Context ? view : new Context(view, undefined);
    return this.renderTokens(tokens, context, partials, template, tags);
  };
  Writer.prototype.renderTokens = function renderTokens(
    tokens,
    context,
    partials,
    originalTemplate,
    tags
  ) {
    var buffer = "";
    var token, symbol, value;
    for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
      value = undefined;
      token = tokens[i];
      symbol = token[0];
      if (symbol === "#")
        value = this.renderSection(token, context, partials, originalTemplate);
      else if (symbol === "^")
        value = this.renderInverted(token, context, partials, originalTemplate);
      else if (symbol === ">")
        value = this.renderPartial(token, context, partials, tags);
      else if (symbol === "&") value = this.unescapedValue(token, context);
      else if (symbol === "name") value = this.escapedValue(token, context);
      else if (symbol === "text") value = this.rawValue(token);
      if (value !== undefined) buffer += value;
    }
    return buffer;
  };
  Writer.prototype.renderSection = function renderSection(
    token,
    context,
    partials,
    originalTemplate
  ) {
    var self = this;
    var buffer = "";
    var value = context.lookup(token[1]);
    function subRender(template) {
      return self.render(template, context, partials);
    }
    if (!value) return;
    if (isArray(value)) {
      for (var j = 0, valueLength = value.length; j < valueLength; ++j) {
        buffer += this.renderTokens(
          token[4],
          context.push(value[j]),
          partials,
          originalTemplate
        );
      }
    } else if (
      typeof value === "object" ||
      typeof value === "string" ||
      typeof value === "number"
    ) {
      buffer += this.renderTokens(
        token[4],
        context.push(value),
        partials,
        originalTemplate
      );
    } else if (isFunction(value)) {
      if (typeof originalTemplate !== "string")
        throw new Error(
          "Cannot use higher-order sections without the original template"
        );
      value = value.call(
        context.view,
        originalTemplate.slice(token[3], token[5]),
        subRender
      );
      if (value != null) buffer += value;
    } else {
      buffer += this.renderTokens(
        token[4],
        context,
        partials,
        originalTemplate
      );
    }
    return buffer;
  };
  Writer.prototype.renderInverted = function renderInverted(
    token,
    context,
    partials,
    originalTemplate
  ) {
    var value = context.lookup(token[1]);
    if (!value || (isArray(value) && value.length === 0))
      return this.renderTokens(token[4], context, partials, originalTemplate);
  };
  Writer.prototype.indentPartial = function indentPartial(
    partial,
    indentation,
    lineHasNonSpace
  ) {
    var filteredIndentation = indentation.replace(/[^ \t]/g, "");
    var partialByNl = partial.split("\n");
    for (var i = 0; i < partialByNl.length; i++) {
      if (partialByNl[i].length && (i > 0 || !lineHasNonSpace)) {
        partialByNl[i] = filteredIndentation + partialByNl[i];
      }
    }
    return partialByNl.join("\n");
  };
  Writer.prototype.renderPartial = function renderPartial(
    token,
    context,
    partials,
    tags
  ) {
    if (!partials) return;
    var value = isFunction(partials) ? partials(token[1]) : partials[token[1]];
    if (value != null) {
      var lineHasNonSpace = token[6];
      var tagIndex = token[5];
      var indentation = token[4];
      var indentedValue = value;
      if (tagIndex == 0 && indentation) {
        indentedValue = this.indentPartial(value, indentation, lineHasNonSpace);
      }
      return this.renderTokens(
        this.parse(indentedValue, tags),
        context,
        partials,
        indentedValue
      );
    }
  };
  Writer.prototype.unescapedValue = function unescapedValue(token, context) {
    var value = context.lookup(token[1]);
    if (value != null) return value;
  };
  Writer.prototype.escapedValue = function escapedValue(token, context) {
    var value = context.lookup(token[1]);
    if (value != null) return mustache.escape(value);
  };
  Writer.prototype.rawValue = function rawValue(token) {
    return token[1];
  };
  var mustache = {
    name: "mustache.js",
    version: "3.2.1",
    tags: ["{{", "}}"],
    clearCache: undefined,
    escape: undefined,
    parse: undefined,
    render: undefined,
    to_html: undefined,
    Scanner: undefined,
    Context: undefined,
    Writer: undefined,
  };
  var defaultWriter = new Writer();
  mustache.clearCache = function clearCache() {
    return defaultWriter.clearCache();
  };
  mustache.parse = function parse(template, tags) {
    return defaultWriter.parse(template, tags);
  };
  mustache.render = function render(template, view, partials, tags) {
    if (typeof template !== "string") {
      throw new TypeError(
        'Invalid template! Template should be a "string" ' +
          'but "' +
          typeStr(template) +
          '" was given as the first ' +
          "argument for mustache#render(template, view, partials)"
      );
    }
    return defaultWriter.render(template, view, partials, tags);
  };
  mustache.to_html = function to_html(template, view, partials, send) {
    var result = mustache.render(template, view, partials);
    if (isFunction(send)) {
      send(result);
    } else {
      return result;
    }
  };
  mustache.escape = escapeHtml;
  mustache.Scanner = Scanner;
  mustache.Context = Context;
  mustache.Writer = Writer;
  return mustache;
});
/* isInViewport.min.js */
!(function (e, n) {
  "object" == typeof exports && "undefined" != typeof module
    ? n(require("jquery"))
    : "function" == typeof define && define.amd
    ? define(["jquery"], n)
    : n(e.jQuery);
})(this, function (e) {
  "use strict";
  function n(n) {
    var t = this;
    if (
      (1 === arguments.length && "function" == typeof n && (n = [n]),
      !(n instanceof Array))
    )
      throw new SyntaxError(
        "isInViewport: Argument(s) passed to .do/.run should be a function or an array of functions"
      );
    return (
      n.forEach(function (n) {
        "function" != typeof n
          ? (console.warn(
              "isInViewport: Argument(s) passed to .do/.run should be a function or an array of functions"
            ),
            console.warn(
              "isInViewport: Ignoring non-function values in array and moving on"
            ))
          : [].slice.call(t).forEach(function (t) {
              return n.call(e(t));
            });
      }),
      this
    );
  }
  function t(n) {
    var t = e("<div></div>").css({ width: "100%" });
    n.append(t);
    var o = n.width() - t.width();
    return t.remove(), o;
  }
  function o(n, r) {
    var i = n.getBoundingClientRect(),
      a = i.top,
      u = i.bottom,
      c = i.left,
      f = i.right,
      s = e.extend({ tolerance: 0, viewport: window }, r),
      d = !1,
      l = s.viewport.jquery ? s.viewport : e(s.viewport);
    l.length ||
      (console.warn(
        "isInViewport: The viewport selector you have provided matches no element on page."
      ),
      console.warn("isInViewport: Defaulting to viewport as window"),
      (l = e(window)));
    var p = l.height(),
      w = l.width(),
      h = l[0].toString();
    if (
      l[0] !== window &&
      "[object Window]" !== h &&
      "[object DOMWindow]" !== h
    ) {
      var v = l[0].getBoundingClientRect();
      (a -= v.top),
        (u -= v.top),
        (c -= v.left),
        (f -= v.left),
        (o.scrollBarWidth = o.scrollBarWidth || t(l)),
        (w -= o.scrollBarWidth);
    }
    return (
      (s.tolerance = ~~Math.round(parseFloat(s.tolerance))),
      s.tolerance < 0 && (s.tolerance = p + s.tolerance),
      f <= 0 || c >= w
        ? d
        : (d = s.tolerance
            ? a <= s.tolerance && u >= s.tolerance
            : u > 0 && a <= p)
    );
  }
  function r(n) {
    if (n) {
      var t = n.split(",");
      return (
        1 === t.length && isNaN(t[0]) && ((t[1] = t[0]), (t[0] = void 0)),
        {
          tolerance: t[0] ? t[0].trim() : void 0,
          viewport: t[1] ? e(t[1].trim()) : void 0,
        }
      );
    }
    return {};
  }
  (e = e && e.hasOwnProperty("default") ? e.default : e)
  /**
   * @author  Mudit Ameta
   * @license https://github.com/zeusdeux/isInViewport/blob/master/license.md MIT
   */,
    e.extend(e.expr.pseudos || e.expr[":"], {
      "in-viewport": e.expr.createPseudo
        ? e.expr.createPseudo(function (e) {
            return function (n) {
              return o(n, r(e));
            };
          })
        : function (e, n, t) {
            return o(e, r(t[3]));
          },
    }),
    (e.fn.isInViewport = function (e) {
      return this.filter(function (n, t) {
        return o(t, e);
      });
    }),
    (e.fn.run = n);
});
//# sourceMappingURL=isInViewport.min.js.map
